var of = Object.defineProperty;
var af = (n, e, t) => e in n ? of(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var Kt = (n, e, t) => (af(n, typeof e != "symbol" ? e + "" : e, t), t);
import Dt, { createElement as sf, useReducer as lf, useRef as qt, useEffect as cf } from "react";
import "react-dom";
const uf = "nylas-web-elements", Hr = (
  /* nylas-web-elements */
  { allRenderFn: !0, appendChildSlotFix: !1, asyncLoading: !0, asyncQueue: !1, attachStyles: !0, cloneNodeFix: !1, cmpDidLoad: !0, cmpDidRender: !0, cmpDidUnload: !1, cmpDidUpdate: !0, cmpShouldUpdate: !1, cmpWillLoad: !0, cmpWillRender: !0, cmpWillUpdate: !0, connectedCallback: !0, constructableCSS: !0, cssAnnotations: !0, devTools: !1, disconnectedCallback: !0, element: !1, event: !0, experimentalScopedSlotChanges: !1, experimentalSlotFixes: !1, formAssociated: !0, hasRenderFn: !0, hostListener: !0, hostListenerTarget: !0, hostListenerTargetBody: !0, hostListenerTargetDocument: !0, hostListenerTargetParent: !1, hostListenerTargetWindow: !0, hotModuleReplacement: !1, hydrateClientSide: !1, hydrateServerSide: !1, hydratedAttribute: !1, hydratedClass: !0, initializeNextTick: !1, invisiblePrehydration: !0, isDebug: !1, isDev: !1, isTesting: !1, lazyLoad: !0, lifecycle: !0, lifecycleDOMEvents: !1, member: !0, method: !0, mode: !1, observeAttribute: !0, profile: !1, prop: !0, propBoolean: !0, propMutable: !0, propNumber: !0, propString: !0, reflect: !1, scoped: !0, scopedSlotTextContentFix: !1, scriptDataOpts: !1, shadowDelegatesFocus: !1, shadowDom: !0, slot: !0, slotChildNodesFix: !1, slotRelocation: !0, state: !0, style: !0, svg: !0, taskQueue: !0, transformTagName: !1, updatable: !0, vdomAttribute: !0, vdomClass: !0, vdomFunctional: !0, vdomKey: !0, vdomListener: !0, vdomPropOrAttr: !0, vdomRef: !0, vdomRender: !0, vdomStyle: !0, vdomText: !0, vdomXlink: !1, watchCallback: !0 }
);
let Qe, nn, Nt, Yr = !1, kt = !1, bn = !1, he = !1, rn = null, on = !1;
const _e = (n, e = "") => () => {
}, df = (n, e) => () => {
}, ff = "{visibility:hidden}.hydrated{visibility:inherit}", jr = "slot-fb{display:contents}slot-fb[hidden]{display:none}", hf = [
  "formAssociatedCallback",
  "formResetCallback",
  "formDisabledCallback",
  "formStateRestoreCallback"
], Wn = {}, gf = "http://www.w3.org/2000/svg", pf = "http://www.w3.org/1999/xhtml", mf = (n) => n != null, vn = (n) => (n = typeof n, n === "object" || n === "function");
function zr(n) {
  var e, t, r;
  return (r = (t = (e = n.head) === null || e === void 0 ? void 0 : e.querySelector('meta[name="csp-nonce"]')) === null || t === void 0 ? void 0 : t.getAttribute("content")) !== null && r !== void 0 ? r : void 0;
}
const Wr = (n, e, ...t) => {
  let r = null, i = null, o = null, a = !1, s = !1;
  const l = [], c = (f) => {
    for (let d = 0; d < f.length; d++)
      r = f[d], Array.isArray(r) ? c(r) : r != null && typeof r != "boolean" && ((a = typeof n != "function" && !vn(r)) && (r = String(r)), a && s ? l[l.length - 1].$text$ += r : l.push(a ? $t(null, r) : r), s = a);
  };
  if (c(t), e) {
    e.key && (i = e.key), e.name && (o = e.name);
    {
      const f = e.className || e.class;
      f && (e.class = typeof f != "object" ? f : Object.keys(f).filter((d) => f[d]).join(" "));
    }
  }
  if (typeof n == "function")
    return n(e === null ? {} : e, l, vf);
  const u = $t(n, null);
  return u.$attrs$ = e, l.length > 0 && (u.$children$ = l), u.$key$ = i, u.$name$ = o, u;
}, $t = (n, e) => {
  const t = {
    $flags$: 0,
    $tag$: n,
    $text$: e,
    $elm$: null,
    $children$: null
  };
  return t.$attrs$ = null, t.$key$ = null, t.$name$ = null, t;
}, yf = {}, bf = (n) => n && n.$tag$ === yf, vf = {
  forEach: (n, e) => n.map(Gn).forEach(e),
  map: (n, e) => n.map(Gn).map(e).map(Ef)
}, Gn = (n) => ({
  vattrs: n.$attrs$,
  vchildren: n.$children$,
  vkey: n.$key$,
  vname: n.$name$,
  vtag: n.$tag$,
  vtext: n.$text$
}), Ef = (n) => {
  if (typeof n.vtag == "function") {
    const t = Object.assign({}, n.vattrs);
    return n.vkey && (t.key = n.vkey), n.vname && (t.name = n.vname), Wr(n.vtag, t, ...n.vchildren || []);
  }
  const e = $t(n.vtag, n.vtext);
  return e.$attrs$ = n.vattrs, e.$children$ = n.vchildren, e.$key$ = n.vkey, e.$name$ = n.vname, e;
}, kf = (n, e) => n != null && !vn(n) ? e & 4 ? n === "false" ? !1 : n === "" || !!n : e & 2 ? parseFloat(n) : e & 1 ? String(n) : n : n, $f = (n) => Ie(n).$hostElement$, _p = (n, e, t) => {
  const r = $f(n);
  return {
    emit: (i) => Gr(r, e, {
      bubbles: !!(t & 4),
      composed: !!(t & 2),
      cancelable: !!(t & 1),
      detail: i
    })
  };
}, Gr = (n, e, t) => {
  const r = Z.ce(e, t);
  return n.dispatchEvent(r), r;
}, Kn = /* @__PURE__ */ new WeakMap(), wf = (n, e, t) => {
  let r = Tt.get(n);
  Vf && t ? (r = r || new CSSStyleSheet(), typeof r == "string" ? r = e : r.replaceSync(e)) : r = e, Tt.set(n, r);
}, Tf = (n, e, t) => {
  var r;
  const i = Kr(e), o = Tt.get(i);
  if (n = n.nodeType === 11 ? n : le, o)
    if (typeof o == "string") {
      n = n.head || n;
      let a = Kn.get(n), s;
      if (a || Kn.set(n, a = /* @__PURE__ */ new Set()), !a.has(i)) {
        {
          s = le.createElement("style"), s.innerHTML = o;
          const l = (r = Z.$nonce$) !== null && r !== void 0 ? r : zr(le);
          l != null && s.setAttribute("nonce", l), n.insertBefore(s, n.querySelector("link"));
        }
        e.$flags$ & 4 && (s.innerHTML += jr), a && a.add(i);
      }
    } else
      n.adoptedStyleSheets.includes(o) || (n.adoptedStyleSheets = [...n.adoptedStyleSheets, o]);
  return i;
}, Sf = (n) => {
  const e = n.$cmpMeta$, t = n.$hostElement$, r = e.$flags$, i = _e("attachStyles", e.$tagName$), o = Tf(t.shadowRoot ? t.shadowRoot : t.getRootNode(), e);
  r & 10 && (t["s-sc"] = o, t.classList.add(o + "-h"), r & 2 && t.classList.add(o + "-s")), i();
}, Kr = (n, e) => "sc-" + n.$tagName$, qn = (n, e, t, r, i, o) => {
  if (t !== r) {
    let a = tr(n, e), s = e.toLowerCase();
    if (e === "class") {
      const l = n.classList, c = Vn(t), u = Vn(r);
      l.remove(...c.filter((f) => f && !u.includes(f))), l.add(...u.filter((f) => f && !c.includes(f)));
    } else if (e === "style") {
      for (const l in t)
        (!r || r[l] == null) && (l.includes("-") ? n.style.removeProperty(l) : n.style[l] = "");
      for (const l in r)
        (!t || r[l] !== t[l]) && (l.includes("-") ? n.style.setProperty(l, r[l]) : n.style[l] = r[l]);
    } else if (e !== "key")
      if (e === "ref")
        r && r(n);
      else if (!a && e[0] === "o" && e[1] === "n") {
        if (e[2] === "-" ? e = e.slice(3) : tr(gt, s) ? e = s.slice(2) : e = s[2] + e.slice(3), t || r) {
          const l = e.endsWith(qr);
          e = e.replace(xf, ""), t && Z.rel(n, e, t, l), r && Z.ael(n, e, r, l);
        }
      } else {
        const l = vn(r);
        if ((a || l && r !== null) && !i)
          try {
            if (n.tagName.includes("-"))
              n[e] = r;
            else {
              const c = r ?? "";
              e === "list" ? a = !1 : (t == null || n[e] != c) && (n[e] = c);
            }
          } catch {
          }
        r == null || r === !1 ? (r !== !1 || n.getAttribute(e) === "") && n.removeAttribute(e) : (!a || o & 4 || i) && !l && (r = r === !0 ? "" : r, n.setAttribute(e, r));
      }
  }
}, Cf = /\s/, Vn = (n) => n ? n.split(Cf) : [], qr = "Capture", xf = new RegExp(qr + "$"), Vr = (n, e, t, r) => {
  const i = e.$elm$.nodeType === 11 && e.$elm$.host ? e.$elm$.host : e.$elm$, o = n && n.$attrs$ || Wn, a = e.$attrs$ || Wn;
  for (r in o)
    r in a || qn(i, r, o[r], void 0, t, e.$flags$);
  for (r in a)
    qn(i, r, o[r], a[r], t, e.$flags$);
}, wt = (n, e, t, r) => {
  const i = e.$children$[t];
  let o = 0, a, s, l;
  if (Yr || (bn = !0, i.$tag$ === "slot" && (Qe && r.classList.add(Qe + "-s"), i.$flags$ |= i.$children$ ? (
    // slot element has fallback content
    2
  ) : (
    // slot element does not have fallback content
    1
  ))), i.$text$ !== null)
    a = i.$elm$ = le.createTextNode(i.$text$);
  else if (i.$flags$ & 1)
    a = i.$elm$ = le.createTextNode("");
  else {
    if (he || (he = i.$tag$ === "svg"), a = i.$elm$ = le.createElementNS(he ? gf : pf, i.$flags$ & 2 ? "slot-fb" : i.$tag$), he && i.$tag$ === "foreignObject" && (he = !1), Vr(null, i, he), mf(Qe) && a["s-si"] !== Qe && a.classList.add(a["s-si"] = Qe), i.$children$)
      for (o = 0; o < i.$children$.length; ++o)
        s = wt(n, i, o, a), s && a.appendChild(s);
    i.$tag$ === "svg" ? he = !1 : a.tagName === "foreignObject" && (he = !0);
  }
  return a["s-hn"] = Nt, i.$flags$ & 3 && (a["s-sr"] = !0, a["s-cr"] = nn, a["s-sn"] = i.$name$ || "", l = n && n.$children$ && n.$children$[t], l && l.$tag$ === i.$tag$ && n.$elm$ && dt(n.$elm$, !1)), a;
}, dt = (n, e) => {
  Z.$flags$ |= 1;
  const t = n.childNodes;
  for (let r = t.length - 1; r >= 0; r--) {
    const i = t[r];
    i["s-hn"] !== Nt && i["s-ol"] && (Qr(i).insertBefore(i, En(i)), i["s-ol"].remove(), i["s-ol"] = void 0, i["s-sh"] = void 0, bn = !0), e && dt(i, e);
  }
  Z.$flags$ &= -2;
}, Jr = (n, e, t, r, i, o) => {
  let a = n["s-cr"] && n["s-cr"].parentNode || n, s;
  for (a.shadowRoot && a.tagName === Nt && (a = a.shadowRoot); i <= o; ++i)
    r[i] && (s = wt(null, t, i, n), s && (r[i].$elm$ = s, a.insertBefore(s, En(e))));
}, Zr = (n, e, t) => {
  for (let r = e; r <= t; ++r) {
    const i = n[r];
    if (i) {
      const o = i.$elm$;
      ti(i), o && (kt = !0, o["s-ol"] ? o["s-ol"].remove() : dt(o, !0), o.remove());
    }
  }
}, Bf = (n, e, t, r, i = !1) => {
  let o = 0, a = 0, s = 0, l = 0, c = e.length - 1, u = e[0], f = e[c], d = r.length - 1, g = r[0], p = r[d], y, b;
  for (; o <= c && a <= d; )
    if (u == null)
      u = e[++o];
    else if (f == null)
      f = e[--c];
    else if (g == null)
      g = r[++a];
    else if (p == null)
      p = r[--d];
    else if (bt(u, g, i))
      Xe(u, g, i), u = e[++o], g = r[++a];
    else if (bt(f, p, i))
      Xe(f, p, i), f = e[--c], p = r[--d];
    else if (bt(u, p, i))
      (u.$tag$ === "slot" || p.$tag$ === "slot") && dt(u.$elm$.parentNode, !1), Xe(u, p, i), n.insertBefore(u.$elm$, f.$elm$.nextSibling), u = e[++o], p = r[--d];
    else if (bt(f, g, i))
      (u.$tag$ === "slot" || p.$tag$ === "slot") && dt(f.$elm$.parentNode, !1), Xe(f, g, i), n.insertBefore(f.$elm$, u.$elm$), f = e[--c], g = r[++a];
    else {
      for (s = -1, l = o; l <= c; ++l)
        if (e[l] && e[l].$key$ !== null && e[l].$key$ === g.$key$) {
          s = l;
          break;
        }
      s >= 0 ? (b = e[s], b.$tag$ !== g.$tag$ ? y = wt(e && e[a], t, s, n) : (Xe(b, g, i), e[s] = void 0, y = b.$elm$), g = r[++a]) : (y = wt(e && e[a], t, a, n), g = r[++a]), y && Qr(u.$elm$).insertBefore(y, En(u.$elm$));
    }
  o > c ? Jr(n, r[d + 1] == null ? null : r[d + 1].$elm$, t, r, a, d) : a > d && Zr(e, o, c);
}, bt = (n, e, t = !1) => n.$tag$ === e.$tag$ ? n.$tag$ === "slot" ? n.$name$ === e.$name$ : t ? !0 : n.$key$ === e.$key$ : !1, En = (n) => n && n["s-ol"] || n, Qr = (n) => (n["s-ol"] ? n["s-ol"] : n).parentNode, Xe = (n, e, t = !1) => {
  const r = e.$elm$ = n.$elm$, i = n.$children$, o = e.$children$, a = e.$tag$, s = e.$text$;
  let l;
  s === null ? (he = a === "svg" ? !0 : a === "foreignObject" ? !1 : he, a === "slot" || Vr(n, e, he), i !== null && o !== null ? Bf(r, i, e, o, t) : o !== null ? (n.$text$ !== null && (r.textContent = ""), Jr(r, null, e, o, 0, o.length - 1)) : i !== null && Zr(i, 0, i.length - 1), he && a === "svg" && (he = !1)) : (l = r["s-cr"]) ? l.parentNode.textContent = s : n.$text$ !== s && (r.data = s);
}, Xr = (n) => {
  const e = n.childNodes;
  for (const t of e)
    if (t.nodeType === 1) {
      if (t["s-sr"]) {
        const r = t["s-sn"];
        t.hidden = !1;
        for (const i of e)
          if (i !== t) {
            if (i["s-hn"] !== t["s-hn"] || r !== "") {
              if (i.nodeType === 1 && (r === i.getAttribute("slot") || r === i["s-sn"])) {
                t.hidden = !0;
                break;
              }
            } else if (i.nodeType === 1 || i.nodeType === 3 && i.textContent.trim() !== "") {
              t.hidden = !0;
              break;
            }
          }
      }
      Xr(t);
    }
}, Fe = [], ei = (n) => {
  let e, t, r;
  for (const i of n.childNodes) {
    if (i["s-sr"] && (e = i["s-cr"]) && e.parentNode) {
      t = e.parentNode.childNodes;
      const o = i["s-sn"];
      for (r = t.length - 1; r >= 0; r--)
        if (e = t[r], !e["s-cn"] && !e["s-nr"] && e["s-hn"] !== i["s-hn"] && !Hr.experimentalSlotFixes)
          if (Jn(e, o)) {
            let a = Fe.find((s) => s.$nodeToRelocate$ === e);
            kt = !0, e["s-sn"] = e["s-sn"] || o, a ? (a.$nodeToRelocate$["s-sh"] = i["s-hn"], a.$slotRefNode$ = i) : (e["s-sh"] = i["s-hn"], Fe.push({
              $slotRefNode$: i,
              $nodeToRelocate$: e
            })), e["s-sr"] && Fe.map((s) => {
              Jn(s.$nodeToRelocate$, e["s-sn"]) && (a = Fe.find((l) => l.$nodeToRelocate$ === e), a && !s.$slotRefNode$ && (s.$slotRefNode$ = a.$slotRefNode$));
            });
          } else
            Fe.some((a) => a.$nodeToRelocate$ === e) || Fe.push({
              $nodeToRelocate$: e
            });
    }
    i.nodeType === 1 && ei(i);
  }
}, Jn = (n, e) => n.nodeType === 1 ? n.getAttribute("slot") === null && e === "" || n.getAttribute("slot") === e : n["s-sn"] === e ? !0 : e === "", ti = (n) => {
  n.$attrs$ && n.$attrs$.ref && n.$attrs$.ref(null), n.$children$ && n.$children$.map(ti);
}, If = (n, e, t = !1) => {
  var r, i, o, a;
  const s = n.$hostElement$, l = n.$cmpMeta$, c = n.$vnode$ || $t(null, null), u = bf(e) ? e : Wr(null, null, e);
  if (Nt = s.tagName, t && u.$attrs$)
    for (const f of Object.keys(u.$attrs$))
      s.hasAttribute(f) && !["key", "ref", "style", "class"].includes(f) && (u.$attrs$[f] = s[f]);
  u.$tag$ = null, u.$flags$ |= 4, n.$vnode$ = u, u.$elm$ = c.$elm$ = s.shadowRoot || s, Qe = s["s-sc"], nn = s["s-cr"], Yr = (l.$flags$ & 1) !== 0, kt = !1, Xe(c, u, t);
  {
    if (Z.$flags$ |= 1, bn) {
      ei(u.$elm$);
      for (const f of Fe) {
        const d = f.$nodeToRelocate$;
        if (!d["s-ol"]) {
          const g = le.createTextNode("");
          g["s-nr"] = d, d.parentNode.insertBefore(d["s-ol"] = g, d);
        }
      }
      for (const f of Fe) {
        const d = f.$nodeToRelocate$, g = f.$slotRefNode$;
        if (g) {
          const p = g.parentNode;
          let y = g.nextSibling;
          {
            let b = (r = d["s-ol"]) === null || r === void 0 ? void 0 : r.previousSibling;
            for (; b; ) {
              let k = (i = b["s-nr"]) !== null && i !== void 0 ? i : null;
              if (k && k["s-sn"] === d["s-sn"] && p === k.parentNode && (k = k.nextSibling, !k || !k["s-nr"])) {
                y = k;
                break;
              }
              b = b.previousSibling;
            }
          }
          (!y && p !== d.parentNode || d.nextSibling !== y) && d !== y && (!d["s-hn"] && d["s-ol"] && (d["s-hn"] = d["s-ol"].parentNode.nodeName), p.insertBefore(d, y), d.nodeType === 1 && (d.hidden = (o = d["s-ih"]) !== null && o !== void 0 ? o : !1));
        } else
          d.nodeType === 1 && (t && (d["s-ih"] = (a = d.hidden) !== null && a !== void 0 ? a : !1), d.hidden = !0);
      }
    }
    kt && Xr(u.$elm$), Z.$flags$ &= -2, Fe.length = 0;
  }
  nn = void 0;
}, ni = (n, e) => {
  e && !n.$onRenderResolve$ && e["s-p"] && e["s-p"].push(new Promise((t) => n.$onRenderResolve$ = t));
}, Ft = (n, e) => {
  if (n.$flags$ |= 16, n.$flags$ & 4) {
    n.$flags$ |= 512;
    return;
  }
  return ni(n, n.$ancestorComponent$), Zf(() => Rf(n, e));
}, Rf = (n, e) => {
  const t = _e("scheduleUpdate", n.$cmpMeta$.$tagName$), r = n.$lazyInstance$;
  let i;
  return e ? (n.$flags$ |= 256, n.$queuedListeners$ && (n.$queuedListeners$.map(([o, a]) => Le(r, o, a)), n.$queuedListeners$ = void 0), i = Le(r, "componentWillLoad")) : i = Le(r, "componentWillUpdate"), i = Zn(i, () => Le(r, "componentWillRender")), t(), Zn(i, () => Mf(n, r, e));
}, Zn = (n, e) => Af(n) ? n.then(e) : e(), Af = (n) => n instanceof Promise || n && n.then && typeof n.then == "function", Mf = async (n, e, t) => {
  var r;
  const i = n.$hostElement$, o = _e("update", n.$cmpMeta$.$tagName$), a = i["s-rc"];
  t && Sf(n);
  const s = _e("render", n.$cmpMeta$.$tagName$);
  Of(n, e, i, t), a && (a.map((l) => l()), i["s-rc"] = void 0), s(), o();
  {
    const l = (r = i["s-p"]) !== null && r !== void 0 ? r : [], c = () => Df(n);
    l.length === 0 ? c() : (Promise.all(l).then(c), n.$flags$ |= 4, l.length = 0);
  }
}, Of = (n, e, t, r) => {
  try {
    rn = e, e = e.render(), n.$flags$ &= -17, n.$flags$ |= 2, If(n, e, r);
  } catch (i) {
    R(i, n.$hostElement$);
  }
  return rn = null, null;
}, Qn = () => rn, Df = (n) => {
  const e = n.$cmpMeta$.$tagName$, t = n.$hostElement$, r = _e("postUpdate", e), i = n.$lazyInstance$, o = n.$ancestorComponent$;
  Le(i, "componentDidRender"), n.$flags$ & 64 ? (Le(i, "componentDidUpdate"), r()) : (n.$flags$ |= 64, ii(t), Le(i, "componentDidLoad"), r(), n.$onReadyResolve$(t), o || ri()), n.$onInstanceResolve$(t), n.$onRenderResolve$ && (n.$onRenderResolve$(), n.$onRenderResolve$ = void 0), n.$flags$ & 512 && $n(() => Ft(n, !1)), n.$flags$ &= -517;
}, Xn = (n) => {
  {
    const e = Ie(n), t = e.$hostElement$.isConnected;
    return t && (e.$flags$ & 18) === 2 && Ft(e, !1), t;
  }
}, ri = (n) => {
  ii(le.documentElement), $n(() => Gr(gt, "appload", { detail: { namespace: uf } }));
}, Le = (n, e, t) => {
  if (n && n[e])
    try {
      return n[e](t);
    } catch (r) {
      R(r);
    }
}, ii = (n) => n.classList.add("hydrated"), Nf = (n, e) => Ie(n).$instanceValues$.get(e), Ff = (n, e, t, r) => {
  const i = Ie(n), o = i.$hostElement$, a = i.$instanceValues$.get(e), s = i.$flags$, l = i.$lazyInstance$;
  t = kf(t, r.$members$[e][0]);
  const c = Number.isNaN(a) && Number.isNaN(t), u = t !== a && !c;
  if ((!(s & 8) || a === void 0) && u && (i.$instanceValues$.set(e, t), l)) {
    if (r.$watchers$ && s & 128) {
      const f = r.$watchers$[e];
      f && f.map((d) => {
        try {
          l[d](t, a, e);
        } catch (g) {
          R(g, o);
        }
      });
    }
    (s & 18) === 2 && Ft(i, !1);
  }
}, oi = (n, e, t) => {
  var r;
  const i = n.prototype;
  if (e.$flags$ & 64 && t & 1 && hf.forEach((o) => Object.defineProperty(i, o, {
    value(...a) {
      const s = Ie(this), l = s.$lazyInstance$;
      if (!l)
        s.$onReadyPromise$.then((c) => {
          const u = c[o];
          typeof u == "function" && u.call(c, ...a);
        });
      else {
        const c = l[o];
        typeof c == "function" && c.call(l, ...a);
      }
    }
  })), e.$members$) {
    n.watchers && (e.$watchers$ = n.watchers);
    const o = Object.entries(e.$members$);
    if (o.map(([a, [s]]) => {
      s & 31 || t & 2 && s & 32 ? Object.defineProperty(i, a, {
        get() {
          return Nf(this, a);
        },
        set(l) {
          Ff(this, a, l, e);
        },
        configurable: !0,
        enumerable: !0
      }) : t & 1 && s & 64 && Object.defineProperty(i, a, {
        value(...l) {
          var c;
          const u = Ie(this);
          return (c = u == null ? void 0 : u.$onInstancePromise$) === null || c === void 0 ? void 0 : c.then(() => {
            var f;
            return (f = u.$lazyInstance$) === null || f === void 0 ? void 0 : f[a](...l);
          });
        }
      });
    }), t & 1) {
      const a = /* @__PURE__ */ new Map();
      i.attributeChangedCallback = function(s, l, c) {
        Z.jmp(() => {
          var u;
          const f = a.get(s);
          if (this.hasOwnProperty(f))
            c = this[f], delete this[f];
          else {
            if (i.hasOwnProperty(f) && typeof this[f] == "number" && this[f] == c)
              return;
            if (f == null) {
              const d = Ie(this), g = d == null ? void 0 : d.$flags$;
              if (g && !(g & 8) && g & 128 && c !== l) {
                const p = d.$lazyInstance$, y = (u = e.$watchers$) === null || u === void 0 ? void 0 : u[s];
                y == null || y.forEach((b) => {
                  p[b] != null && p[b].call(p, c, l, s);
                });
              }
              return;
            }
          }
          this[f] = c === null && typeof this[f] == "boolean" ? !1 : c;
        });
      }, n.observedAttributes = Array.from(/* @__PURE__ */ new Set([
        ...Object.keys((r = e.$watchers$) !== null && r !== void 0 ? r : {}),
        ...o.filter(
          ([s, l]) => l[0] & 15
          /* MEMBER_FLAGS.HasAttribute */
        ).map(([s, l]) => {
          const c = l[1] || s;
          return a.set(c, s), c;
        })
      ]));
    }
  }
  return n;
}, Lf = async (n, e, t, r) => {
  let i;
  if (!(e.$flags$ & 32)) {
    e.$flags$ |= 32;
    {
      if (i = Gf(t), i.then) {
        const l = df();
        i = await i, l();
      }
      i.isProxied || (t.$watchers$ = i.watchers, oi(
        i,
        t,
        2
        /* PROXY_FLAGS.proxyState */
      ), i.isProxied = !0);
      const s = _e("createInstance", t.$tagName$);
      e.$flags$ |= 8;
      try {
        new i(e);
      } catch (l) {
        R(l);
      }
      e.$flags$ &= -9, e.$flags$ |= 128, s(), an(e.$lazyInstance$);
    }
    if (i.style) {
      let s = i.style;
      const l = Kr(t);
      if (!Tt.has(l)) {
        const c = _e("registerStyles", t.$tagName$);
        wf(l, s, !!(t.$flags$ & 1)), c();
      }
    }
  }
  const o = e.$ancestorComponent$, a = () => Ft(e, !0);
  o && o["s-rc"] ? o["s-rc"].push(a) : a();
}, an = (n) => {
  Le(n, "connectedCallback");
}, Pf = (n) => {
  if (!(Z.$flags$ & 1)) {
    const e = Ie(n), t = e.$cmpMeta$, r = _e("connectedCallback", t.$tagName$);
    if (e.$flags$ & 1)
      ai(n, e, t.$listeners$), e != null && e.$lazyInstance$ ? an(e.$lazyInstance$) : e != null && e.$onReadyPromise$ && e.$onReadyPromise$.then(() => an(e.$lazyInstance$));
    else {
      e.$flags$ |= 1, // TODO(STENCIL-854): Remove code related to legacy shadowDomShim field
      t.$flags$ & 12 && _f(n);
      {
        let i = n;
        for (; i = i.parentNode || i.host; )
          if (i["s-p"]) {
            ni(e, e.$ancestorComponent$ = i);
            break;
          }
      }
      t.$members$ && Object.entries(t.$members$).map(([i, [o]]) => {
        if (o & 31 && n.hasOwnProperty(i)) {
          const a = n[i];
          delete n[i], n[i] = a;
        }
      }), Lf(n, e, t);
    }
    r();
  }
}, _f = (n) => {
  const e = n["s-cr"] = le.createComment("");
  e["s-cn"] = !0, n.insertBefore(e, n.firstChild);
}, er = (n) => {
  Le(n, "disconnectedCallback");
}, Uf = async (n) => {
  if (!(Z.$flags$ & 1)) {
    const e = Ie(n);
    e.$rmListeners$ && (e.$rmListeners$.map((t) => t()), e.$rmListeners$ = void 0), e != null && e.$lazyInstance$ ? er(e.$lazyInstance$) : e != null && e.$onReadyPromise$ && e.$onReadyPromise$.then(() => er(e.$lazyInstance$));
  }
}, Hf = (n, e = {}) => {
  var t;
  const r = _e(), i = [], o = e.exclude || [], a = gt.customElements, s = le.head, l = /* @__PURE__ */ s.querySelector("meta[charset]"), c = /* @__PURE__ */ le.createElement("style"), u = [];
  let f, d = !0;
  Object.assign(Z, e), Z.$resourcesUrl$ = new URL(e.resourcesUrl || "./", le.baseURI).href;
  let g = !1;
  if (n.map((p) => {
    p[1].map((y) => {
      var b;
      const k = {
        $flags$: y[0],
        $tagName$: y[1],
        $members$: y[2],
        $listeners$: y[3]
      };
      k.$flags$ & 4 && (g = !0), k.$members$ = y[2], k.$listeners$ = y[3], k.$watchers$ = (b = y[4]) !== null && b !== void 0 ? b : {};
      const x = k.$tagName$, Q = class extends HTMLElement {
        // StencilLazyHost
        constructor(F) {
          super(F), F = this, Wf(F, k), k.$flags$ & 1 && F.attachShadow({ mode: "open" });
        }
        connectedCallback() {
          f && (clearTimeout(f), f = null), d ? u.push(this) : Z.jmp(() => Pf(this));
        }
        disconnectedCallback() {
          Z.jmp(() => Uf(this));
        }
        componentOnReady() {
          return Ie(this).$onReadyPromise$;
        }
      };
      k.$flags$ & 64 && (Q.formAssociated = !0), k.$lazyBundleId$ = p[0], !o.includes(x) && !a.get(x) && (i.push(x), a.define(x, oi(
        Q,
        k,
        1
        /* PROXY_FLAGS.isElementConstructor */
      )));
    });
  }), g && (c.innerHTML += jr), c.innerHTML += i + ff, c.innerHTML.length) {
    c.setAttribute("data-styles", "");
    const p = (t = Z.$nonce$) !== null && t !== void 0 ? t : zr(le);
    p != null && c.setAttribute("nonce", p), s.insertBefore(c, l ? l.nextSibling : s.firstChild);
  }
  d = !1, u.length ? u.map((p) => p.connectedCallback()) : Z.jmp(() => f = setTimeout(ri, 30)), r();
}, Up = (n, e) => e, ai = (n, e, t, r) => {
  t && t.map(([i, o, a]) => {
    const s = jf(n, i), l = Yf(e, a), c = zf(i);
    Z.ael(s, o, l, c), (e.$rmListeners$ = e.$rmListeners$ || []).push(() => Z.rel(s, o, l, c));
  });
}, Yf = (n, e) => (t) => {
  try {
    n.$flags$ & 256 ? n.$lazyInstance$[e](t) : (n.$queuedListeners$ = n.$queuedListeners$ || []).push([e, t]);
  } catch (r) {
    R(r);
  }
}, jf = (n, e) => e & 4 ? le : e & 8 ? gt : e & 16 ? le.body : n, zf = (n) => Kf ? {
  passive: (n & 1) !== 0,
  capture: (n & 2) !== 0
} : (n & 2) !== 0, Hp = (n) => Z.$nonce$ = n, kn = /* @__PURE__ */ new WeakMap(), Ie = (n) => kn.get(n), Yp = (n, e) => kn.set(e.$lazyInstance$ = n, e), Wf = (n, e) => {
  const t = {
    $flags$: 0,
    $hostElement$: n,
    $cmpMeta$: e,
    $instanceValues$: /* @__PURE__ */ new Map()
  };
  return t.$onInstancePromise$ = new Promise((r) => t.$onInstanceResolve$ = r), t.$onReadyPromise$ = new Promise((r) => t.$onReadyResolve$ = r), n["s-p"] = [], n["s-rc"] = [], ai(n, t, e.$listeners$), kn.set(n, t);
}, tr = (n, e) => e in n, R = (n, e) => (0, console.error)(n, e), Vt = /* @__PURE__ */ new Map(), Gf = (n, e, t) => {
  const r = n.$tagName$.replace(/-/g, "_"), i = n.$lazyBundleId$, o = Vt.get(i);
  if (o)
    return o[r];
  if (!t || !Hr.hotModuleReplacement) {
    const a = (s) => (Vt.set(i, s), s[r]);
    switch (i) {
      case "checkmark-icon":
        return import(
          /* webpackMode: "lazy" */
          "./checkmark-icon.entry-0749b942.js"
        ).then(a, R);
      case "document-refresh-icon":
        return import(
          /* webpackMode: "lazy" */
          "./document-refresh-icon.entry-6dd65cb6.js"
        ).then(a, R);
      case "nylas-custom-booking-flow":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-custom-booking-flow.entry-0e16973b.js"
        ).then(a, R);
      case "nylas-if-state":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-if-state.entry-93935670.js"
        ).then(a, R);
      case "nylas-list-folders":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-list-folders.entry-14fc1fe8.js"
        ).then(a, R);
      case "nylas-list-threads":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-list-threads.entry-2118b146.js"
        ).then(a, R);
      case "nylas-login":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-login.entry-87a902d6.js"
        ).then(a, R);
      case "nylas-mailbox":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-mailbox.entry-179e5a5c.js"
        ).then(a, R);
      case "nylas-mailbox-pagination":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-mailbox-pagination.entry-eedbf796.js"
        ).then(a, R);
      case "nylas-mailbox-toolbar-button":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-mailbox-toolbar-button.entry-40b75810.js"
        ).then(a, R);
      case "nylas-provider":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-provider.entry-7b70bbdc.js"
        ).then(a, R);
      case "nylas-scheduler-editor":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-scheduler-editor.entry-f1f80de1.js"
        ).then(a, R);
      case "nylas-scheduling":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-scheduling.entry-31d13205.js"
        ).then(a, R);
      case "nylas-threads-refresh":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-threads-refresh.entry-a3ea46aa.js"
        ).then(a, R);
      case "nylas-threads-search":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-threads-search.entry-01482ddf.js"
        ).then(a, R);
      case "nylas-view-thread":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-view-thread.entry-cb057b9e.js"
        ).then(a, R);
      case "archive-icon_7":
        return import(
          /* webpackMode: "lazy" */
          "./archive-icon_7.entry-3830776a.js"
        ).then(a, R);
      case "arrow-icon":
        return import(
          /* webpackMode: "lazy" */
          "./arrow-icon.entry-19f00716.js"
        ).then(a, R);
      case "forward-icon_6":
        return import(
          /* webpackMode: "lazy" */
          "./forward-icon_6.entry-acdf04ad.js"
        ).then(a, R);
      case "google-logo-icon_4":
        return import(
          /* webpackMode: "lazy" */
          "./google-logo-icon_4.entry-eae19fc8.js"
        ).then(a, R);
      case "nylas-booked-event-card_10":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-booked-event-card_10.entry-9487941d.js"
        ).then(a, R);
      case "bold-icon_3":
        return import(
          /* webpackMode: "lazy" */
          "./bold-icon_3.entry-80abafbb.js"
        ).then(a, R);
      case "calendar-agenda-fill-icon_40":
        return import(
          /* webpackMode: "lazy" */
          "./calendar-agenda-fill-icon_40.entry-f19d6ad7.js"
        ).then(a, R);
      case "calendar-check-icon_2":
        return import(
          /* webpackMode: "lazy" */
          "./calendar-check-icon_2.entry-159c38af.js"
        ).then(a, R);
      case "copy-icon_3":
        return import(
          /* webpackMode: "lazy" */
          "./copy-icon_3.entry-7b276fa2.js"
        ).then(a, R);
      case "person-icon":
        return import(
          /* webpackMode: "lazy" */
          "./person-icon.entry-3e30c63c.js"
        ).then(a, R);
      case "play-icon_2":
        return import(
          /* webpackMode: "lazy" */
          "./play-icon_2.entry-71eaad5c.js"
        ).then(a, R);
      case "refresh-icon":
        return import(
          /* webpackMode: "lazy" */
          "./refresh-icon.entry-db85d14d.js"
        ).then(a, R);
      case "textarea-component":
        return import(
          /* webpackMode: "lazy" */
          "./textarea-component.entry-f5f402a1.js"
        ).then(a, R);
      case "translate-icon":
        return import(
          /* webpackMode: "lazy" */
          "./translate-icon.entry-b91a0449.js"
        ).then(a, R);
      case "warning-icon":
        return import(
          /* webpackMode: "lazy" */
          "./warning-icon.entry-acdc811b.js"
        ).then(a, R);
      case "calendar-cancel-icon":
        return import(
          /* webpackMode: "lazy" */
          "./calendar-cancel-icon.entry-1fae00c5.js"
        ).then(a, R);
      case "calendar-icon":
        return import(
          /* webpackMode: "lazy" */
          "./calendar-icon.entry-3af9cb76.js"
        ).then(a, R);
      case "multi-select-dropdown":
        return import(
          /* webpackMode: "lazy" */
          "./multi-select-dropdown.entry-8e14e9af.js"
        ).then(a, R);
      case "nylas-time-window-picker":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-time-window-picker.entry-5f063b2b.js"
        ).then(a, R);
      case "clock-icon_4":
        return import(
          /* webpackMode: "lazy" */
          "./clock-icon_4.entry-9395d0cb.js"
        ).then(a, R);
      case "checkbox-component_2":
        return import(
          /* webpackMode: "lazy" */
          "./checkbox-component_2.entry-5eee51f6.js"
        ).then(a, R);
      case "nylas-form-card":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-form-card.entry-ccfa5692.js"
        ).then(a, R);
      case "time-period-selector":
        return import(
          /* webpackMode: "lazy" */
          "./time-period-selector.entry-d1a8470b.js"
        ).then(a, R);
      case "loading-icon":
        return import(
          /* webpackMode: "lazy" */
          "./loading-icon.entry-fc9bc740.js"
        ).then(a, R);
      case "button-component":
        return import(
          /* webpackMode: "lazy" */
          "./button-component.entry-36137536.js"
        ).then(a, R);
      case "add-circle-icon_2":
        return import(
          /* webpackMode: "lazy" */
          "./add-circle-icon_2.entry-b8d6df60.js"
        ).then(a, R);
      case "globe-icon":
        return import(
          /* webpackMode: "lazy" */
          "./globe-icon.entry-389c0391.js"
        ).then(a, R);
      case "input-dropdown":
        return import(
          /* webpackMode: "lazy" */
          "./input-dropdown.entry-4d29246a.js"
        ).then(a, R);
      case "close-icon":
        return import(
          /* webpackMode: "lazy" */
          "./close-icon.entry-cf9f0a69.js"
        ).then(a, R);
      case "info-icon_2":
        return import(
          /* webpackMode: "lazy" */
          "./info-icon_2.entry-97d75550.js"
        ).then(a, R);
      case "chevron-icon_3":
        return import(
          /* webpackMode: "lazy" */
          "./chevron-icon_3.entry-2e9eebbc.js"
        ).then(a, R);
    }
  }
  return import(
    /* @vite-ignore */
    /* webpackInclude: /\.entry\.js$/ */
    /* webpackExclude: /\.system\.entry\.js$/ */
    /* webpackMode: "lazy" */
    `./${i}.entry.js`
  ).then((a) => (Vt.set(i, a), a[r]), R);
}, Tt = /* @__PURE__ */ new Map(), gt = typeof window < "u" ? window : {}, le = gt.document || { head: {} }, Z = {
  $flags$: 0,
  $resourcesUrl$: "",
  jmp: (n) => n(),
  raf: (n) => requestAnimationFrame(n),
  ael: (n, e, t, r) => n.addEventListener(e, t, r),
  rel: (n, e, t, r) => n.removeEventListener(e, t, r),
  ce: (n, e) => new CustomEvent(n, e)
}, Kf = /* @__PURE__ */ (() => {
  let n = !1;
  try {
    le.addEventListener("e", null, Object.defineProperty({}, "passive", {
      get() {
        n = !0;
      }
    }));
  } catch {
  }
  return n;
})(), qf = (n) => Promise.resolve(n), Vf = /* @__PURE__ */ (() => {
  try {
    return new CSSStyleSheet(), typeof new CSSStyleSheet().replaceSync == "function";
  } catch {
  }
  return !1;
})(), nr = [], si = [], Jf = (n, e) => (t) => {
  n.push(t), on || (on = !0, e && Z.$flags$ & 4 ? $n(sn) : Z.raf(sn));
}, rr = (n) => {
  for (let e = 0; e < n.length; e++)
    try {
      n[e](performance.now());
    } catch (t) {
      R(t);
    }
  n.length = 0;
}, sn = () => {
  rr(nr), rr(si), (on = nr.length > 0) && Z.raf(sn);
}, $n = (n) => qf().then(n), Zf = /* @__PURE__ */ Jf(si, !0), Qf = (n, e, t) => {
  const r = n.get(e);
  r ? r.includes(t) || r.push(t) : n.set(e, [t]);
}, Xf = (n, e) => {
  let t;
  return (...r) => {
    t && clearTimeout(t), t = setTimeout(() => {
      t = 0, n(...r);
    }, e);
  };
}, eh = (n) => !("isConnected" in n) || n.isConnected, ir = Xf((n) => {
  for (let e of n.keys())
    n.set(e, n.get(e).filter(eh));
}, 2e3), th = () => {
  if (typeof Qn != "function")
    return {};
  const n = /* @__PURE__ */ new Map();
  return {
    dispose: () => n.clear(),
    get: (e) => {
      const t = Qn();
      t && Qf(n, e, t);
    },
    set: (e) => {
      const t = n.get(e);
      t && n.set(e, t.filter(Xn)), ir(n);
    },
    reset: () => {
      n.forEach((e) => e.forEach(Xn)), ir(n);
    }
  };
}, Jt = (n) => typeof n == "function" ? n() : n, nh = (n, e = (t, r) => t !== r) => {
  const t = Jt(n);
  let r = new Map(Object.entries(t ?? {}));
  const i = {
    dispose: [],
    get: [],
    set: [],
    reset: []
  }, o = () => {
    var p;
    r = new Map(Object.entries((p = Jt(n)) !== null && p !== void 0 ? p : {})), i.reset.forEach((y) => y());
  }, a = () => {
    i.dispose.forEach((p) => p()), o();
  }, s = (p) => (i.get.forEach((y) => y(p)), r.get(p)), l = (p, y) => {
    const b = r.get(p);
    e(y, b, p) && (r.set(p, y), i.set.forEach((k) => k(p, y, b)));
  }, c = typeof Proxy > "u" ? {} : new Proxy(t, {
    get(p, y) {
      return s(y);
    },
    ownKeys(p) {
      return Array.from(r.keys());
    },
    getOwnPropertyDescriptor() {
      return {
        enumerable: !0,
        configurable: !0
      };
    },
    has(p, y) {
      return r.has(y);
    },
    set(p, y, b) {
      return l(y, b), !0;
    }
  }), u = (p, y) => (i[p].push(y), () => {
    rh(i[p], y);
  });
  return {
    state: c,
    get: s,
    set: l,
    on: u,
    onChange: (p, y) => {
      const b = u("set", (x, Q) => {
        x === p && y(Q);
      }), k = u("reset", () => y(Jt(n)[p]));
      return () => {
        b(), k();
      };
    },
    use: (...p) => {
      const y = p.reduce((b, k) => (k.set && b.push(u("set", k.set)), k.get && b.push(u("get", k.get)), k.reset && b.push(u("reset", k.reset)), k.dispose && b.push(u("dispose", k.dispose)), b), []);
      return () => y.forEach((b) => b());
    },
    dispose: a,
    reset: o,
    forceUpdate: (p) => {
      const y = r.get(p);
      i.set.forEach((b) => b(p, y, y));
    }
  };
}, rh = (n, e) => {
  const t = n.indexOf(e);
  t >= 0 && (n[t] = n[n.length - 1], n.length--);
}, ih = (n, e) => {
  const t = nh(n, e);
  return t.use(th()), t;
}, or = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {};
var xe = [], be = [], oh = typeof Uint8Array < "u" ? Uint8Array : Array, wn = !1;
function li() {
  wn = !0;
  for (var n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = 0, t = n.length; e < t; ++e)
    xe[e] = n[e], be[n.charCodeAt(e)] = e;
  be["-".charCodeAt(0)] = 62, be["_".charCodeAt(0)] = 63;
}
function ah(n) {
  wn || li();
  var e, t, r, i, o, a, s = n.length;
  if (s % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  o = n[s - 2] === "=" ? 2 : n[s - 1] === "=" ? 1 : 0, a = new oh(s * 3 / 4 - o), r = o > 0 ? s - 4 : s;
  var l = 0;
  for (e = 0, t = 0; e < r; e += 4, t += 3)
    i = be[n.charCodeAt(e)] << 18 | be[n.charCodeAt(e + 1)] << 12 | be[n.charCodeAt(e + 2)] << 6 | be[n.charCodeAt(e + 3)], a[l++] = i >> 16 & 255, a[l++] = i >> 8 & 255, a[l++] = i & 255;
  return o === 2 ? (i = be[n.charCodeAt(e)] << 2 | be[n.charCodeAt(e + 1)] >> 4, a[l++] = i & 255) : o === 1 && (i = be[n.charCodeAt(e)] << 10 | be[n.charCodeAt(e + 1)] << 4 | be[n.charCodeAt(e + 2)] >> 2, a[l++] = i >> 8 & 255, a[l++] = i & 255), a;
}
function sh(n) {
  return xe[n >> 18 & 63] + xe[n >> 12 & 63] + xe[n >> 6 & 63] + xe[n & 63];
}
function lh(n, e, t) {
  for (var r, i = [], o = e; o < t; o += 3)
    r = (n[o] << 16) + (n[o + 1] << 8) + n[o + 2], i.push(sh(r));
  return i.join("");
}
function ar(n) {
  wn || li();
  for (var e, t = n.length, r = t % 3, i = "", o = [], a = 16383, s = 0, l = t - r; s < l; s += a)
    o.push(lh(n, s, s + a > l ? l : s + a));
  return r === 1 ? (e = n[t - 1], i += xe[e >> 2], i += xe[e << 4 & 63], i += "==") : r === 2 && (e = (n[t - 2] << 8) + n[t - 1], i += xe[e >> 10], i += xe[e >> 4 & 63], i += xe[e << 2 & 63], i += "="), o.push(i), o.join("");
}
function Lt(n, e, t, r, i) {
  var o, a, s = i * 8 - r - 1, l = (1 << s) - 1, c = l >> 1, u = -7, f = t ? i - 1 : 0, d = t ? -1 : 1, g = n[e + f];
  for (f += d, o = g & (1 << -u) - 1, g >>= -u, u += s; u > 0; o = o * 256 + n[e + f], f += d, u -= 8)
    ;
  for (a = o & (1 << -u) - 1, o >>= -u, u += r; u > 0; a = a * 256 + n[e + f], f += d, u -= 8)
    ;
  if (o === 0)
    o = 1 - c;
  else {
    if (o === l)
      return a ? NaN : (g ? -1 : 1) * (1 / 0);
    a = a + Math.pow(2, r), o = o - c;
  }
  return (g ? -1 : 1) * a * Math.pow(2, o - r);
}
function ci(n, e, t, r, i, o) {
  var a, s, l, c = o * 8 - i - 1, u = (1 << c) - 1, f = u >> 1, d = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, g = r ? 0 : o - 1, p = r ? 1 : -1, y = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, a = u) : (a = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -a)) < 1 && (a--, l *= 2), a + f >= 1 ? e += d / l : e += d * Math.pow(2, 1 - f), e * l >= 2 && (a++, l /= 2), a + f >= u ? (s = 0, a = u) : a + f >= 1 ? (s = (e * l - 1) * Math.pow(2, i), a = a + f) : (s = e * Math.pow(2, f - 1) * Math.pow(2, i), a = 0)); i >= 8; n[t + g] = s & 255, g += p, s /= 256, i -= 8)
    ;
  for (a = a << i | s, c += i; c > 0; n[t + g] = a & 255, g += p, a /= 256, c -= 8)
    ;
  n[t + g - p] |= y * 128;
}
var ch = {}.toString, ui = Array.isArray || function(n) {
  return ch.call(n) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var uh = 50;
v.TYPED_ARRAY_SUPPORT = or.TYPED_ARRAY_SUPPORT !== void 0 ? or.TYPED_ARRAY_SUPPORT : !0;
function ln() {
  return v.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function Pe(n, e) {
  if (ln() < e)
    throw new RangeError("Invalid typed array length");
  return v.TYPED_ARRAY_SUPPORT ? (n = new Uint8Array(e), n.__proto__ = v.prototype) : (n === null && (n = new v(e)), n.length = e), n;
}
function v(n, e, t) {
  if (!v.TYPED_ARRAY_SUPPORT && !(this instanceof v))
    return new v(n, e, t);
  if (typeof n == "number") {
    if (typeof e == "string")
      throw new Error(
        "If encoding is specified then the first argument must be a string"
      );
    return Tn(this, n);
  }
  return di(this, n, e, t);
}
v.poolSize = 8192;
v._augment = function(n) {
  return n.__proto__ = v.prototype, n;
};
function di(n, e, t, r) {
  if (typeof e == "number")
    throw new TypeError('"value" argument must not be a number');
  return typeof ArrayBuffer < "u" && e instanceof ArrayBuffer ? hh(n, e, t, r) : typeof e == "string" ? fh(n, e, t) : gh(n, e);
}
v.from = function(n, e, t) {
  return di(null, n, e, t);
};
v.TYPED_ARRAY_SUPPORT && (v.prototype.__proto__ = Uint8Array.prototype, v.__proto__ = Uint8Array);
function fi(n) {
  if (typeof n != "number")
    throw new TypeError('"size" argument must be a number');
  if (n < 0)
    throw new RangeError('"size" argument must not be negative');
}
function dh(n, e, t, r) {
  return fi(e), e <= 0 ? Pe(n, e) : t !== void 0 ? typeof r == "string" ? Pe(n, e).fill(t, r) : Pe(n, e).fill(t) : Pe(n, e);
}
v.alloc = function(n, e, t) {
  return dh(null, n, e, t);
};
function Tn(n, e) {
  if (fi(e), n = Pe(n, e < 0 ? 0 : Sn(e) | 0), !v.TYPED_ARRAY_SUPPORT)
    for (var t = 0; t < e; ++t)
      n[t] = 0;
  return n;
}
v.allocUnsafe = function(n) {
  return Tn(null, n);
};
v.allocUnsafeSlow = function(n) {
  return Tn(null, n);
};
function fh(n, e, t) {
  if ((typeof t != "string" || t === "") && (t = "utf8"), !v.isEncoding(t))
    throw new TypeError('"encoding" must be a valid string encoding');
  var r = hi(e, t) | 0;
  n = Pe(n, r);
  var i = n.write(e, t);
  return i !== r && (n = n.slice(0, i)), n;
}
function cn(n, e) {
  var t = e.length < 0 ? 0 : Sn(e.length) | 0;
  n = Pe(n, t);
  for (var r = 0; r < t; r += 1)
    n[r] = e[r] & 255;
  return n;
}
function hh(n, e, t, r) {
  if (t < 0 || e.byteLength < t)
    throw new RangeError("'offset' is out of bounds");
  if (e.byteLength < t + (r || 0))
    throw new RangeError("'length' is out of bounds");
  return t === void 0 && r === void 0 ? e = new Uint8Array(e) : r === void 0 ? e = new Uint8Array(e, t) : e = new Uint8Array(e, t, r), v.TYPED_ARRAY_SUPPORT ? (n = e, n.__proto__ = v.prototype) : n = cn(n, e), n;
}
function gh(n, e) {
  if (Re(e)) {
    var t = Sn(e.length) | 0;
    return n = Pe(n, t), n.length === 0 || e.copy(n, 0, 0, t), n;
  }
  if (e) {
    if (typeof ArrayBuffer < "u" && e.buffer instanceof ArrayBuffer || "length" in e)
      return typeof e.length != "number" || Oh(e.length) ? Pe(n, 0) : cn(n, e);
    if (e.type === "Buffer" && ui(e.data))
      return cn(n, e.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function Sn(n) {
  if (n >= ln())
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + ln().toString(16) + " bytes");
  return n | 0;
}
v.isBuffer = Dh;
function Re(n) {
  return !!(n != null && n._isBuffer);
}
v.compare = function(e, t) {
  if (!Re(e) || !Re(t))
    throw new TypeError("Arguments must be Buffers");
  if (e === t)
    return 0;
  for (var r = e.length, i = t.length, o = 0, a = Math.min(r, i); o < a; ++o)
    if (e[o] !== t[o]) {
      r = e[o], i = t[o];
      break;
    }
  return r < i ? -1 : i < r ? 1 : 0;
};
v.isEncoding = function(e) {
  switch (String(e).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
};
v.concat = function(e, t) {
  if (!ui(e))
    throw new TypeError('"list" argument must be an Array of Buffers');
  if (e.length === 0)
    return v.alloc(0);
  var r;
  if (t === void 0)
    for (t = 0, r = 0; r < e.length; ++r)
      t += e[r].length;
  var i = v.allocUnsafe(t), o = 0;
  for (r = 0; r < e.length; ++r) {
    var a = e[r];
    if (!Re(a))
      throw new TypeError('"list" argument must be an Array of Buffers');
    a.copy(i, o), o += a.length;
  }
  return i;
};
function hi(n, e) {
  if (Re(n))
    return n.length;
  if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(n) || n instanceof ArrayBuffer))
    return n.byteLength;
  typeof n != "string" && (n = "" + n);
  var t = n.length;
  if (t === 0)
    return 0;
  for (var r = !1; ; )
    switch (e) {
      case "ascii":
      case "latin1":
      case "binary":
        return t;
      case "utf8":
      case "utf-8":
      case void 0:
        return St(n).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return t * 2;
      case "hex":
        return t >>> 1;
      case "base64":
        return Ei(n).length;
      default:
        if (r)
          return St(n).length;
        e = ("" + e).toLowerCase(), r = !0;
    }
}
v.byteLength = hi;
function ph(n, e, t) {
  var r = !1;
  if ((e === void 0 || e < 0) && (e = 0), e > this.length || ((t === void 0 || t > this.length) && (t = this.length), t <= 0) || (t >>>= 0, e >>>= 0, t <= e))
    return "";
  for (n || (n = "utf8"); ; )
    switch (n) {
      case "hex":
        return Sh(this, e, t);
      case "utf8":
      case "utf-8":
        return mi(this, e, t);
      case "ascii":
        return wh(this, e, t);
      case "latin1":
      case "binary":
        return Th(this, e, t);
      case "base64":
        return kh(this, e, t);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return Ch(this, e, t);
      default:
        if (r)
          throw new TypeError("Unknown encoding: " + n);
        n = (n + "").toLowerCase(), r = !0;
    }
}
v.prototype._isBuffer = !0;
function ze(n, e, t) {
  var r = n[e];
  n[e] = n[t], n[t] = r;
}
v.prototype.swap16 = function() {
  var e = this.length;
  if (e % 2 !== 0)
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var t = 0; t < e; t += 2)
    ze(this, t, t + 1);
  return this;
};
v.prototype.swap32 = function() {
  var e = this.length;
  if (e % 4 !== 0)
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var t = 0; t < e; t += 4)
    ze(this, t, t + 3), ze(this, t + 1, t + 2);
  return this;
};
v.prototype.swap64 = function() {
  var e = this.length;
  if (e % 8 !== 0)
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var t = 0; t < e; t += 8)
    ze(this, t, t + 7), ze(this, t + 1, t + 6), ze(this, t + 2, t + 5), ze(this, t + 3, t + 4);
  return this;
};
v.prototype.toString = function() {
  var e = this.length | 0;
  return e === 0 ? "" : arguments.length === 0 ? mi(this, 0, e) : ph.apply(this, arguments);
};
v.prototype.equals = function(e) {
  if (!Re(e))
    throw new TypeError("Argument must be a Buffer");
  return this === e ? !0 : v.compare(this, e) === 0;
};
v.prototype.inspect = function() {
  var e = "", t = uh;
  return this.length > 0 && (e = this.toString("hex", 0, t).match(/.{2}/g).join(" "), this.length > t && (e += " ... ")), "<Buffer " + e + ">";
};
v.prototype.compare = function(e, t, r, i, o) {
  if (!Re(e))
    throw new TypeError("Argument must be a Buffer");
  if (t === void 0 && (t = 0), r === void 0 && (r = e ? e.length : 0), i === void 0 && (i = 0), o === void 0 && (o = this.length), t < 0 || r > e.length || i < 0 || o > this.length)
    throw new RangeError("out of range index");
  if (i >= o && t >= r)
    return 0;
  if (i >= o)
    return -1;
  if (t >= r)
    return 1;
  if (t >>>= 0, r >>>= 0, i >>>= 0, o >>>= 0, this === e)
    return 0;
  for (var a = o - i, s = r - t, l = Math.min(a, s), c = this.slice(i, o), u = e.slice(t, r), f = 0; f < l; ++f)
    if (c[f] !== u[f]) {
      a = c[f], s = u[f];
      break;
    }
  return a < s ? -1 : s < a ? 1 : 0;
};
function gi(n, e, t, r, i) {
  if (n.length === 0)
    return -1;
  if (typeof t == "string" ? (r = t, t = 0) : t > 2147483647 ? t = 2147483647 : t < -2147483648 && (t = -2147483648), t = +t, isNaN(t) && (t = i ? 0 : n.length - 1), t < 0 && (t = n.length + t), t >= n.length) {
    if (i)
      return -1;
    t = n.length - 1;
  } else if (t < 0)
    if (i)
      t = 0;
    else
      return -1;
  if (typeof e == "string" && (e = v.from(e, r)), Re(e))
    return e.length === 0 ? -1 : sr(n, e, t, r, i);
  if (typeof e == "number")
    return e = e & 255, v.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? i ? Uint8Array.prototype.indexOf.call(n, e, t) : Uint8Array.prototype.lastIndexOf.call(n, e, t) : sr(n, [e], t, r, i);
  throw new TypeError("val must be string, number or Buffer");
}
function sr(n, e, t, r, i) {
  var o = 1, a = n.length, s = e.length;
  if (r !== void 0 && (r = String(r).toLowerCase(), r === "ucs2" || r === "ucs-2" || r === "utf16le" || r === "utf-16le")) {
    if (n.length < 2 || e.length < 2)
      return -1;
    o = 2, a /= 2, s /= 2, t /= 2;
  }
  function l(g, p) {
    return o === 1 ? g[p] : g.readUInt16BE(p * o);
  }
  var c;
  if (i) {
    var u = -1;
    for (c = t; c < a; c++)
      if (l(n, c) === l(e, u === -1 ? 0 : c - u)) {
        if (u === -1 && (u = c), c - u + 1 === s)
          return u * o;
      } else
        u !== -1 && (c -= c - u), u = -1;
  } else
    for (t + s > a && (t = a - s), c = t; c >= 0; c--) {
      for (var f = !0, d = 0; d < s; d++)
        if (l(n, c + d) !== l(e, d)) {
          f = !1;
          break;
        }
      if (f)
        return c;
    }
  return -1;
}
v.prototype.includes = function(e, t, r) {
  return this.indexOf(e, t, r) !== -1;
};
v.prototype.indexOf = function(e, t, r) {
  return gi(this, e, t, r, !0);
};
v.prototype.lastIndexOf = function(e, t, r) {
  return gi(this, e, t, r, !1);
};
function mh(n, e, t, r) {
  t = Number(t) || 0;
  var i = n.length - t;
  r ? (r = Number(r), r > i && (r = i)) : r = i;
  var o = e.length;
  if (o % 2 !== 0)
    throw new TypeError("Invalid hex string");
  r > o / 2 && (r = o / 2);
  for (var a = 0; a < r; ++a) {
    var s = parseInt(e.substr(a * 2, 2), 16);
    if (isNaN(s))
      return a;
    n[t + a] = s;
  }
  return a;
}
function yh(n, e, t, r) {
  return Ut(St(e, n.length - t), n, t, r);
}
function pi(n, e, t, r) {
  return Ut(Ah(e), n, t, r);
}
function bh(n, e, t, r) {
  return pi(n, e, t, r);
}
function vh(n, e, t, r) {
  return Ut(Ei(e), n, t, r);
}
function Eh(n, e, t, r) {
  return Ut(Mh(e, n.length - t), n, t, r);
}
v.prototype.write = function(e, t, r, i) {
  if (t === void 0)
    i = "utf8", r = this.length, t = 0;
  else if (r === void 0 && typeof t == "string")
    i = t, r = this.length, t = 0;
  else if (isFinite(t))
    t = t | 0, isFinite(r) ? (r = r | 0, i === void 0 && (i = "utf8")) : (i = r, r = void 0);
  else
    throw new Error(
      "Buffer.write(string, encoding, offset[, length]) is no longer supported"
    );
  var o = this.length - t;
  if ((r === void 0 || r > o) && (r = o), e.length > 0 && (r < 0 || t < 0) || t > this.length)
    throw new RangeError("Attempt to write outside buffer bounds");
  i || (i = "utf8");
  for (var a = !1; ; )
    switch (i) {
      case "hex":
        return mh(this, e, t, r);
      case "utf8":
      case "utf-8":
        return yh(this, e, t, r);
      case "ascii":
        return pi(this, e, t, r);
      case "latin1":
      case "binary":
        return bh(this, e, t, r);
      case "base64":
        return vh(this, e, t, r);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return Eh(this, e, t, r);
      default:
        if (a)
          throw new TypeError("Unknown encoding: " + i);
        i = ("" + i).toLowerCase(), a = !0;
    }
};
v.prototype.toJSON = function() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function kh(n, e, t) {
  return e === 0 && t === n.length ? ar(n) : ar(n.slice(e, t));
}
function mi(n, e, t) {
  t = Math.min(n.length, t);
  for (var r = [], i = e; i < t; ) {
    var o = n[i], a = null, s = o > 239 ? 4 : o > 223 ? 3 : o > 191 ? 2 : 1;
    if (i + s <= t) {
      var l, c, u, f;
      switch (s) {
        case 1:
          o < 128 && (a = o);
          break;
        case 2:
          l = n[i + 1], (l & 192) === 128 && (f = (o & 31) << 6 | l & 63, f > 127 && (a = f));
          break;
        case 3:
          l = n[i + 1], c = n[i + 2], (l & 192) === 128 && (c & 192) === 128 && (f = (o & 15) << 12 | (l & 63) << 6 | c & 63, f > 2047 && (f < 55296 || f > 57343) && (a = f));
          break;
        case 4:
          l = n[i + 1], c = n[i + 2], u = n[i + 3], (l & 192) === 128 && (c & 192) === 128 && (u & 192) === 128 && (f = (o & 15) << 18 | (l & 63) << 12 | (c & 63) << 6 | u & 63, f > 65535 && f < 1114112 && (a = f));
      }
    }
    a === null ? (a = 65533, s = 1) : a > 65535 && (a -= 65536, r.push(a >>> 10 & 1023 | 55296), a = 56320 | a & 1023), r.push(a), i += s;
  }
  return $h(r);
}
var lr = 4096;
function $h(n) {
  var e = n.length;
  if (e <= lr)
    return String.fromCharCode.apply(String, n);
  for (var t = "", r = 0; r < e; )
    t += String.fromCharCode.apply(
      String,
      n.slice(r, r += lr)
    );
  return t;
}
function wh(n, e, t) {
  var r = "";
  t = Math.min(n.length, t);
  for (var i = e; i < t; ++i)
    r += String.fromCharCode(n[i] & 127);
  return r;
}
function Th(n, e, t) {
  var r = "";
  t = Math.min(n.length, t);
  for (var i = e; i < t; ++i)
    r += String.fromCharCode(n[i]);
  return r;
}
function Sh(n, e, t) {
  var r = n.length;
  (!e || e < 0) && (e = 0), (!t || t < 0 || t > r) && (t = r);
  for (var i = "", o = e; o < t; ++o)
    i += Rh(n[o]);
  return i;
}
function Ch(n, e, t) {
  for (var r = n.slice(e, t), i = "", o = 0; o < r.length; o += 2)
    i += String.fromCharCode(r[o] + r[o + 1] * 256);
  return i;
}
v.prototype.slice = function(e, t) {
  var r = this.length;
  e = ~~e, t = t === void 0 ? r : ~~t, e < 0 ? (e += r, e < 0 && (e = 0)) : e > r && (e = r), t < 0 ? (t += r, t < 0 && (t = 0)) : t > r && (t = r), t < e && (t = e);
  var i;
  if (v.TYPED_ARRAY_SUPPORT)
    i = this.subarray(e, t), i.__proto__ = v.prototype;
  else {
    var o = t - e;
    i = new v(o, void 0);
    for (var a = 0; a < o; ++a)
      i[a] = this[a + e];
  }
  return i;
};
function oe(n, e, t) {
  if (n % 1 !== 0 || n < 0)
    throw new RangeError("offset is not uint");
  if (n + e > t)
    throw new RangeError("Trying to access beyond buffer length");
}
v.prototype.readUIntLE = function(e, t, r) {
  e = e | 0, t = t | 0, r || oe(e, t, this.length);
  for (var i = this[e], o = 1, a = 0; ++a < t && (o *= 256); )
    i += this[e + a] * o;
  return i;
};
v.prototype.readUIntBE = function(e, t, r) {
  e = e | 0, t = t | 0, r || oe(e, t, this.length);
  for (var i = this[e + --t], o = 1; t > 0 && (o *= 256); )
    i += this[e + --t] * o;
  return i;
};
v.prototype.readUInt8 = function(e, t) {
  return t || oe(e, 1, this.length), this[e];
};
v.prototype.readUInt16LE = function(e, t) {
  return t || oe(e, 2, this.length), this[e] | this[e + 1] << 8;
};
v.prototype.readUInt16BE = function(e, t) {
  return t || oe(e, 2, this.length), this[e] << 8 | this[e + 1];
};
v.prototype.readUInt32LE = function(e, t) {
  return t || oe(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + this[e + 3] * 16777216;
};
v.prototype.readUInt32BE = function(e, t) {
  return t || oe(e, 4, this.length), this[e] * 16777216 + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
};
v.prototype.readIntLE = function(e, t, r) {
  e = e | 0, t = t | 0, r || oe(e, t, this.length);
  for (var i = this[e], o = 1, a = 0; ++a < t && (o *= 256); )
    i += this[e + a] * o;
  return o *= 128, i >= o && (i -= Math.pow(2, 8 * t)), i;
};
v.prototype.readIntBE = function(e, t, r) {
  e = e | 0, t = t | 0, r || oe(e, t, this.length);
  for (var i = t, o = 1, a = this[e + --i]; i > 0 && (o *= 256); )
    a += this[e + --i] * o;
  return o *= 128, a >= o && (a -= Math.pow(2, 8 * t)), a;
};
v.prototype.readInt8 = function(e, t) {
  return t || oe(e, 1, this.length), this[e] & 128 ? (255 - this[e] + 1) * -1 : this[e];
};
v.prototype.readInt16LE = function(e, t) {
  t || oe(e, 2, this.length);
  var r = this[e] | this[e + 1] << 8;
  return r & 32768 ? r | 4294901760 : r;
};
v.prototype.readInt16BE = function(e, t) {
  t || oe(e, 2, this.length);
  var r = this[e + 1] | this[e] << 8;
  return r & 32768 ? r | 4294901760 : r;
};
v.prototype.readInt32LE = function(e, t) {
  return t || oe(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
};
v.prototype.readInt32BE = function(e, t) {
  return t || oe(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
};
v.prototype.readFloatLE = function(e, t) {
  return t || oe(e, 4, this.length), Lt(this, e, !0, 23, 4);
};
v.prototype.readFloatBE = function(e, t) {
  return t || oe(e, 4, this.length), Lt(this, e, !1, 23, 4);
};
v.prototype.readDoubleLE = function(e, t) {
  return t || oe(e, 8, this.length), Lt(this, e, !0, 52, 8);
};
v.prototype.readDoubleBE = function(e, t) {
  return t || oe(e, 8, this.length), Lt(this, e, !1, 52, 8);
};
function de(n, e, t, r, i, o) {
  if (!Re(n))
    throw new TypeError('"buffer" argument must be a Buffer instance');
  if (e > i || e < o)
    throw new RangeError('"value" argument is out of bounds');
  if (t + r > n.length)
    throw new RangeError("Index out of range");
}
v.prototype.writeUIntLE = function(e, t, r, i) {
  if (e = +e, t = t | 0, r = r | 0, !i) {
    var o = Math.pow(2, 8 * r) - 1;
    de(this, e, t, r, o, 0);
  }
  var a = 1, s = 0;
  for (this[t] = e & 255; ++s < r && (a *= 256); )
    this[t + s] = e / a & 255;
  return t + r;
};
v.prototype.writeUIntBE = function(e, t, r, i) {
  if (e = +e, t = t | 0, r = r | 0, !i) {
    var o = Math.pow(2, 8 * r) - 1;
    de(this, e, t, r, o, 0);
  }
  var a = r - 1, s = 1;
  for (this[t + a] = e & 255; --a >= 0 && (s *= 256); )
    this[t + a] = e / s & 255;
  return t + r;
};
v.prototype.writeUInt8 = function(e, t, r) {
  return e = +e, t = t | 0, r || de(this, e, t, 1, 255, 0), v.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = e & 255, t + 1;
};
function Pt(n, e, t, r) {
  e < 0 && (e = 65535 + e + 1);
  for (var i = 0, o = Math.min(n.length - t, 2); i < o; ++i)
    n[t + i] = (e & 255 << 8 * (r ? i : 1 - i)) >>> (r ? i : 1 - i) * 8;
}
v.prototype.writeUInt16LE = function(e, t, r) {
  return e = +e, t = t | 0, r || de(this, e, t, 2, 65535, 0), v.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8) : Pt(this, e, t, !0), t + 2;
};
v.prototype.writeUInt16BE = function(e, t, r) {
  return e = +e, t = t | 0, r || de(this, e, t, 2, 65535, 0), v.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = e & 255) : Pt(this, e, t, !1), t + 2;
};
function _t(n, e, t, r) {
  e < 0 && (e = 4294967295 + e + 1);
  for (var i = 0, o = Math.min(n.length - t, 4); i < o; ++i)
    n[t + i] = e >>> (r ? i : 3 - i) * 8 & 255;
}
v.prototype.writeUInt32LE = function(e, t, r) {
  return e = +e, t = t | 0, r || de(this, e, t, 4, 4294967295, 0), v.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = e & 255) : _t(this, e, t, !0), t + 4;
};
v.prototype.writeUInt32BE = function(e, t, r) {
  return e = +e, t = t | 0, r || de(this, e, t, 4, 4294967295, 0), v.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255) : _t(this, e, t, !1), t + 4;
};
v.prototype.writeIntLE = function(e, t, r, i) {
  if (e = +e, t = t | 0, !i) {
    var o = Math.pow(2, 8 * r - 1);
    de(this, e, t, r, o - 1, -o);
  }
  var a = 0, s = 1, l = 0;
  for (this[t] = e & 255; ++a < r && (s *= 256); )
    e < 0 && l === 0 && this[t + a - 1] !== 0 && (l = 1), this[t + a] = (e / s >> 0) - l & 255;
  return t + r;
};
v.prototype.writeIntBE = function(e, t, r, i) {
  if (e = +e, t = t | 0, !i) {
    var o = Math.pow(2, 8 * r - 1);
    de(this, e, t, r, o - 1, -o);
  }
  var a = r - 1, s = 1, l = 0;
  for (this[t + a] = e & 255; --a >= 0 && (s *= 256); )
    e < 0 && l === 0 && this[t + a + 1] !== 0 && (l = 1), this[t + a] = (e / s >> 0) - l & 255;
  return t + r;
};
v.prototype.writeInt8 = function(e, t, r) {
  return e = +e, t = t | 0, r || de(this, e, t, 1, 127, -128), v.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = e & 255, t + 1;
};
v.prototype.writeInt16LE = function(e, t, r) {
  return e = +e, t = t | 0, r || de(this, e, t, 2, 32767, -32768), v.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8) : Pt(this, e, t, !0), t + 2;
};
v.prototype.writeInt16BE = function(e, t, r) {
  return e = +e, t = t | 0, r || de(this, e, t, 2, 32767, -32768), v.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = e & 255) : Pt(this, e, t, !1), t + 2;
};
v.prototype.writeInt32LE = function(e, t, r) {
  return e = +e, t = t | 0, r || de(this, e, t, 4, 2147483647, -2147483648), v.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : _t(this, e, t, !0), t + 4;
};
v.prototype.writeInt32BE = function(e, t, r) {
  return e = +e, t = t | 0, r || de(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), v.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255) : _t(this, e, t, !1), t + 4;
};
function yi(n, e, t, r, i, o) {
  if (t + r > n.length)
    throw new RangeError("Index out of range");
  if (t < 0)
    throw new RangeError("Index out of range");
}
function bi(n, e, t, r, i) {
  return i || yi(n, e, t, 4), ci(n, e, t, r, 23, 4), t + 4;
}
v.prototype.writeFloatLE = function(e, t, r) {
  return bi(this, e, t, !0, r);
};
v.prototype.writeFloatBE = function(e, t, r) {
  return bi(this, e, t, !1, r);
};
function vi(n, e, t, r, i) {
  return i || yi(n, e, t, 8), ci(n, e, t, r, 52, 8), t + 8;
}
v.prototype.writeDoubleLE = function(e, t, r) {
  return vi(this, e, t, !0, r);
};
v.prototype.writeDoubleBE = function(e, t, r) {
  return vi(this, e, t, !1, r);
};
v.prototype.copy = function(e, t, r, i) {
  if (r || (r = 0), !i && i !== 0 && (i = this.length), t >= e.length && (t = e.length), t || (t = 0), i > 0 && i < r && (i = r), i === r || e.length === 0 || this.length === 0)
    return 0;
  if (t < 0)
    throw new RangeError("targetStart out of bounds");
  if (r < 0 || r >= this.length)
    throw new RangeError("sourceStart out of bounds");
  if (i < 0)
    throw new RangeError("sourceEnd out of bounds");
  i > this.length && (i = this.length), e.length - t < i - r && (i = e.length - t + r);
  var o = i - r, a;
  if (this === e && r < t && t < i)
    for (a = o - 1; a >= 0; --a)
      e[a + t] = this[a + r];
  else if (o < 1e3 || !v.TYPED_ARRAY_SUPPORT)
    for (a = 0; a < o; ++a)
      e[a + t] = this[a + r];
  else
    Uint8Array.prototype.set.call(
      e,
      this.subarray(r, r + o),
      t
    );
  return o;
};
v.prototype.fill = function(e, t, r, i) {
  if (typeof e == "string") {
    if (typeof t == "string" ? (i = t, t = 0, r = this.length) : typeof r == "string" && (i = r, r = this.length), e.length === 1) {
      var o = e.charCodeAt(0);
      o < 256 && (e = o);
    }
    if (i !== void 0 && typeof i != "string")
      throw new TypeError("encoding must be a string");
    if (typeof i == "string" && !v.isEncoding(i))
      throw new TypeError("Unknown encoding: " + i);
  } else
    typeof e == "number" && (e = e & 255);
  if (t < 0 || this.length < t || this.length < r)
    throw new RangeError("Out of range index");
  if (r <= t)
    return this;
  t = t >>> 0, r = r === void 0 ? this.length : r >>> 0, e || (e = 0);
  var a;
  if (typeof e == "number")
    for (a = t; a < r; ++a)
      this[a] = e;
  else {
    var s = Re(e) ? e : St(new v(e, i).toString()), l = s.length;
    for (a = 0; a < r - t; ++a)
      this[a + t] = s[a % l];
  }
  return this;
};
var xh = /[^+\/0-9A-Za-z-_]/g;
function Bh(n) {
  if (n = Ih(n).replace(xh, ""), n.length < 2)
    return "";
  for (; n.length % 4 !== 0; )
    n = n + "=";
  return n;
}
function Ih(n) {
  return n.trim ? n.trim() : n.replace(/^\s+|\s+$/g, "");
}
function Rh(n) {
  return n < 16 ? "0" + n.toString(16) : n.toString(16);
}
function St(n, e) {
  e = e || 1 / 0;
  for (var t, r = n.length, i = null, o = [], a = 0; a < r; ++a) {
    if (t = n.charCodeAt(a), t > 55295 && t < 57344) {
      if (!i) {
        if (t > 56319) {
          (e -= 3) > -1 && o.push(239, 191, 189);
          continue;
        } else if (a + 1 === r) {
          (e -= 3) > -1 && o.push(239, 191, 189);
          continue;
        }
        i = t;
        continue;
      }
      if (t < 56320) {
        (e -= 3) > -1 && o.push(239, 191, 189), i = t;
        continue;
      }
      t = (i - 55296 << 10 | t - 56320) + 65536;
    } else
      i && (e -= 3) > -1 && o.push(239, 191, 189);
    if (i = null, t < 128) {
      if ((e -= 1) < 0)
        break;
      o.push(t);
    } else if (t < 2048) {
      if ((e -= 2) < 0)
        break;
      o.push(
        t >> 6 | 192,
        t & 63 | 128
      );
    } else if (t < 65536) {
      if ((e -= 3) < 0)
        break;
      o.push(
        t >> 12 | 224,
        t >> 6 & 63 | 128,
        t & 63 | 128
      );
    } else if (t < 1114112) {
      if ((e -= 4) < 0)
        break;
      o.push(
        t >> 18 | 240,
        t >> 12 & 63 | 128,
        t >> 6 & 63 | 128,
        t & 63 | 128
      );
    } else
      throw new Error("Invalid code point");
  }
  return o;
}
function Ah(n) {
  for (var e = [], t = 0; t < n.length; ++t)
    e.push(n.charCodeAt(t) & 255);
  return e;
}
function Mh(n, e) {
  for (var t, r, i, o = [], a = 0; a < n.length && !((e -= 2) < 0); ++a)
    t = n.charCodeAt(a), r = t >> 8, i = t % 256, o.push(i), o.push(r);
  return o;
}
function Ei(n) {
  return ah(Bh(n));
}
function Ut(n, e, t, r) {
  for (var i = 0; i < r && !(i + t >= e.length || i >= n.length); ++i)
    e[i + t] = n[i];
  return i;
}
function Oh(n) {
  return n !== n;
}
function Dh(n) {
  return n != null && (!!n._isBuffer || ki(n) || Nh(n));
}
function ki(n) {
  return !!n.constructor && typeof n.constructor.isBuffer == "function" && n.constructor.isBuffer(n);
}
function Nh(n) {
  return typeof n.readFloatLE == "function" && typeof n.slice == "function" && ki(n.slice(0, 0));
}
var Fh = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function jp(n) {
  if (n.__esModule)
    return n;
  var e = Object.defineProperty({}, "__esModule", { value: !0 });
  return Object.keys(n).forEach(function(t) {
    var r = Object.getOwnPropertyDescriptor(n, t);
    Object.defineProperty(e, t, r.get ? r : {
      enumerable: !0,
      get: function() {
        return n[t];
      }
    });
  }), e;
}
var $i = { exports: {} };
(function(n, e) {
  (function(t, r) {
    n.exports = r();
  })(Fh, function() {
    var t = 1e3, r = 6e4, i = 36e5, o = "millisecond", a = "second", s = "minute", l = "hour", c = "day", u = "week", f = "month", d = "quarter", g = "year", p = "date", y = "Invalid Date", b = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, k = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, x = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(I) {
      var w = ["th", "st", "nd", "rd"], $ = I % 100;
      return "[" + I + (w[($ - 20) % 10] || w[$] || w[0]) + "]";
    } }, Q = function(I, w, $) {
      var M = String(I);
      return !M || M.length >= w ? I : "" + Array(w + 1 - M.length).join($) + I;
    }, F = { s: Q, z: function(I) {
      var w = -I.utcOffset(), $ = Math.abs(w), M = Math.floor($ / 60), C = $ % 60;
      return (w <= 0 ? "+" : "-") + Q(M, 2, "0") + ":" + Q(C, 2, "0");
    }, m: function I(w, $) {
      if (w.date() < $.date())
        return -I($, w);
      var M = 12 * ($.year() - w.year()) + ($.month() - w.month()), C = w.clone().add(M, f), B = $ - C < 0, A = w.clone().add(M + (B ? -1 : 1), f);
      return +(-(M + ($ - C) / (B ? C - A : A - C)) || 0);
    }, a: function(I) {
      return I < 0 ? Math.ceil(I) || 0 : Math.floor(I);
    }, p: function(I) {
      return { M: f, y: g, w: u, d: c, D: p, h: l, m: s, s: a, ms: o, Q: d }[I] || String(I || "").toLowerCase().replace(/s$/, "");
    }, u: function(I) {
      return I === void 0;
    } }, K = "en", j = {};
    j[K] = x;
    var V = function(I) {
      return I instanceof me;
    }, Ee = function I(w, $, M) {
      var C;
      if (!w)
        return K;
      if (typeof w == "string") {
        var B = w.toLowerCase();
        j[B] && (C = B), $ && (j[B] = $, C = B);
        var A = w.split("-");
        if (!C && A.length > 1)
          return I(A[0]);
      } else {
        var N = w.name;
        j[N] = w, C = N;
      }
      return !M && C && (K = C), C || !M && K;
    }, J = function(I, w) {
      if (V(I))
        return I.clone();
      var $ = typeof w == "object" ? w : {};
      return $.date = I, $.args = arguments, new me($);
    }, _ = F;
    _.l = Ee, _.i = V, _.w = function(I, w) {
      return J(I, { locale: w.$L, utc: w.$u, x: w.$x, $offset: w.$offset });
    };
    var me = function() {
      function I($) {
        this.$L = Ee($.locale, null, !0), this.parse($);
      }
      var w = I.prototype;
      return w.parse = function($) {
        this.$d = function(M) {
          var C = M.date, B = M.utc;
          if (C === null)
            return /* @__PURE__ */ new Date(NaN);
          if (_.u(C))
            return /* @__PURE__ */ new Date();
          if (C instanceof Date)
            return new Date(C);
          if (typeof C == "string" && !/Z$/i.test(C)) {
            var A = C.match(b);
            if (A) {
              var N = A[2] - 1 || 0, G = (A[7] || "0").substring(0, 3);
              return B ? new Date(Date.UTC(A[1], N, A[3] || 1, A[4] || 0, A[5] || 0, A[6] || 0, G)) : new Date(A[1], N, A[3] || 1, A[4] || 0, A[5] || 0, A[6] || 0, G);
            }
          }
          return new Date(C);
        }($), this.$x = $.x || {}, this.init();
      }, w.init = function() {
        var $ = this.$d;
        this.$y = $.getFullYear(), this.$M = $.getMonth(), this.$D = $.getDate(), this.$W = $.getDay(), this.$H = $.getHours(), this.$m = $.getMinutes(), this.$s = $.getSeconds(), this.$ms = $.getMilliseconds();
      }, w.$utils = function() {
        return _;
      }, w.isValid = function() {
        return this.$d.toString() !== y;
      }, w.isSame = function($, M) {
        var C = J($);
        return this.startOf(M) <= C && C <= this.endOf(M);
      }, w.isAfter = function($, M) {
        return J($) < this.startOf(M);
      }, w.isBefore = function($, M) {
        return this.endOf(M) < J($);
      }, w.$g = function($, M, C) {
        return _.u($) ? this[M] : this.set(C, $);
      }, w.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, w.valueOf = function() {
        return this.$d.getTime();
      }, w.startOf = function($, M) {
        var C = this, B = !!_.u(M) || M, A = _.p($), N = function($e, re) {
          var fe = _.w(C.$u ? Date.UTC(C.$y, re, $e) : new Date(C.$y, re, $e), C);
          return B ? fe : fe.endOf(c);
        }, G = function($e, re) {
          return _.w(C.toDate()[$e].apply(C.toDate("s"), (B ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(re)), C);
        }, q = this.$W, ne = this.$M, Te = this.$D, ke = "set" + (this.$u ? "UTC" : "");
        switch (A) {
          case g:
            return B ? N(1, 0) : N(31, 11);
          case f:
            return B ? N(1, ne) : N(0, ne + 1);
          case u:
            var Me = this.$locale().weekStart || 0, Oe = (q < Me ? q + 7 : q) - Me;
            return N(B ? Te - Oe : Te + (6 - Oe), ne);
          case c:
          case p:
            return G(ke + "Hours", 0);
          case l:
            return G(ke + "Minutes", 1);
          case s:
            return G(ke + "Seconds", 2);
          case a:
            return G(ke + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, w.endOf = function($) {
        return this.startOf($, !1);
      }, w.$set = function($, M) {
        var C, B = _.p($), A = "set" + (this.$u ? "UTC" : ""), N = (C = {}, C[c] = A + "Date", C[p] = A + "Date", C[f] = A + "Month", C[g] = A + "FullYear", C[l] = A + "Hours", C[s] = A + "Minutes", C[a] = A + "Seconds", C[o] = A + "Milliseconds", C)[B], G = B === c ? this.$D + (M - this.$W) : M;
        if (B === f || B === g) {
          var q = this.clone().set(p, 1);
          q.$d[N](G), q.init(), this.$d = q.set(p, Math.min(this.$D, q.daysInMonth())).$d;
        } else
          N && this.$d[N](G);
        return this.init(), this;
      }, w.set = function($, M) {
        return this.clone().$set($, M);
      }, w.get = function($) {
        return this[_.p($)]();
      }, w.add = function($, M) {
        var C, B = this;
        $ = Number($);
        var A = _.p(M), N = function(ne) {
          var Te = J(B);
          return _.w(Te.date(Te.date() + Math.round(ne * $)), B);
        };
        if (A === f)
          return this.set(f, this.$M + $);
        if (A === g)
          return this.set(g, this.$y + $);
        if (A === c)
          return N(1);
        if (A === u)
          return N(7);
        var G = (C = {}, C[s] = r, C[l] = i, C[a] = t, C)[A] || 1, q = this.$d.getTime() + $ * G;
        return _.w(q, this);
      }, w.subtract = function($, M) {
        return this.add(-1 * $, M);
      }, w.format = function($) {
        var M = this, C = this.$locale();
        if (!this.isValid())
          return C.invalidDate || y;
        var B = $ || "YYYY-MM-DDTHH:mm:ssZ", A = _.z(this), N = this.$H, G = this.$m, q = this.$M, ne = C.weekdays, Te = C.months, ke = function(re, fe, rt, je) {
          return re && (re[fe] || re(M, B)) || rt[fe].slice(0, je);
        }, Me = function(re) {
          return _.s(N % 12 || 12, re, "0");
        }, Oe = C.meridiem || function(re, fe, rt) {
          var je = re < 12 ? "AM" : "PM";
          return rt ? je.toLowerCase() : je;
        }, $e = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: q + 1, MM: _.s(q + 1, 2, "0"), MMM: ke(C.monthsShort, q, Te, 3), MMMM: ke(Te, q), D: this.$D, DD: _.s(this.$D, 2, "0"), d: String(this.$W), dd: ke(C.weekdaysMin, this.$W, ne, 2), ddd: ke(C.weekdaysShort, this.$W, ne, 3), dddd: ne[this.$W], H: String(N), HH: _.s(N, 2, "0"), h: Me(1), hh: Me(2), a: Oe(N, G, !0), A: Oe(N, G, !1), m: String(G), mm: _.s(G, 2, "0"), s: String(this.$s), ss: _.s(this.$s, 2, "0"), SSS: _.s(this.$ms, 3, "0"), Z: A };
        return B.replace(k, function(re, fe) {
          return fe || $e[re] || A.replace(":", "");
        });
      }, w.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, w.diff = function($, M, C) {
        var B, A = _.p(M), N = J($), G = (N.utcOffset() - this.utcOffset()) * r, q = this - N, ne = _.m(this, N);
        return ne = (B = {}, B[g] = ne / 12, B[f] = ne, B[d] = ne / 3, B[u] = (q - G) / 6048e5, B[c] = (q - G) / 864e5, B[l] = q / i, B[s] = q / r, B[a] = q / t, B)[A] || q, C ? ne : _.a(ne);
      }, w.daysInMonth = function() {
        return this.endOf(f).$D;
      }, w.$locale = function() {
        return j[this.$L];
      }, w.locale = function($, M) {
        if (!$)
          return this.$L;
        var C = this.clone(), B = Ee($, M, !0);
        return B && (C.$L = B), C;
      }, w.clone = function() {
        return _.w(this.$d, this);
      }, w.toDate = function() {
        return new Date(this.valueOf());
      }, w.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, w.toISOString = function() {
        return this.$d.toISOString();
      }, w.toString = function() {
        return this.$d.toUTCString();
      }, I;
    }(), Ge = me.prototype;
    return J.prototype = Ge, [["$ms", o], ["$s", a], ["$m", s], ["$H", l], ["$W", c], ["$M", f], ["$y", g], ["$D", p]].forEach(function(I) {
      Ge[I[1]] = function(w) {
        return this.$g(w, I[0], I[1]);
      };
    }), J.extend = function(I, w) {
      return I.$i || (I(w, me, J), I.$i = !0), J;
    }, J.locale = Ee, J.isDayjs = V, J.unix = function(I) {
      return J(1e3 * I);
    }, J.en = j[K], J.Ls = j, J.p = {}, J;
  });
})($i);
const wi = $i.exports;
var un = [
  "MO",
  "TU",
  "WE",
  "TH",
  "FR",
  "SA",
  "SU"
], ue = (
  /** @class */
  function() {
    function n(e, t) {
      if (t === 0)
        throw new Error("Can't create weekday with n == 0");
      this.weekday = e, this.n = t;
    }
    return n.fromStr = function(e) {
      return new n(un.indexOf(e));
    }, n.prototype.nth = function(e) {
      return this.n === e ? this : new n(this.weekday, e);
    }, n.prototype.equals = function(e) {
      return this.weekday === e.weekday && this.n === e.n;
    }, n.prototype.toString = function() {
      var e = un[this.weekday];
      return this.n && (e = (this.n > 0 ? "+" : "") + String(this.n) + e), e;
    }, n.prototype.getJsWeekday = function() {
      return this.weekday === 6 ? 0 : this.weekday + 1;
    }, n;
  }()
), te = function(n) {
  return n != null;
}, Se = function(n) {
  return typeof n == "number";
}, cr = function(n) {
  return typeof n == "string" && un.includes(n);
}, ge = Array.isArray, Ae = function(n, e) {
  e === void 0 && (e = n), arguments.length === 1 && (e = n, n = 0);
  for (var t = [], r = n; r < e; r++)
    t.push(r);
  return t;
}, U = function(n, e) {
  var t = 0, r = [];
  if (ge(n))
    for (; t < e; t++)
      r[t] = [].concat(n);
  else
    for (; t < e; t++)
      r[t] = n;
  return r;
}, Lh = function(n) {
  return ge(n) ? n : [n];
};
function Ve(n, e, t) {
  t === void 0 && (t = " ");
  var r = String(n);
  return e = e >> 0, r.length > e ? String(r) : (e = e - r.length, e > t.length && (t += U(t, e / t.length)), t.slice(0, e) + String(r));
}
var Ph = function(n, e, t) {
  var r = n.split(e);
  return t ? r.slice(0, t).concat([r.slice(t).join(e)]) : r;
}, ve = function(n, e) {
  var t = n % e;
  return t * e < 0 ? t + e : t;
}, Zt = function(n, e) {
  return { div: Math.floor(n / e), mod: ve(n, e) };
}, Ce = function(n) {
  return !te(n) || n.length === 0;
}, ie = function(n) {
  return !Ce(n);
}, W = function(n, e) {
  return ie(n) && n.indexOf(e) !== -1;
}, We = function(n, e, t, r, i, o) {
  return r === void 0 && (r = 0), i === void 0 && (i = 0), o === void 0 && (o = 0), new Date(Date.UTC(n, e - 1, t, r, i, o));
}, _h = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Ti = 1e3 * 60 * 60 * 24, Si = 9999, Ci = We(1970, 1, 1), Uh = [6, 0, 1, 2, 3, 4, 5], ct = function(n) {
  return n % 4 === 0 && n % 100 !== 0 || n % 400 === 0;
}, xi = function(n) {
  return n instanceof Date;
}, lt = function(n) {
  return xi(n) && !isNaN(n.getTime());
}, ur = function(n) {
  return n.getTimezoneOffset() * 60 * 1e3;
}, Hh = function(n, e) {
  var t = n.getTime() - ur(n), r = e.getTime() - ur(e), i = t - r;
  return Math.round(i / Ti);
}, dn = function(n) {
  return Hh(n, Ci);
}, Bi = function(n) {
  return new Date(Ci.getTime() + n * Ti);
}, Yh = function(n) {
  var e = n.getUTCMonth();
  return e === 1 && ct(n.getUTCFullYear()) ? 29 : _h[e];
}, tt = function(n) {
  return Uh[n.getUTCDay()];
}, dr = function(n, e) {
  var t = We(n, e + 1, 1);
  return [tt(t), Yh(t)];
}, Ii = function(n, e) {
  return e = e || n, new Date(Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
}, fn = function(n) {
  var e = new Date(n.getTime());
  return e;
}, fr = function(n) {
  for (var e = [], t = 0; t < n.length; t++)
    e.push(fn(n[t]));
  return e;
}, ft = function(n) {
  n.sort(function(e, t) {
    return e.getTime() - t.getTime();
  });
}, Cn = function(n, e) {
  e === void 0 && (e = !0);
  var t = new Date(n);
  return [
    Ve(t.getUTCFullYear().toString(), 4, "0"),
    Ve(t.getUTCMonth() + 1, 2, "0"),
    Ve(t.getUTCDate(), 2, "0"),
    "T",
    Ve(t.getUTCHours(), 2, "0"),
    Ve(t.getUTCMinutes(), 2, "0"),
    Ve(t.getUTCSeconds(), 2, "0"),
    e ? "Z" : ""
  ].join("");
}, xn = function(n) {
  var e = /^(\d{4})(\d{2})(\d{2})(T(\d{2})(\d{2})(\d{2})Z?)?$/, t = e.exec(n);
  if (!t)
    throw new Error("Invalid UNTIL value: ".concat(n));
  return new Date(Date.UTC(parseInt(t[1], 10), parseInt(t[2], 10) - 1, parseInt(t[3], 10), parseInt(t[5], 10) || 0, parseInt(t[6], 10) || 0, parseInt(t[7], 10) || 0));
}, hr = function(n, e) {
  var t = n.toLocaleString("sv-SE", { timeZone: e });
  return t.replace(" ", "T") + "Z";
}, jh = function(n, e) {
  var t = Intl.DateTimeFormat().resolvedOptions().timeZone, r = new Date(hr(n, t)), i = new Date(hr(n, e ?? "UTC")), o = i.getTime() - r.getTime();
  return new Date(n.getTime() - o);
}, et = (
  /** @class */
  function() {
    function n(e, t) {
      this.minDate = null, this.maxDate = null, this._result = [], this.total = 0, this.method = e, this.args = t, e === "between" ? (this.maxDate = t.inc ? t.before : new Date(t.before.getTime() - 1), this.minDate = t.inc ? t.after : new Date(t.after.getTime() + 1)) : e === "before" ? this.maxDate = t.inc ? t.dt : new Date(t.dt.getTime() - 1) : e === "after" && (this.minDate = t.inc ? t.dt : new Date(t.dt.getTime() + 1));
    }
    return n.prototype.accept = function(e) {
      ++this.total;
      var t = this.minDate && e < this.minDate, r = this.maxDate && e > this.maxDate;
      if (this.method === "between") {
        if (t)
          return !0;
        if (r)
          return !1;
      } else if (this.method === "before") {
        if (r)
          return !1;
      } else if (this.method === "after")
        return t ? !0 : (this.add(e), !1);
      return this.add(e);
    }, n.prototype.add = function(e) {
      return this._result.push(e), !0;
    }, n.prototype.getValue = function() {
      var e = this._result;
      switch (this.method) {
        case "all":
        case "between":
          return e;
        case "before":
        case "after":
        default:
          return e.length ? e[e.length - 1] : null;
      }
    }, n.prototype.clone = function() {
      return new n(this.method, this.args);
    }, n;
  }()
), hn = function(n, e) {
  return hn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, r) {
    t.__proto__ = r;
  } || function(t, r) {
    for (var i in r)
      Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
  }, hn(n, e);
};
function Bn(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  hn(n, e);
  function t() {
    this.constructor = n;
  }
  n.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var pe = function() {
  return pe = Object.assign || function(e) {
    for (var t, r = 1, i = arguments.length; r < i; r++) {
      t = arguments[r];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, pe.apply(this, arguments);
};
function T(n, e, t) {
  if (t || arguments.length === 2)
    for (var r = 0, i = e.length, o; r < i; r++)
      (o || !(r in e)) && (o || (o = Array.prototype.slice.call(e, 0, r)), o[r] = e[r]);
  return n.concat(o || Array.prototype.slice.call(e));
}
var gr = (
  /** @class */
  function(n) {
    Bn(e, n);
    function e(t, r, i) {
      var o = n.call(this, t, r) || this;
      return o.iterator = i, o;
    }
    return e.prototype.add = function(t) {
      return this.iterator(t, this._result.length) ? (this._result.push(t), !0) : !1;
    }, e;
  }(et)
), Ct = {
  dayNames: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ],
  monthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  tokens: {
    SKIP: /^[ \r\n\t]+|^\.$/,
    number: /^[1-9][0-9]*/,
    numberAsText: /^(one|two|three)/i,
    every: /^every/i,
    "day(s)": /^days?/i,
    "weekday(s)": /^weekdays?/i,
    "week(s)": /^weeks?/i,
    "hour(s)": /^hours?/i,
    "minute(s)": /^minutes?/i,
    "month(s)": /^months?/i,
    "year(s)": /^years?/i,
    on: /^(on|in)/i,
    at: /^(at)/i,
    the: /^the/i,
    first: /^first/i,
    second: /^second/i,
    third: /^third/i,
    nth: /^([1-9][0-9]*)(\.|th|nd|rd|st)/i,
    last: /^last/i,
    for: /^for/i,
    "time(s)": /^times?/i,
    until: /^(un)?til/i,
    monday: /^mo(n(day)?)?/i,
    tuesday: /^tu(e(s(day)?)?)?/i,
    wednesday: /^we(d(n(esday)?)?)?/i,
    thursday: /^th(u(r(sday)?)?)?/i,
    friday: /^fr(i(day)?)?/i,
    saturday: /^sa(t(urday)?)?/i,
    sunday: /^su(n(day)?)?/i,
    january: /^jan(uary)?/i,
    february: /^feb(ruary)?/i,
    march: /^mar(ch)?/i,
    april: /^apr(il)?/i,
    may: /^may/i,
    june: /^june?/i,
    july: /^july?/i,
    august: /^aug(ust)?/i,
    september: /^sep(t(ember)?)?/i,
    october: /^oct(ober)?/i,
    november: /^nov(ember)?/i,
    december: /^dec(ember)?/i,
    comma: /^(,\s*|(and|or)\s*)+/i
  }
}, pr = function(n, e) {
  return n.indexOf(e) !== -1;
}, zh = function(n) {
  return n.toString();
}, Wh = function(n, e, t) {
  return "".concat(e, " ").concat(t, ", ").concat(n);
}, Ue = (
  /** @class */
  function() {
    function n(e, t, r, i) {
      if (t === void 0 && (t = zh), r === void 0 && (r = Ct), i === void 0 && (i = Wh), this.text = [], this.language = r || Ct, this.gettext = t, this.dateFormatter = i, this.rrule = e, this.options = e.options, this.origOptions = e.origOptions, this.origOptions.bymonthday) {
        var o = [].concat(this.options.bymonthday), a = [].concat(this.options.bynmonthday);
        o.sort(function(u, f) {
          return u - f;
        }), a.sort(function(u, f) {
          return f - u;
        }), this.bymonthday = o.concat(a), this.bymonthday.length || (this.bymonthday = null);
      }
      if (te(this.origOptions.byweekday)) {
        var s = ge(this.origOptions.byweekday) ? this.origOptions.byweekday : [this.origOptions.byweekday], l = String(s);
        this.byweekday = {
          allWeeks: s.filter(function(u) {
            return !u.n;
          }),
          someWeeks: s.filter(function(u) {
            return !!u.n;
          }),
          isWeekdays: l.indexOf("MO") !== -1 && l.indexOf("TU") !== -1 && l.indexOf("WE") !== -1 && l.indexOf("TH") !== -1 && l.indexOf("FR") !== -1 && l.indexOf("SA") === -1 && l.indexOf("SU") === -1,
          isEveryDay: l.indexOf("MO") !== -1 && l.indexOf("TU") !== -1 && l.indexOf("WE") !== -1 && l.indexOf("TH") !== -1 && l.indexOf("FR") !== -1 && l.indexOf("SA") !== -1 && l.indexOf("SU") !== -1
        };
        var c = function(u, f) {
          return u.weekday - f.weekday;
        };
        this.byweekday.allWeeks.sort(c), this.byweekday.someWeeks.sort(c), this.byweekday.allWeeks.length || (this.byweekday.allWeeks = null), this.byweekday.someWeeks.length || (this.byweekday.someWeeks = null);
      } else
        this.byweekday = null;
    }
    return n.isFullyConvertible = function(e) {
      var t = !0;
      if (!(e.options.freq in n.IMPLEMENTED) || e.origOptions.until && e.origOptions.count)
        return !1;
      for (var r in e.origOptions) {
        if (pr(["dtstart", "wkst", "freq"], r))
          return !0;
        if (!pr(n.IMPLEMENTED[e.options.freq], r))
          return !1;
      }
      return t;
    }, n.prototype.isFullyConvertible = function() {
      return n.isFullyConvertible(this.rrule);
    }, n.prototype.toString = function() {
      var e = this.gettext;
      if (!(this.options.freq in n.IMPLEMENTED))
        return e("RRule error: Unable to fully convert this rrule to text");
      if (this.text = [e("every")], this[O.FREQUENCIES[this.options.freq]](), this.options.until) {
        this.add(e("until"));
        var t = this.options.until;
        this.add(this.dateFormatter(t.getUTCFullYear(), this.language.monthNames[t.getUTCMonth()], t.getUTCDate()));
      } else
        this.options.count && this.add(e("for")).add(this.options.count.toString()).add(this.plural(this.options.count) ? e("times") : e("time"));
      return this.isFullyConvertible() || this.add(e("(~ approximate)")), this.text.join("");
    }, n.prototype.HOURLY = function() {
      var e = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? e("hours") : e("hour"));
    }, n.prototype.MINUTELY = function() {
      var e = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? e("minutes") : e("minute"));
    }, n.prototype.DAILY = function() {
      var e = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()), this.byweekday && this.byweekday.isWeekdays ? this.add(this.plural(this.options.interval) ? e("weekdays") : e("weekday")) : this.add(this.plural(this.options.interval) ? e("days") : e("day")), this.origOptions.bymonth && (this.add(e("in")), this._bymonth()), this.bymonthday ? this._bymonthday() : this.byweekday ? this._byweekday() : this.origOptions.byhour && this._byhour();
    }, n.prototype.WEEKLY = function() {
      var e = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()).add(this.plural(this.options.interval) ? e("weeks") : e("week")), this.byweekday && this.byweekday.isWeekdays ? this.options.interval === 1 ? this.add(this.plural(this.options.interval) ? e("weekdays") : e("weekday")) : this.add(e("on")).add(e("weekdays")) : this.byweekday && this.byweekday.isEveryDay ? this.add(this.plural(this.options.interval) ? e("days") : e("day")) : (this.options.interval === 1 && this.add(e("week")), this.origOptions.bymonth && (this.add(e("in")), this._bymonth()), this.bymonthday ? this._bymonthday() : this.byweekday && this._byweekday());
    }, n.prototype.MONTHLY = function() {
      var e = this.gettext;
      this.origOptions.bymonth ? (this.options.interval !== 1 && (this.add(this.options.interval.toString()).add(e("months")), this.plural(this.options.interval) && this.add(e("in"))), this._bymonth()) : (this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? e("months") : e("month"))), this.bymonthday ? this._bymonthday() : this.byweekday && this.byweekday.isWeekdays ? this.add(e("on")).add(e("weekdays")) : this.byweekday && this._byweekday();
    }, n.prototype.YEARLY = function() {
      var e = this.gettext;
      this.origOptions.bymonth ? (this.options.interval !== 1 && (this.add(this.options.interval.toString()), this.add(e("years"))), this._bymonth()) : (this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? e("years") : e("year"))), this.bymonthday ? this._bymonthday() : this.byweekday && this._byweekday(), this.options.byyearday && this.add(e("on the")).add(this.list(this.options.byyearday, this.nth, e("and"))).add(e("day")), this.options.byweekno && this.add(e("in")).add(this.plural(this.options.byweekno.length) ? e("weeks") : e("week")).add(this.list(this.options.byweekno, void 0, e("and")));
    }, n.prototype._bymonthday = function() {
      var e = this.gettext;
      this.byweekday && this.byweekday.allWeeks ? this.add(e("on")).add(this.list(this.byweekday.allWeeks, this.weekdaytext, e("or"))).add(e("the")).add(this.list(this.bymonthday, this.nth, e("or"))) : this.add(e("on the")).add(this.list(this.bymonthday, this.nth, e("and")));
    }, n.prototype._byweekday = function() {
      var e = this.gettext;
      this.byweekday.allWeeks && !this.byweekday.isWeekdays && this.add(e("on")).add(this.list(this.byweekday.allWeeks, this.weekdaytext)), this.byweekday.someWeeks && (this.byweekday.allWeeks && this.add(e("and")), this.add(e("on the")).add(this.list(this.byweekday.someWeeks, this.weekdaytext, e("and"))));
    }, n.prototype._byhour = function() {
      var e = this.gettext;
      this.add(e("at")).add(this.list(this.origOptions.byhour, void 0, e("and")));
    }, n.prototype._bymonth = function() {
      this.add(this.list(this.options.bymonth, this.monthtext, this.gettext("and")));
    }, n.prototype.nth = function(e) {
      e = parseInt(e.toString(), 10);
      var t, r = this.gettext;
      if (e === -1)
        return r("last");
      var i = Math.abs(e);
      switch (i) {
        case 1:
        case 21:
        case 31:
          t = i + r("st");
          break;
        case 2:
        case 22:
          t = i + r("nd");
          break;
        case 3:
        case 23:
          t = i + r("rd");
          break;
        default:
          t = i + r("th");
      }
      return e < 0 ? t + " " + r("last") : t;
    }, n.prototype.monthtext = function(e) {
      return this.language.monthNames[e - 1];
    }, n.prototype.weekdaytext = function(e) {
      var t = Se(e) ? (e + 1) % 7 : e.getJsWeekday();
      return (e.n ? this.nth(e.n) + " " : "") + this.language.dayNames[t];
    }, n.prototype.plural = function(e) {
      return e % 100 !== 1;
    }, n.prototype.add = function(e) {
      return this.text.push(" "), this.text.push(e), this;
    }, n.prototype.list = function(e, t, r, i) {
      var o = this;
      i === void 0 && (i = ","), ge(e) || (e = [e]);
      var a = function(l, c, u) {
        for (var f = "", d = 0; d < l.length; d++)
          d !== 0 && (d === l.length - 1 ? f += " " + u + " " : f += c + " "), f += l[d];
        return f;
      };
      t = t || function(l) {
        return l.toString();
      };
      var s = function(l) {
        return t && t.call(o, l);
      };
      return r ? a(e.map(s), i, r) : e.map(s).join(i + " ");
    }, n;
  }()
), Gh = (
  /** @class */
  function() {
    function n(e) {
      this.done = !0, this.rules = e;
    }
    return n.prototype.start = function(e) {
      return this.text = e, this.done = !1, this.nextSymbol();
    }, n.prototype.isDone = function() {
      return this.done && this.symbol === null;
    }, n.prototype.nextSymbol = function() {
      var e, t;
      this.symbol = null, this.value = null;
      do {
        if (this.done)
          return !1;
        var r = void 0;
        e = null;
        for (var i in this.rules) {
          r = this.rules[i];
          var o = r.exec(this.text);
          o && (e === null || o[0].length > e[0].length) && (e = o, t = i);
        }
        if (e != null && (this.text = this.text.substr(e[0].length), this.text === "" && (this.done = !0)), e == null) {
          this.done = !0, this.symbol = null, this.value = null;
          return;
        }
      } while (t === "SKIP");
      return this.symbol = t, this.value = e, !0;
    }, n.prototype.accept = function(e) {
      if (this.symbol === e) {
        if (this.value) {
          var t = this.value;
          return this.nextSymbol(), t;
        }
        return this.nextSymbol(), !0;
      }
      return !1;
    }, n.prototype.acceptNumber = function() {
      return this.accept("number");
    }, n.prototype.expect = function(e) {
      if (this.accept(e))
        return !0;
      throw new Error("expected " + e + " but found " + this.symbol);
    }, n;
  }()
);
function Ri(n, e) {
  e === void 0 && (e = Ct);
  var t = {}, r = new Gh(e.tokens);
  if (!r.start(n))
    return null;
  return i(), t;
  function i() {
    r.expect("every");
    var d = r.acceptNumber();
    if (d && (t.interval = parseInt(d[0], 10)), r.isDone())
      throw new Error("Unexpected end");
    switch (r.symbol) {
      case "day(s)":
        t.freq = O.DAILY, r.nextSymbol() && (a(), f());
        break;
      case "weekday(s)":
        t.freq = O.WEEKLY, t.byweekday = [O.MO, O.TU, O.WE, O.TH, O.FR], r.nextSymbol(), f();
        break;
      case "week(s)":
        t.freq = O.WEEKLY, r.nextSymbol() && (o(), f());
        break;
      case "hour(s)":
        t.freq = O.HOURLY, r.nextSymbol() && (o(), f());
        break;
      case "minute(s)":
        t.freq = O.MINUTELY, r.nextSymbol() && (o(), f());
        break;
      case "month(s)":
        t.freq = O.MONTHLY, r.nextSymbol() && (o(), f());
        break;
      case "year(s)":
        t.freq = O.YEARLY, r.nextSymbol() && (o(), f());
        break;
      case "monday":
      case "tuesday":
      case "wednesday":
      case "thursday":
      case "friday":
      case "saturday":
      case "sunday":
        t.freq = O.WEEKLY;
        var g = r.symbol.substr(0, 2).toUpperCase();
        if (t.byweekday = [O[g]], !r.nextSymbol())
          return;
        for (; r.accept("comma"); ) {
          if (r.isDone())
            throw new Error("Unexpected end");
          var p = l();
          if (!p)
            throw new Error("Unexpected symbol " + r.symbol + ", expected weekday");
          t.byweekday.push(O[p]), r.nextSymbol();
        }
        u(), f();
        break;
      case "january":
      case "february":
      case "march":
      case "april":
      case "may":
      case "june":
      case "july":
      case "august":
      case "september":
      case "october":
      case "november":
      case "december":
        if (t.freq = O.YEARLY, t.bymonth = [s()], !r.nextSymbol())
          return;
        for (; r.accept("comma"); ) {
          if (r.isDone())
            throw new Error("Unexpected end");
          var y = s();
          if (!y)
            throw new Error("Unexpected symbol " + r.symbol + ", expected month");
          t.bymonth.push(y), r.nextSymbol();
        }
        o(), f();
        break;
      default:
        throw new Error("Unknown symbol");
    }
  }
  function o() {
    var d = r.accept("on"), g = r.accept("the");
    if (d || g)
      do {
        var p = c(), y = l(), b = s();
        if (p)
          y ? (r.nextSymbol(), t.byweekday || (t.byweekday = []), t.byweekday.push(O[y].nth(p))) : (t.bymonthday || (t.bymonthday = []), t.bymonthday.push(p), r.accept("day(s)"));
        else if (y)
          r.nextSymbol(), t.byweekday || (t.byweekday = []), t.byweekday.push(O[y]);
        else if (r.symbol === "weekday(s)")
          r.nextSymbol(), t.byweekday || (t.byweekday = [O.MO, O.TU, O.WE, O.TH, O.FR]);
        else if (r.symbol === "week(s)") {
          r.nextSymbol();
          var k = r.acceptNumber();
          if (!k)
            throw new Error("Unexpected symbol " + r.symbol + ", expected week number");
          for (t.byweekno = [parseInt(k[0], 10)]; r.accept("comma"); ) {
            if (k = r.acceptNumber(), !k)
              throw new Error("Unexpected symbol " + r.symbol + "; expected monthday");
            t.byweekno.push(parseInt(k[0], 10));
          }
        } else if (b)
          r.nextSymbol(), t.bymonth || (t.bymonth = []), t.bymonth.push(b);
        else
          return;
      } while (r.accept("comma") || r.accept("the") || r.accept("on"));
  }
  function a() {
    var d = r.accept("at");
    if (d)
      do {
        var g = r.acceptNumber();
        if (!g)
          throw new Error("Unexpected symbol " + r.symbol + ", expected hour");
        for (t.byhour = [parseInt(g[0], 10)]; r.accept("comma"); ) {
          if (g = r.acceptNumber(), !g)
            throw new Error("Unexpected symbol " + r.symbol + "; expected hour");
          t.byhour.push(parseInt(g[0], 10));
        }
      } while (r.accept("comma") || r.accept("at"));
  }
  function s() {
    switch (r.symbol) {
      case "january":
        return 1;
      case "february":
        return 2;
      case "march":
        return 3;
      case "april":
        return 4;
      case "may":
        return 5;
      case "june":
        return 6;
      case "july":
        return 7;
      case "august":
        return 8;
      case "september":
        return 9;
      case "october":
        return 10;
      case "november":
        return 11;
      case "december":
        return 12;
      default:
        return !1;
    }
  }
  function l() {
    switch (r.symbol) {
      case "monday":
      case "tuesday":
      case "wednesday":
      case "thursday":
      case "friday":
      case "saturday":
      case "sunday":
        return r.symbol.substr(0, 2).toUpperCase();
      default:
        return !1;
    }
  }
  function c() {
    switch (r.symbol) {
      case "last":
        return r.nextSymbol(), -1;
      case "first":
        return r.nextSymbol(), 1;
      case "second":
        return r.nextSymbol(), r.accept("last") ? -2 : 2;
      case "third":
        return r.nextSymbol(), r.accept("last") ? -3 : 3;
      case "nth":
        var d = parseInt(r.value[1], 10);
        if (d < -366 || d > 366)
          throw new Error("Nth out of range: " + d);
        return r.nextSymbol(), r.accept("last") ? -d : d;
      default:
        return !1;
    }
  }
  function u() {
    r.accept("on"), r.accept("the");
    var d = c();
    if (d)
      for (t.bymonthday = [d], r.nextSymbol(); r.accept("comma"); ) {
        if (d = c(), !d)
          throw new Error("Unexpected symbol " + r.symbol + "; expected monthday");
        t.bymonthday.push(d), r.nextSymbol();
      }
  }
  function f() {
    if (r.symbol === "until") {
      var d = Date.parse(r.text);
      if (!d)
        throw new Error("Cannot parse until date:" + r.text);
      t.until = new Date(d);
    } else
      r.accept("for") && (t.count = parseInt(r.value[0], 10), r.expect("number"));
  }
}
var H;
(function(n) {
  n[n.YEARLY = 0] = "YEARLY", n[n.MONTHLY = 1] = "MONTHLY", n[n.WEEKLY = 2] = "WEEKLY", n[n.DAILY = 3] = "DAILY", n[n.HOURLY = 4] = "HOURLY", n[n.MINUTELY = 5] = "MINUTELY", n[n.SECONDLY = 6] = "SECONDLY";
})(H || (H = {}));
function In(n) {
  return n < H.HOURLY;
}
var Kh = function(n, e) {
  return e === void 0 && (e = Ct), new O(Ri(n, e) || void 0);
}, nt = [
  "count",
  "until",
  "interval",
  "byweekday",
  "bymonthday",
  "bymonth"
];
Ue.IMPLEMENTED = [];
Ue.IMPLEMENTED[H.HOURLY] = nt;
Ue.IMPLEMENTED[H.MINUTELY] = nt;
Ue.IMPLEMENTED[H.DAILY] = ["byhour"].concat(nt);
Ue.IMPLEMENTED[H.WEEKLY] = nt;
Ue.IMPLEMENTED[H.MONTHLY] = nt;
Ue.IMPLEMENTED[H.YEARLY] = ["byweekno", "byyearday"].concat(nt);
var qh = function(n, e, t, r) {
  return new Ue(n, e, t, r).toString();
}, Vh = Ue.isFullyConvertible, xt = (
  /** @class */
  function() {
    function n(e, t, r, i) {
      this.hour = e, this.minute = t, this.second = r, this.millisecond = i || 0;
    }
    return n.prototype.getHours = function() {
      return this.hour;
    }, n.prototype.getMinutes = function() {
      return this.minute;
    }, n.prototype.getSeconds = function() {
      return this.second;
    }, n.prototype.getMilliseconds = function() {
      return this.millisecond;
    }, n.prototype.getTime = function() {
      return (this.hour * 60 * 60 + this.minute * 60 + this.second) * 1e3 + this.millisecond;
    }, n;
  }()
), Jh = (
  /** @class */
  function(n) {
    Bn(e, n);
    function e(t, r, i, o, a, s, l) {
      var c = n.call(this, o, a, s, l) || this;
      return c.year = t, c.month = r, c.day = i, c;
    }
    return e.fromDate = function(t) {
      return new this(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate(), t.getUTCHours(), t.getUTCMinutes(), t.getUTCSeconds(), t.valueOf() % 1e3);
    }, e.prototype.getWeekday = function() {
      return tt(new Date(this.getTime()));
    }, e.prototype.getTime = function() {
      return new Date(Date.UTC(this.year, this.month - 1, this.day, this.hour, this.minute, this.second, this.millisecond)).getTime();
    }, e.prototype.getDay = function() {
      return this.day;
    }, e.prototype.getMonth = function() {
      return this.month;
    }, e.prototype.getYear = function() {
      return this.year;
    }, e.prototype.addYears = function(t) {
      this.year += t;
    }, e.prototype.addMonths = function(t) {
      if (this.month += t, this.month > 12) {
        var r = Math.floor(this.month / 12), i = ve(this.month, 12);
        this.month = i, this.year += r, this.month === 0 && (this.month = 12, --this.year);
      }
    }, e.prototype.addWeekly = function(t, r) {
      r > this.getWeekday() ? this.day += -(this.getWeekday() + 1 + (6 - r)) + t * 7 : this.day += -(this.getWeekday() - r) + t * 7, this.fixDay();
    }, e.prototype.addDaily = function(t) {
      this.day += t, this.fixDay();
    }, e.prototype.addHours = function(t, r, i) {
      for (r && (this.hour += Math.floor((23 - this.hour) / t) * t); ; ) {
        this.hour += t;
        var o = Zt(this.hour, 24), a = o.div, s = o.mod;
        if (a && (this.hour = s, this.addDaily(a)), Ce(i) || W(i, this.hour))
          break;
      }
    }, e.prototype.addMinutes = function(t, r, i, o) {
      for (r && (this.minute += Math.floor((1439 - (this.hour * 60 + this.minute)) / t) * t); ; ) {
        this.minute += t;
        var a = Zt(this.minute, 60), s = a.div, l = a.mod;
        if (s && (this.minute = l, this.addHours(s, !1, i)), (Ce(i) || W(i, this.hour)) && (Ce(o) || W(o, this.minute)))
          break;
      }
    }, e.prototype.addSeconds = function(t, r, i, o, a) {
      for (r && (this.second += Math.floor((86399 - (this.hour * 3600 + this.minute * 60 + this.second)) / t) * t); ; ) {
        this.second += t;
        var s = Zt(this.second, 60), l = s.div, c = s.mod;
        if (l && (this.second = c, this.addMinutes(l, !1, i, o)), (Ce(i) || W(i, this.hour)) && (Ce(o) || W(o, this.minute)) && (Ce(a) || W(a, this.second)))
          break;
      }
    }, e.prototype.fixDay = function() {
      if (!(this.day <= 28)) {
        var t = dr(this.year, this.month - 1)[1];
        if (!(this.day <= t))
          for (; this.day > t; ) {
            if (this.day -= t, ++this.month, this.month === 13 && (this.month = 1, ++this.year, this.year > Si))
              return;
            t = dr(this.year, this.month - 1)[1];
          }
      }
    }, e.prototype.add = function(t, r) {
      var i = t.freq, o = t.interval, a = t.wkst, s = t.byhour, l = t.byminute, c = t.bysecond;
      switch (i) {
        case H.YEARLY:
          return this.addYears(o);
        case H.MONTHLY:
          return this.addMonths(o);
        case H.WEEKLY:
          return this.addWeekly(o, a);
        case H.DAILY:
          return this.addDaily(o);
        case H.HOURLY:
          return this.addHours(o, r, s);
        case H.MINUTELY:
          return this.addMinutes(o, r, s, l);
        case H.SECONDLY:
          return this.addSeconds(o, r, s, l, c);
      }
    }, e;
  }(xt)
);
function Ai(n) {
  for (var e = [], t = Object.keys(n), r = 0, i = t; r < i.length; r++) {
    var o = i[r];
    W(Cg, o) || e.push(o), xi(n[o]) && !lt(n[o]) && e.push(o);
  }
  if (e.length)
    throw new Error("Invalid options: " + e.join(", "));
  return pe({}, n);
}
function Zh(n) {
  var e = pe(pe({}, Rn), Ai(n));
  if (te(e.byeaster) && (e.freq = O.YEARLY), !(te(e.freq) && O.FREQUENCIES[e.freq]))
    throw new Error("Invalid frequency: ".concat(e.freq, " ").concat(n.freq));
  if (e.dtstart || (e.dtstart = new Date((/* @__PURE__ */ new Date()).setMilliseconds(0))), te(e.wkst) ? Se(e.wkst) || (e.wkst = e.wkst.weekday) : e.wkst = O.MO.weekday, te(e.bysetpos)) {
    Se(e.bysetpos) && (e.bysetpos = [e.bysetpos]);
    for (var t = 0; t < e.bysetpos.length; t++) {
      var r = e.bysetpos[t];
      if (r === 0 || !(r >= -366 && r <= 366))
        throw new Error("bysetpos must be between 1 and 366, or between -366 and -1");
    }
  }
  if (!(e.byweekno || ie(e.byweekno) || ie(e.byyearday) || e.bymonthday || ie(e.bymonthday) || te(e.byweekday) || te(e.byeaster)))
    switch (e.freq) {
      case O.YEARLY:
        e.bymonth || (e.bymonth = e.dtstart.getUTCMonth() + 1), e.bymonthday = e.dtstart.getUTCDate();
        break;
      case O.MONTHLY:
        e.bymonthday = e.dtstart.getUTCDate();
        break;
      case O.WEEKLY:
        e.byweekday = [tt(e.dtstart)];
        break;
    }
  if (te(e.bymonth) && !ge(e.bymonth) && (e.bymonth = [e.bymonth]), te(e.byyearday) && !ge(e.byyearday) && Se(e.byyearday) && (e.byyearday = [e.byyearday]), !te(e.bymonthday))
    e.bymonthday = [], e.bynmonthday = [];
  else if (ge(e.bymonthday)) {
    for (var i = [], o = [], t = 0; t < e.bymonthday.length; t++) {
      var r = e.bymonthday[t];
      r > 0 ? i.push(r) : r < 0 && o.push(r);
    }
    e.bymonthday = i, e.bynmonthday = o;
  } else
    e.bymonthday < 0 ? (e.bynmonthday = [e.bymonthday], e.bymonthday = []) : (e.bynmonthday = [], e.bymonthday = [e.bymonthday]);
  if (te(e.byweekno) && !ge(e.byweekno) && (e.byweekno = [e.byweekno]), !te(e.byweekday))
    e.bynweekday = null;
  else if (Se(e.byweekday))
    e.byweekday = [e.byweekday], e.bynweekday = null;
  else if (cr(e.byweekday))
    e.byweekday = [ue.fromStr(e.byweekday).weekday], e.bynweekday = null;
  else if (e.byweekday instanceof ue)
    !e.byweekday.n || e.freq > O.MONTHLY ? (e.byweekday = [e.byweekday.weekday], e.bynweekday = null) : (e.bynweekday = [[e.byweekday.weekday, e.byweekday.n]], e.byweekday = null);
  else {
    for (var a = [], s = [], t = 0; t < e.byweekday.length; t++) {
      var l = e.byweekday[t];
      if (Se(l)) {
        a.push(l);
        continue;
      } else if (cr(l)) {
        a.push(ue.fromStr(l).weekday);
        continue;
      }
      !l.n || e.freq > O.MONTHLY ? a.push(l.weekday) : s.push([l.weekday, l.n]);
    }
    e.byweekday = ie(a) ? a : null, e.bynweekday = ie(s) ? s : null;
  }
  return te(e.byhour) ? Se(e.byhour) && (e.byhour = [e.byhour]) : e.byhour = e.freq < O.HOURLY ? [e.dtstart.getUTCHours()] : null, te(e.byminute) ? Se(e.byminute) && (e.byminute = [e.byminute]) : e.byminute = e.freq < O.MINUTELY ? [e.dtstart.getUTCMinutes()] : null, te(e.bysecond) ? Se(e.bysecond) && (e.bysecond = [e.bysecond]) : e.bysecond = e.freq < O.SECONDLY ? [e.dtstart.getUTCSeconds()] : null, { parsedOptions: e };
}
function Qh(n) {
  var e = n.dtstart.getTime() % 1e3;
  if (!In(n.freq))
    return [];
  var t = [];
  return n.byhour.forEach(function(r) {
    n.byminute.forEach(function(i) {
      n.bysecond.forEach(function(o) {
        t.push(new xt(r, i, o, e));
      });
    });
  }), t;
}
function gn(n) {
  var e = n.split(`
`).map(Xh).filter(function(t) {
    return t !== null;
  });
  return pe(pe({}, e[0]), e[1]);
}
function Bt(n) {
  var e = {}, t = /DTSTART(?:;TZID=([^:=]+?))?(?::|=)([^;\s]+)/i.exec(n);
  if (!t)
    return e;
  var r = t[1], i = t[2];
  return r && (e.tzid = r), e.dtstart = xn(i), e;
}
function Xh(n) {
  if (n = n.replace(/^\s+|\s+$/, ""), !n.length)
    return null;
  var e = /^([A-Z]+?)[:;]/.exec(n.toUpperCase());
  if (!e)
    return mr(n);
  var t = e[1];
  switch (t.toUpperCase()) {
    case "RRULE":
    case "EXRULE":
      return mr(n);
    case "DTSTART":
      return Bt(n);
    default:
      throw new Error("Unsupported RFC prop ".concat(t, " in ").concat(n));
  }
}
function mr(n) {
  var e = n.replace(/^RRULE:/i, ""), t = Bt(e), r = n.replace(/^(?:RRULE|EXRULE):/i, "").split(";");
  return r.forEach(function(i) {
    var o = i.split("="), a = o[0], s = o[1];
    switch (a.toUpperCase()) {
      case "FREQ":
        t.freq = H[s.toUpperCase()];
        break;
      case "WKST":
        t.wkst = we[s.toUpperCase()];
        break;
      case "COUNT":
      case "INTERVAL":
      case "BYSETPOS":
      case "BYMONTH":
      case "BYMONTHDAY":
      case "BYYEARDAY":
      case "BYWEEKNO":
      case "BYHOUR":
      case "BYMINUTE":
      case "BYSECOND":
        var l = eg(s), c = a.toLowerCase();
        t[c] = l;
        break;
      case "BYWEEKDAY":
      case "BYDAY":
        t.byweekday = tg(s);
        break;
      case "DTSTART":
      case "TZID":
        var u = Bt(n);
        t.tzid = u.tzid, t.dtstart = u.dtstart;
        break;
      case "UNTIL":
        t.until = xn(s);
        break;
      case "BYEASTER":
        t.byeaster = Number(s);
        break;
      default:
        throw new Error("Unknown RRULE property '" + a + "'");
    }
  }), t;
}
function eg(n) {
  if (n.indexOf(",") !== -1) {
    var e = n.split(",");
    return e.map(yr);
  }
  return yr(n);
}
function yr(n) {
  return /^[+-]?\d+$/.test(n) ? Number(n) : n;
}
function tg(n) {
  var e = n.split(",");
  return e.map(function(t) {
    if (t.length === 2)
      return we[t];
    var r = t.match(/^([+-]?\d{1,2})([A-Z]{2})$/);
    if (!r || r.length < 3)
      throw new SyntaxError("Invalid weekday string: ".concat(t));
    var i = Number(r[1]), o = r[2], a = we[o].weekday;
    return new ue(a, i);
  });
}
var It = (
  /** @class */
  function() {
    function n(e, t) {
      if (isNaN(e.getTime()))
        throw new RangeError("Invalid date passed to DateWithZone");
      this.date = e, this.tzid = t;
    }
    return Object.defineProperty(n.prototype, "isUTC", {
      get: function() {
        return !this.tzid || this.tzid.toUpperCase() === "UTC";
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.toString = function() {
      var e = Cn(this.date.getTime(), this.isUTC);
      return this.isUTC ? ":".concat(e) : ";TZID=".concat(this.tzid, ":").concat(e);
    }, n.prototype.getTime = function() {
      return this.date.getTime();
    }, n.prototype.rezonedDate = function() {
      return this.isUTC ? this.date : jh(this.date, this.tzid);
    }, n;
  }()
);
function pn(n) {
  for (var e = [], t = "", r = Object.keys(n), i = Object.keys(Rn), o = 0; o < r.length; o++)
    if (r[o] !== "tzid" && W(i, r[o])) {
      var a = r[o].toUpperCase(), s = n[r[o]], l = "";
      if (!(!te(s) || ge(s) && !s.length)) {
        switch (a) {
          case "FREQ":
            l = O.FREQUENCIES[n.freq];
            break;
          case "WKST":
            Se(s) ? l = new ue(s).toString() : l = s.toString();
            break;
          case "BYWEEKDAY":
            a = "BYDAY", l = Lh(s).map(function(g) {
              return g instanceof ue ? g : ge(g) ? new ue(g[0], g[1]) : new ue(g);
            }).toString();
            break;
          case "DTSTART":
            t = ng(s, n.tzid);
            break;
          case "UNTIL":
            l = Cn(s, !n.tzid);
            break;
          default:
            if (ge(s)) {
              for (var c = [], u = 0; u < s.length; u++)
                c[u] = String(s[u]);
              l = c.toString();
            } else
              l = String(s);
        }
        l && e.push([a, l]);
      }
    }
  var f = e.map(function(g) {
    var p = g[0], y = g[1];
    return "".concat(p, "=").concat(y.toString());
  }).join(";"), d = "";
  return f !== "" && (d = "RRULE:".concat(f)), [t, d].filter(function(g) {
    return !!g;
  }).join(`
`);
}
function ng(n, e) {
  return n ? "DTSTART" + new It(new Date(n), e).toString() : "";
}
function rg(n, e) {
  return Array.isArray(n) ? !Array.isArray(e) || n.length !== e.length ? !1 : n.every(function(t, r) {
    return t.getTime() === e[r].getTime();
  }) : n instanceof Date ? e instanceof Date && n.getTime() === e.getTime() : n === e;
}
var ig = (
  /** @class */
  function() {
    function n() {
      this.all = !1, this.before = [], this.after = [], this.between = [];
    }
    return n.prototype._cacheAdd = function(e, t, r) {
      t && (t = t instanceof Date ? fn(t) : fr(t)), e === "all" ? this.all = t : (r._value = t, this[e].push(r));
    }, n.prototype._cacheGet = function(e, t) {
      var r = !1, i = t ? Object.keys(t) : [], o = function(u) {
        for (var f = 0; f < i.length; f++) {
          var d = i[f];
          if (!rg(t[d], u[d]))
            return !0;
        }
        return !1;
      }, a = this[e];
      if (e === "all")
        r = this.all;
      else if (ge(a))
        for (var s = 0; s < a.length; s++) {
          var l = a[s];
          if (!(i.length && o(l))) {
            r = l._value;
            break;
          }
        }
      if (!r && this.all) {
        for (var c = new et(e, t), s = 0; s < this.all.length && c.accept(this.all[s]); s++)
          ;
        r = c.getValue(), this._cacheAdd(e, r, t);
      }
      return ge(r) ? fr(r) : r instanceof Date ? fn(r) : r;
    }, n;
  }()
), og = T(T(T(T(T(T(T(T(T(T(T(T(T([], U(1, 31), !0), U(2, 28), !0), U(3, 31), !0), U(4, 30), !0), U(5, 31), !0), U(6, 30), !0), U(7, 31), !0), U(8, 31), !0), U(9, 30), !0), U(10, 31), !0), U(11, 30), !0), U(12, 31), !0), U(1, 7), !0), ag = T(T(T(T(T(T(T(T(T(T(T(T(T([], U(1, 31), !0), U(2, 29), !0), U(3, 31), !0), U(4, 30), !0), U(5, 31), !0), U(6, 30), !0), U(7, 31), !0), U(8, 31), !0), U(9, 30), !0), U(10, 31), !0), U(11, 30), !0), U(12, 31), !0), U(1, 7), !0), sg = Ae(1, 29), lg = Ae(1, 30), He = Ae(1, 31), ae = Ae(1, 32), cg = T(T(T(T(T(T(T(T(T(T(T(T(T([], ae, !0), lg, !0), ae, !0), He, !0), ae, !0), He, !0), ae, !0), ae, !0), He, !0), ae, !0), He, !0), ae, !0), ae.slice(0, 7), !0), ug = T(T(T(T(T(T(T(T(T(T(T(T(T([], ae, !0), sg, !0), ae, !0), He, !0), ae, !0), He, !0), ae, !0), ae, !0), He, !0), ae, !0), He, !0), ae, !0), ae.slice(0, 7), !0), dg = Ae(-28, 0), fg = Ae(-29, 0), Ye = Ae(-30, 0), se = Ae(-31, 0), hg = T(T(T(T(T(T(T(T(T(T(T(T(T([], se, !0), fg, !0), se, !0), Ye, !0), se, !0), Ye, !0), se, !0), se, !0), Ye, !0), se, !0), Ye, !0), se, !0), se.slice(0, 7), !0), gg = T(T(T(T(T(T(T(T(T(T(T(T(T([], se, !0), dg, !0), se, !0), Ye, !0), se, !0), Ye, !0), se, !0), se, !0), Ye, !0), se, !0), Ye, !0), se, !0), se.slice(0, 7), !0), pg = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366], mg = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365], br = function() {
  for (var n = [], e = 0; e < 55; e++)
    n = n.concat(Ae(7));
  return n;
}();
function yg(n, e) {
  var t = We(n, 1, 1), r = ct(n) ? 366 : 365, i = ct(n + 1) ? 366 : 365, o = dn(t), a = tt(t), s = pe(pe({ yearlen: r, nextyearlen: i, yearordinal: o, yearweekday: a }, bg(n)), { wnomask: null });
  if (Ce(e.byweekno))
    return s;
  s.wnomask = U(0, r + 7);
  var l, c, u = l = ve(7 - a + e.wkst, 7);
  u >= 4 ? (u = 0, c = s.yearlen + ve(a - e.wkst, 7)) : c = r - u;
  for (var f = Math.floor(c / 7), d = ve(c, 7), g = Math.floor(f + d / 4), p = 0; p < e.byweekno.length; p++) {
    var y = e.byweekno[p];
    if (y < 0 && (y += g + 1), y > 0 && y <= g) {
      var b = void 0;
      y > 1 ? (b = u + (y - 1) * 7, u !== l && (b -= 7 - l)) : b = u;
      for (var k = 0; k < 7 && (s.wnomask[b] = 1, b++, s.wdaymask[b] !== e.wkst); k++)
        ;
    }
  }
  if (W(e.byweekno, 1)) {
    var b = u + g * 7;
    if (u !== l && (b -= 7 - l), b < r)
      for (var p = 0; p < 7 && (s.wnomask[b] = 1, b += 1, s.wdaymask[b] !== e.wkst); p++)
        ;
  }
  if (u) {
    var x = void 0;
    if (W(e.byweekno, -1))
      x = -1;
    else {
      var Q = tt(We(n - 1, 1, 1)), F = ve(7 - Q.valueOf() + e.wkst, 7), K = ct(n - 1) ? 366 : 365, j = void 0;
      F >= 4 ? (F = 0, j = K + ve(Q - e.wkst, 7)) : j = r - u, x = Math.floor(52 + ve(j, 7) / 4);
    }
    if (W(e.byweekno, x))
      for (var b = 0; b < u; b++)
        s.wnomask[b] = 1;
  }
  return s;
}
function bg(n) {
  var e = ct(n) ? 366 : 365, t = We(n, 1, 1), r = tt(t);
  return e === 365 ? {
    mmask: og,
    mdaymask: ug,
    nmdaymask: gg,
    wdaymask: br.slice(r),
    mrange: mg
  } : {
    mmask: ag,
    mdaymask: cg,
    nmdaymask: hg,
    wdaymask: br.slice(r),
    mrange: pg
  };
}
function vg(n, e, t, r, i, o) {
  var a = {
    lastyear: n,
    lastmonth: e,
    nwdaymask: []
  }, s = [];
  if (o.freq === O.YEARLY)
    if (Ce(o.bymonth))
      s = [[0, t]];
    else
      for (var l = 0; l < o.bymonth.length; l++)
        e = o.bymonth[l], s.push(r.slice(e - 1, e + 1));
  else
    o.freq === O.MONTHLY && (s = [r.slice(e - 1, e + 1)]);
  if (Ce(s))
    return a;
  a.nwdaymask = U(0, t);
  for (var l = 0; l < s.length; l++)
    for (var c = s[l], u = c[0], f = c[1] - 1, d = 0; d < o.bynweekday.length; d++) {
      var g = void 0, p = o.bynweekday[d], y = p[0], b = p[1];
      b < 0 ? (g = f + (b + 1) * 7, g -= ve(i[g] - y, 7)) : (g = u + (b - 1) * 7, g += ve(7 - i[g] + y, 7)), u <= g && g <= f && (a.nwdaymask[g] = 1);
    }
  return a;
}
function Eg(n, e) {
  e === void 0 && (e = 0);
  var t = n % 19, r = Math.floor(n / 100), i = n % 100, o = Math.floor(r / 4), a = r % 4, s = Math.floor((r + 8) / 25), l = Math.floor((r - s + 1) / 3), c = Math.floor(19 * t + r - o - l + 15) % 30, u = Math.floor(i / 4), f = i % 4, d = Math.floor(32 + 2 * a + 2 * u - c - f) % 7, g = Math.floor((t + 11 * c + 22 * d) / 451), p = Math.floor((c + d - 7 * g + 114) / 31), y = (c + d - 7 * g + 114) % 31 + 1, b = Date.UTC(n, p - 1, y + e), k = Date.UTC(n, 0, 1);
  return [Math.ceil((b - k) / (1e3 * 60 * 60 * 24))];
}
var kg = (
  /** @class */
  function() {
    function n(e) {
      this.options = e;
    }
    return n.prototype.rebuild = function(e, t) {
      var r = this.options;
      if (e !== this.lastyear && (this.yearinfo = yg(e, r)), ie(r.bynweekday) && (t !== this.lastmonth || e !== this.lastyear)) {
        var i = this.yearinfo, o = i.yearlen, a = i.mrange, s = i.wdaymask;
        this.monthinfo = vg(e, t, o, a, s, r);
      }
      te(r.byeaster) && (this.eastermask = Eg(e, r.byeaster));
    }, Object.defineProperty(n.prototype, "lastyear", {
      get: function() {
        return this.monthinfo ? this.monthinfo.lastyear : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "lastmonth", {
      get: function() {
        return this.monthinfo ? this.monthinfo.lastmonth : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "yearlen", {
      get: function() {
        return this.yearinfo.yearlen;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "yearordinal", {
      get: function() {
        return this.yearinfo.yearordinal;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "mrange", {
      get: function() {
        return this.yearinfo.mrange;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "wdaymask", {
      get: function() {
        return this.yearinfo.wdaymask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "mmask", {
      get: function() {
        return this.yearinfo.mmask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "wnomask", {
      get: function() {
        return this.yearinfo.wnomask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "nwdaymask", {
      get: function() {
        return this.monthinfo ? this.monthinfo.nwdaymask : [];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "nextyearlen", {
      get: function() {
        return this.yearinfo.nextyearlen;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "mdaymask", {
      get: function() {
        return this.yearinfo.mdaymask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "nmdaymask", {
      get: function() {
        return this.yearinfo.nmdaymask;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.ydayset = function() {
      return [Ae(this.yearlen), 0, this.yearlen];
    }, n.prototype.mdayset = function(e, t) {
      for (var r = this.mrange[t - 1], i = this.mrange[t], o = U(null, this.yearlen), a = r; a < i; a++)
        o[a] = a;
      return [o, r, i];
    }, n.prototype.wdayset = function(e, t, r) {
      for (var i = U(null, this.yearlen + 7), o = dn(We(e, t, r)) - this.yearordinal, a = o, s = 0; s < 7 && (i[o] = o, ++o, this.wdaymask[o] !== this.options.wkst); s++)
        ;
      return [i, a, o];
    }, n.prototype.ddayset = function(e, t, r) {
      var i = U(null, this.yearlen), o = dn(We(e, t, r)) - this.yearordinal;
      return i[o] = o, [i, o, o + 1];
    }, n.prototype.htimeset = function(e, t, r, i) {
      var o = this, a = [];
      return this.options.byminute.forEach(function(s) {
        a = a.concat(o.mtimeset(e, s, r, i));
      }), ft(a), a;
    }, n.prototype.mtimeset = function(e, t, r, i) {
      var o = this.options.bysecond.map(function(a) {
        return new xt(e, t, a, i);
      });
      return ft(o), o;
    }, n.prototype.stimeset = function(e, t, r, i) {
      return [new xt(e, t, r, i)];
    }, n.prototype.getdayset = function(e) {
      switch (e) {
        case H.YEARLY:
          return this.ydayset.bind(this);
        case H.MONTHLY:
          return this.mdayset.bind(this);
        case H.WEEKLY:
          return this.wdayset.bind(this);
        case H.DAILY:
          return this.ddayset.bind(this);
        default:
          return this.ddayset.bind(this);
      }
    }, n.prototype.gettimeset = function(e) {
      switch (e) {
        case H.HOURLY:
          return this.htimeset.bind(this);
        case H.MINUTELY:
          return this.mtimeset.bind(this);
        case H.SECONDLY:
          return this.stimeset.bind(this);
      }
    }, n;
  }()
);
function $g(n, e, t, r, i, o) {
  for (var a = [], s = 0; s < n.length; s++) {
    var l = void 0, c = void 0, u = n[s];
    u < 0 ? (l = Math.floor(u / e.length), c = ve(u, e.length)) : (l = Math.floor((u - 1) / e.length), c = ve(u - 1, e.length));
    for (var f = [], d = t; d < r; d++) {
      var g = o[d];
      te(g) && f.push(g);
    }
    var p = void 0;
    l < 0 ? p = f.slice(l)[0] : p = f[l];
    var y = e[c], b = Bi(i.yearordinal + p), k = Ii(b, y);
    W(a, k) || a.push(k);
  }
  return ft(a), a;
}
function Mi(n, e) {
  var t = e.dtstart, r = e.freq, i = e.interval, o = e.until, a = e.bysetpos, s = e.count;
  if (s === 0 || i === 0)
    return Ne(n);
  var l = Jh.fromDate(t), c = new kg(e);
  c.rebuild(l.year, l.month);
  for (var u = Sg(c, l, e); ; ) {
    var f = c.getdayset(r)(l.year, l.month, l.day), d = f[0], g = f[1], p = f[2], y = Tg(d, g, p, c, e);
    if (ie(a))
      for (var b = $g(a, u, g, p, c, d), k = 0; k < b.length; k++) {
        var x = b[k];
        if (o && x > o)
          return Ne(n);
        if (x >= t) {
          var Q = vr(x, e);
          if (!n.accept(Q) || s && (--s, !s))
            return Ne(n);
        }
      }
    else
      for (var k = g; k < p; k++) {
        var F = d[k];
        if (te(F))
          for (var K = Bi(c.yearordinal + F), j = 0; j < u.length; j++) {
            var V = u[j], x = Ii(K, V);
            if (o && x > o)
              return Ne(n);
            if (x >= t) {
              var Q = vr(x, e);
              if (!n.accept(Q) || s && (--s, !s))
                return Ne(n);
            }
          }
      }
    if (e.interval === 0 || (l.add(e, y), l.year > Si))
      return Ne(n);
    In(r) || (u = c.gettimeset(r)(l.hour, l.minute, l.second, 0)), c.rebuild(l.year, l.month);
  }
}
function wg(n, e, t) {
  var r = t.bymonth, i = t.byweekno, o = t.byweekday, a = t.byeaster, s = t.bymonthday, l = t.bynmonthday, c = t.byyearday;
  return ie(r) && !W(r, n.mmask[e]) || ie(i) && !n.wnomask[e] || ie(o) && !W(o, n.wdaymask[e]) || ie(n.nwdaymask) && !n.nwdaymask[e] || a !== null && !W(n.eastermask, e) || (ie(s) || ie(l)) && !W(s, n.mdaymask[e]) && !W(l, n.nmdaymask[e]) || ie(c) && (e < n.yearlen && !W(c, e + 1) && !W(c, -n.yearlen + e) || e >= n.yearlen && !W(c, e + 1 - n.yearlen) && !W(c, -n.nextyearlen + e - n.yearlen));
}
function vr(n, e) {
  return new It(n, e.tzid).rezonedDate();
}
function Ne(n) {
  return n.getValue();
}
function Tg(n, e, t, r, i) {
  for (var o = !1, a = e; a < t; a++) {
    var s = n[a];
    o = wg(r, s, i), o && (n[s] = null);
  }
  return o;
}
function Sg(n, e, t) {
  var r = t.freq, i = t.byhour, o = t.byminute, a = t.bysecond;
  return In(r) ? Qh(t) : r >= O.HOURLY && ie(i) && !W(i, e.hour) || r >= O.MINUTELY && ie(o) && !W(o, e.minute) || r >= O.SECONDLY && ie(a) && !W(a, e.second) ? [] : n.gettimeset(r)(e.hour, e.minute, e.second, e.millisecond);
}
var we = {
  MO: new ue(0),
  TU: new ue(1),
  WE: new ue(2),
  TH: new ue(3),
  FR: new ue(4),
  SA: new ue(5),
  SU: new ue(6)
}, Rn = {
  freq: H.YEARLY,
  dtstart: null,
  interval: 1,
  wkst: we.MO,
  count: null,
  until: null,
  tzid: null,
  bysetpos: null,
  bymonth: null,
  bymonthday: null,
  bynmonthday: null,
  byyearday: null,
  byweekno: null,
  byweekday: null,
  bynweekday: null,
  byhour: null,
  byminute: null,
  bysecond: null,
  byeaster: null
}, Cg = Object.keys(Rn), O = (
  /** @class */
  function() {
    function n(e, t) {
      e === void 0 && (e = {}), t === void 0 && (t = !1), this._cache = t ? null : new ig(), this.origOptions = Ai(e);
      var r = Zh(e).parsedOptions;
      this.options = r;
    }
    return n.parseText = function(e, t) {
      return Ri(e, t);
    }, n.fromText = function(e, t) {
      return Kh(e, t);
    }, n.fromString = function(e) {
      return new n(n.parseString(e) || void 0);
    }, n.prototype._iter = function(e) {
      return Mi(e, this.options);
    }, n.prototype._cacheGet = function(e, t) {
      return this._cache ? this._cache._cacheGet(e, t) : !1;
    }, n.prototype._cacheAdd = function(e, t, r) {
      if (this._cache)
        return this._cache._cacheAdd(e, t, r);
    }, n.prototype.all = function(e) {
      if (e)
        return this._iter(new gr("all", {}, e));
      var t = this._cacheGet("all");
      return t === !1 && (t = this._iter(new et("all", {})), this._cacheAdd("all", t)), t;
    }, n.prototype.between = function(e, t, r, i) {
      if (r === void 0 && (r = !1), !lt(e) || !lt(t))
        throw new Error("Invalid date passed in to RRule.between");
      var o = {
        before: t,
        after: e,
        inc: r
      };
      if (i)
        return this._iter(new gr("between", o, i));
      var a = this._cacheGet("between", o);
      return a === !1 && (a = this._iter(new et("between", o)), this._cacheAdd("between", a, o)), a;
    }, n.prototype.before = function(e, t) {
      if (t === void 0 && (t = !1), !lt(e))
        throw new Error("Invalid date passed in to RRule.before");
      var r = { dt: e, inc: t }, i = this._cacheGet("before", r);
      return i === !1 && (i = this._iter(new et("before", r)), this._cacheAdd("before", i, r)), i;
    }, n.prototype.after = function(e, t) {
      if (t === void 0 && (t = !1), !lt(e))
        throw new Error("Invalid date passed in to RRule.after");
      var r = { dt: e, inc: t }, i = this._cacheGet("after", r);
      return i === !1 && (i = this._iter(new et("after", r)), this._cacheAdd("after", i, r)), i;
    }, n.prototype.count = function() {
      return this.all().length;
    }, n.prototype.toString = function() {
      return pn(this.origOptions);
    }, n.prototype.toText = function(e, t, r) {
      return qh(this, e, t, r);
    }, n.prototype.isFullyConvertibleToText = function() {
      return Vh(this);
    }, n.prototype.clone = function() {
      return new n(this.origOptions);
    }, n.FREQUENCIES = [
      "YEARLY",
      "MONTHLY",
      "WEEKLY",
      "DAILY",
      "HOURLY",
      "MINUTELY",
      "SECONDLY"
    ], n.YEARLY = H.YEARLY, n.MONTHLY = H.MONTHLY, n.WEEKLY = H.WEEKLY, n.DAILY = H.DAILY, n.HOURLY = H.HOURLY, n.MINUTELY = H.MINUTELY, n.SECONDLY = H.SECONDLY, n.MO = we.MO, n.TU = we.TU, n.WE = we.WE, n.TH = we.TH, n.FR = we.FR, n.SA = we.SA, n.SU = we.SU, n.parseString = gn, n.optionsToString = pn, n;
  }()
);
function xg(n, e, t, r, i, o) {
  var a = {}, s = n.accept;
  function l(d, g) {
    t.forEach(function(p) {
      p.between(d, g, !0).forEach(function(y) {
        a[Number(y)] = !0;
      });
    });
  }
  i.forEach(function(d) {
    var g = new It(d, o).rezonedDate();
    a[Number(g)] = !0;
  }), n.accept = function(d) {
    var g = Number(d);
    return isNaN(g) ? s.call(this, d) : !a[g] && (l(new Date(g - 1), new Date(g + 1)), !a[g]) ? (a[g] = !0, s.call(this, d)) : !0;
  }, n.method === "between" && (l(n.args.after, n.args.before), n.accept = function(d) {
    var g = Number(d);
    return a[g] ? !0 : (a[g] = !0, s.call(this, d));
  });
  for (var c = 0; c < r.length; c++) {
    var u = new It(r[c], o).rezonedDate();
    if (!n.accept(new Date(u.getTime())))
      break;
  }
  e.forEach(function(d) {
    Mi(n, d.options);
  });
  var f = n._result;
  switch (ft(f), n.method) {
    case "all":
    case "between":
      return f;
    case "before":
      return f.length && f[f.length - 1] || null;
    case "after":
    default:
      return f.length && f[0] || null;
  }
}
var Er = {
  dtstart: null,
  cache: !1,
  unfold: !1,
  forceset: !1,
  compatible: !1,
  tzid: null
};
function Bg(n, e) {
  var t = [], r = [], i = [], o = [], a = Bt(n), s = a.dtstart, l = a.tzid, c = Og(n, e.unfold);
  return c.forEach(function(u) {
    var f;
    if (u) {
      var d = Mg(u), g = d.name, p = d.parms, y = d.value;
      switch (g.toUpperCase()) {
        case "RRULE":
          if (p.length)
            throw new Error("unsupported RRULE parm: ".concat(p.join(",")));
          t.push(gn(u));
          break;
        case "RDATE":
          var b = (f = /RDATE(?:;TZID=([^:=]+))?/i.exec(u)) !== null && f !== void 0 ? f : [], k = b[1];
          k && !l && (l = k), r = r.concat($r(y, p));
          break;
        case "EXRULE":
          if (p.length)
            throw new Error("unsupported EXRULE parm: ".concat(p.join(",")));
          i.push(gn(y));
          break;
        case "EXDATE":
          o = o.concat($r(y, p));
          break;
        case "DTSTART":
          break;
        default:
          throw new Error("unsupported property: " + g);
      }
    }
  }), {
    dtstart: s,
    tzid: l,
    rrulevals: t,
    rdatevals: r,
    exrulevals: i,
    exdatevals: o
  };
}
function Ig(n, e) {
  var t = Bg(n, e), r = t.rrulevals, i = t.rdatevals, o = t.exrulevals, a = t.exdatevals, s = t.dtstart, l = t.tzid, c = e.cache === !1;
  if (e.compatible && (e.forceset = !0, e.unfold = !0), e.forceset || r.length > 1 || i.length || o.length || a.length) {
    var u = new Ng(c);
    return u.dtstart(s), u.tzid(l || void 0), r.forEach(function(d) {
      u.rrule(new O(Qt(d, s, l), c));
    }), i.forEach(function(d) {
      u.rdate(d);
    }), o.forEach(function(d) {
      u.exrule(new O(Qt(d, s, l), c));
    }), a.forEach(function(d) {
      u.exdate(d);
    }), e.compatible && e.dtstart && u.rdate(s), u;
  }
  var f = r[0] || {};
  return new O(Qt(f, f.dtstart || e.dtstart || s, f.tzid || e.tzid || l), c);
}
function kr(n, e) {
  return e === void 0 && (e = {}), Ig(n, Rg(e));
}
function Qt(n, e, t) {
  return pe(pe({}, n), { dtstart: e, tzid: t });
}
function Rg(n) {
  var e = [], t = Object.keys(n), r = Object.keys(Er);
  if (t.forEach(function(i) {
    W(r, i) || e.push(i);
  }), e.length)
    throw new Error("Invalid options: " + e.join(", "));
  return pe(pe({}, Er), n);
}
function Ag(n) {
  if (n.indexOf(":") === -1)
    return {
      name: "RRULE",
      value: n
    };
  var e = Ph(n, ":", 1), t = e[0], r = e[1];
  return {
    name: t,
    value: r
  };
}
function Mg(n) {
  var e = Ag(n), t = e.name, r = e.value, i = t.split(";");
  if (!i)
    throw new Error("empty property name");
  return {
    name: i[0].toUpperCase(),
    parms: i.slice(1),
    value: r
  };
}
function Og(n, e) {
  if (e === void 0 && (e = !1), n = n && n.trim(), !n)
    throw new Error("Invalid empty string");
  if (!e)
    return n.split(/\s/);
  for (var t = n.split(`
`), r = 0; r < t.length; ) {
    var i = t[r] = t[r].replace(/\s+$/g, "");
    i ? r > 0 && i[0] === " " ? (t[r - 1] += i.slice(1), t.splice(r, 1)) : r += 1 : t.splice(r, 1);
  }
  return t;
}
function Dg(n) {
  n.forEach(function(e) {
    if (!/(VALUE=DATE(-TIME)?)|(TZID=)/.test(e))
      throw new Error("unsupported RDATE/EXDATE parm: " + e);
  });
}
function $r(n, e) {
  return Dg(e), n.split(",").map(function(t) {
    return xn(t);
  });
}
function wr(n) {
  var e = this;
  return function(t) {
    if (t !== void 0 && (e["_".concat(n)] = t), e["_".concat(n)] !== void 0)
      return e["_".concat(n)];
    for (var r = 0; r < e._rrule.length; r++) {
      var i = e._rrule[r].origOptions[n];
      if (i)
        return i;
    }
  };
}
var Ng = (
  /** @class */
  function(n) {
    Bn(e, n);
    function e(t) {
      t === void 0 && (t = !1);
      var r = n.call(this, {}, t) || this;
      return r.dtstart = wr.apply(r, ["dtstart"]), r.tzid = wr.apply(r, ["tzid"]), r._rrule = [], r._rdate = [], r._exrule = [], r._exdate = [], r;
    }
    return e.prototype._iter = function(t) {
      return xg(t, this._rrule, this._exrule, this._rdate, this._exdate, this.tzid());
    }, e.prototype.rrule = function(t) {
      Tr(t, this._rrule);
    }, e.prototype.exrule = function(t) {
      Tr(t, this._exrule);
    }, e.prototype.rdate = function(t) {
      Sr(t, this._rdate);
    }, e.prototype.exdate = function(t) {
      Sr(t, this._exdate);
    }, e.prototype.rrules = function() {
      return this._rrule.map(function(t) {
        return kr(t.toString());
      });
    }, e.prototype.exrules = function() {
      return this._exrule.map(function(t) {
        return kr(t.toString());
      });
    }, e.prototype.rdates = function() {
      return this._rdate.map(function(t) {
        return new Date(t.getTime());
      });
    }, e.prototype.exdates = function() {
      return this._exdate.map(function(t) {
        return new Date(t.getTime());
      });
    }, e.prototype.valueOf = function() {
      var t = [];
      return !this._rrule.length && this._dtstart && (t = t.concat(pn({ dtstart: this._dtstart }))), this._rrule.forEach(function(r) {
        t = t.concat(r.toString().split(`
`));
      }), this._exrule.forEach(function(r) {
        t = t.concat(r.toString().split(`
`).map(function(i) {
          return i.replace(/^RRULE:/, "EXRULE:");
        }).filter(function(i) {
          return !/^DTSTART/.test(i);
        }));
      }), this._rdate.length && t.push(Cr("RDATE", this._rdate, this.tzid())), this._exdate.length && t.push(Cr("EXDATE", this._exdate, this.tzid())), t;
    }, e.prototype.toString = function() {
      return this.valueOf().join(`
`);
    }, e.prototype.clone = function() {
      var t = new e(!!this._cache);
      return this._rrule.forEach(function(r) {
        return t.rrule(r.clone());
      }), this._exrule.forEach(function(r) {
        return t.exrule(r.clone());
      }), this._rdate.forEach(function(r) {
        return t.rdate(new Date(r.getTime()));
      }), this._exdate.forEach(function(r) {
        return t.exdate(new Date(r.getTime()));
      }), t;
    }, e;
  }(O)
);
function Tr(n, e) {
  if (!(n instanceof O))
    throw new TypeError(String(n) + " is not RRule instance");
  W(e.map(String), String(n)) || e.push(n);
}
function Sr(n, e) {
  if (!(n instanceof Date))
    throw new TypeError(String(n) + " is not Date instance");
  W(e.map(Number), Number(n)) || (e.push(n), ft(e));
}
function Cr(n, e, t) {
  var r = !t || t.toUpperCase() === "UTC", i = r ? "".concat(n, ":") : "".concat(n, ";TZID=").concat(t, ":"), o = e.map(function(a) {
    return Cn(a.valueOf(), r);
  }).join(",");
  return "".concat(i).concat(o);
}
const Fg = {
  type: "logger",
  log(n) {
    this.output("log", n);
  },
  warn(n) {
    this.output("warn", n);
  },
  error(n) {
    this.output("error", n);
  },
  output(n, e) {
    console && console[n] && console[n].apply(console, e);
  }
};
class Rt {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, t);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = t.prefix || "i18next:", this.logger = e || Fg, this.options = t, this.debug = t.debug;
  }
  log() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, t, r, i) {
    return i && !this.debug ? null : (typeof e[0] == "string" && (e[0] = `${r}${this.prefix} ${e[0]}`), this.logger[t](e));
  }
  create(e) {
    return new Rt(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new Rt(this.logger, e);
  }
}
var Be = new Rt();
class Ht {
  constructor() {
    this.observers = {};
  }
  on(e, t) {
    return e.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const i = this.observers[r].get(t) || 0;
      this.observers[r].set(t, i + 1);
    }), this;
  }
  off(e, t) {
    if (this.observers[e]) {
      if (!t) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(t);
    }
  }
  emit(e) {
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
      r[i - 1] = arguments[i];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((a) => {
      let [s, l] = a;
      for (let c = 0; c < l; c++)
        s(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((a) => {
      let [s, l] = a;
      for (let c = 0; c < l; c++)
        s.apply(s, [e, ...r]);
    });
  }
}
function ot() {
  let n, e;
  const t = new Promise((r, i) => {
    n = r, e = i;
  });
  return t.resolve = n, t.reject = e, t;
}
function xr(n) {
  return n == null ? "" : "" + n;
}
function Lg(n, e, t) {
  n.forEach((r) => {
    e[r] && (t[r] = e[r]);
  });
}
const Pg = /###/g;
function ut(n, e, t) {
  function r(s) {
    return s && s.indexOf("###") > -1 ? s.replace(Pg, ".") : s;
  }
  function i() {
    return !n || typeof n == "string";
  }
  const o = typeof e != "string" ? e : e.split(".");
  let a = 0;
  for (; a < o.length - 1; ) {
    if (i())
      return {};
    const s = r(o[a]);
    !n[s] && t && (n[s] = new t()), Object.prototype.hasOwnProperty.call(n, s) ? n = n[s] : n = {}, ++a;
  }
  return i() ? {} : {
    obj: n,
    k: r(o[a])
  };
}
function Br(n, e, t) {
  const {
    obj: r,
    k: i
  } = ut(n, e, Object);
  if (r !== void 0 || e.length === 1) {
    r[i] = t;
    return;
  }
  let o = e[e.length - 1], a = e.slice(0, e.length - 1), s = ut(n, a, Object);
  for (; s.obj === void 0 && a.length; )
    o = `${a[a.length - 1]}.${o}`, a = a.slice(0, a.length - 1), s = ut(n, a, Object), s && s.obj && typeof s.obj[`${s.k}.${o}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${o}`] = t;
}
function _g(n, e, t, r) {
  const {
    obj: i,
    k: o
  } = ut(n, e, Object);
  i[o] = i[o] || [], r && (i[o] = i[o].concat(t)), r || i[o].push(t);
}
function At(n, e) {
  const {
    obj: t,
    k: r
  } = ut(n, e);
  if (t)
    return t[r];
}
function Ug(n, e, t) {
  const r = At(n, t);
  return r !== void 0 ? r : At(e, t);
}
function Oi(n, e, t) {
  for (const r in e)
    r !== "__proto__" && r !== "constructor" && (r in n ? typeof n[r] == "string" || n[r] instanceof String || typeof e[r] == "string" || e[r] instanceof String ? t && (n[r] = e[r]) : Oi(n[r], e[r], t) : n[r] = e[r]);
  return n;
}
function Je(n) {
  return n.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var Hg = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function Yg(n) {
  return typeof n == "string" ? n.replace(/[&<>"'\/]/g, (e) => Hg[e]) : n;
}
class jg {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const t = this.regExpMap.get(e);
    if (t !== void 0)
      return t;
    const r = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, r), this.regExpQueue.push(e), r;
  }
}
const zg = [" ", ",", "?", "!", ";"], Wg = new jg(20);
function Gg(n, e, t) {
  e = e || "", t = t || "";
  const r = zg.filter((a) => e.indexOf(a) < 0 && t.indexOf(a) < 0);
  if (r.length === 0)
    return !0;
  const i = Wg.getRegExp(`(${r.map((a) => a === "?" ? "\\?" : a).join("|")})`);
  let o = !i.test(n);
  if (!o) {
    const a = n.indexOf(t);
    a > 0 && !i.test(n.substring(0, a)) && (o = !0);
  }
  return o;
}
function mn(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!n)
    return;
  if (n[e])
    return n[e];
  const r = e.split(t);
  let i = n;
  for (let o = 0; o < r.length; ) {
    if (!i || typeof i != "object")
      return;
    let a, s = "";
    for (let l = o; l < r.length; ++l)
      if (l !== o && (s += t), s += r[l], a = i[s], a !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof a) > -1 && l < r.length - 1)
          continue;
        o += l - o + 1;
        break;
      }
    i = a;
  }
  return i;
}
function Mt(n) {
  return n && n.indexOf("_") > 0 ? n.replace("_", "-") : n;
}
class Ir extends Ht {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const t = this.options.ns.indexOf(e);
    t > -1 && this.options.ns.splice(t, 1);
  }
  getResource(e, t, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const o = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator, a = i.ignoreJSONStructure !== void 0 ? i.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    e.indexOf(".") > -1 ? s = e.split(".") : (s = [e, t], r && (Array.isArray(r) ? s.push(...r) : typeof r == "string" && o ? s.push(...r.split(o)) : s.push(r)));
    const l = At(this.data, s);
    return !l && !t && !r && e.indexOf(".") > -1 && (e = s[0], t = s[1], r = s.slice(2).join(".")), l || !a || typeof r != "string" ? l : mn(this.data && this.data[e] && this.data[e][t], r, o);
  }
  addResource(e, t, r, i) {
    let o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const a = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator;
    let s = [e, t];
    r && (s = s.concat(a ? r.split(a) : r)), e.indexOf(".") > -1 && (s = e.split("."), i = t, t = s[1]), this.addNamespaces(t), Br(this.data, s, i), o.silent || this.emit("added", e, t, r, i);
  }
  addResources(e, t, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const o in r)
      (typeof r[o] == "string" || Array.isArray(r[o])) && this.addResource(e, t, o, r[o], {
        silent: !0
      });
    i.silent || this.emit("added", e, t, r);
  }
  addResourceBundle(e, t, r, i, o) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, s = [e, t];
    e.indexOf(".") > -1 && (s = e.split("."), i = r, r = t, t = s[1]), this.addNamespaces(t);
    let l = At(this.data, s) || {};
    a.skipCopy || (r = JSON.parse(JSON.stringify(r))), i ? Oi(l, r, o) : l = {
      ...l,
      ...r
    }, Br(this.data, s, l), a.silent || this.emit("added", e, t, r);
  }
  removeResourceBundle(e, t) {
    this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
  }
  hasResourceBundle(e, t) {
    return this.getResource(e, t) !== void 0;
  }
  getResourceBundle(e, t) {
    return t || (t = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, t)
    } : this.getResource(e, t);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const t = this.getDataByLanguage(e);
    return !!(t && Object.keys(t) || []).find((i) => t[i] && Object.keys(t[i]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Di = {
  processors: {},
  addPostProcessor(n) {
    this.processors[n.name] = n;
  },
  handle(n, e, t, r, i) {
    return n.forEach((o) => {
      this.processors[o] && (e = this.processors[o].process(e, t, r, i));
    }), e;
  }
};
const Rr = {};
class Ot extends Ht {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Lg(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Be.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const r = this.resolve(e, t);
    return r && r.res !== void 0;
  }
  extractFromKey(e, t) {
    let r = t.nsSeparator !== void 0 ? t.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const i = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let o = t.ns || this.options.defaultNS || [];
    const a = r && e.indexOf(r) > -1, s = !this.options.userDefinedKeySeparator && !t.keySeparator && !this.options.userDefinedNsSeparator && !t.nsSeparator && !Gg(e, r, i);
    if (a && !s) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: o
        };
      const c = e.split(r);
      (r !== i || r === i && this.options.ns.indexOf(c[0]) > -1) && (o = c.shift()), e = c.join(i);
    }
    return typeof o == "string" && (o = [o]), {
      key: e,
      namespaces: o
    };
  }
  translate(e, t, r) {
    if (typeof t != "object" && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), typeof t == "object" && (t = {
      ...t
    }), t || (t = {}), e == null)
      return "";
    Array.isArray(e) || (e = [String(e)]);
    const i = t.returnDetails !== void 0 ? t.returnDetails : this.options.returnDetails, o = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator, {
      key: a,
      namespaces: s
    } = this.extractFromKey(e[e.length - 1], t), l = s[s.length - 1], c = t.lng || this.language, u = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (u) {
        const F = t.nsSeparator || this.options.nsSeparator;
        return i ? {
          res: `${l}${F}${a}`,
          usedKey: a,
          exactUsedKey: a,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(t)
        } : `${l}${F}${a}`;
      }
      return i ? {
        res: a,
        usedKey: a,
        exactUsedKey: a,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(t)
      } : a;
    }
    const f = this.resolve(e, t);
    let d = f && f.res;
    const g = f && f.usedKey || a, p = f && f.exactUsedKey || a, y = Object.prototype.toString.apply(d), b = ["[object Number]", "[object Function]", "[object RegExp]"], k = t.joinArrays !== void 0 ? t.joinArrays : this.options.joinArrays, x = !this.i18nFormat || this.i18nFormat.handleAsObject;
    if (x && d && (typeof d != "string" && typeof d != "boolean" && typeof d != "number") && b.indexOf(y) < 0 && !(typeof k == "string" && Array.isArray(d))) {
      if (!t.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const F = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(g, d, {
          ...t,
          ns: s
        }) : `key '${a} (${this.language})' returned an object instead of string.`;
        return i ? (f.res = F, f.usedParams = this.getUsedParamsDetails(t), f) : F;
      }
      if (o) {
        const F = Array.isArray(d), K = F ? [] : {}, j = F ? p : g;
        for (const V in d)
          if (Object.prototype.hasOwnProperty.call(d, V)) {
            const Ee = `${j}${o}${V}`;
            K[V] = this.translate(Ee, {
              ...t,
              joinArrays: !1,
              ns: s
            }), K[V] === Ee && (K[V] = d[V]);
          }
        d = K;
      }
    } else if (x && typeof k == "string" && Array.isArray(d))
      d = d.join(k), d && (d = this.extendTranslation(d, e, t, r));
    else {
      let F = !1, K = !1;
      const j = t.count !== void 0 && typeof t.count != "string", V = Ot.hasDefaultValue(t), Ee = j ? this.pluralResolver.getSuffix(c, t.count, t) : "", J = t.ordinal && j ? this.pluralResolver.getSuffix(c, t.count, {
        ordinal: !1
      }) : "", _ = j && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), me = _ && t[`defaultValue${this.options.pluralSeparator}zero`] || t[`defaultValue${Ee}`] || t[`defaultValue${J}`] || t.defaultValue;
      !this.isValidLookup(d) && V && (F = !0, d = me), this.isValidLookup(d) || (K = !0, d = a);
      const I = (t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && K ? void 0 : d, w = V && me !== d && this.options.updateMissing;
      if (K || F || w) {
        if (this.logger.log(w ? "updateKey" : "missingKey", c, l, a, w ? me : d), o) {
          const B = this.resolve(a, {
            ...t,
            keySeparator: !1
          });
          B && B.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let $ = [];
        const M = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && M && M[0])
          for (let B = 0; B < M.length; B++)
            $.push(M[B]);
        else
          this.options.saveMissingTo === "all" ? $ = this.languageUtils.toResolveHierarchy(t.lng || this.language) : $.push(t.lng || this.language);
        const C = (B, A, N) => {
          const G = V && N !== d ? N : I;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(B, l, A, G, w, t) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(B, l, A, G, w, t), this.emit("missingKey", B, l, A, d);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && j ? $.forEach((B) => {
          const A = this.pluralResolver.getSuffixes(B, t);
          _ && t[`defaultValue${this.options.pluralSeparator}zero`] && A.indexOf(`${this.options.pluralSeparator}zero`) < 0 && A.push(`${this.options.pluralSeparator}zero`), A.forEach((N) => {
            C([B], a + N, t[`defaultValue${N}`] || me);
          });
        }) : C($, a, me));
      }
      d = this.extendTranslation(d, e, t, f, r), K && d === a && this.options.appendNamespaceToMissingKey && (d = `${l}:${a}`), (K || F) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? d = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${a}` : a, F ? d : void 0) : d = this.options.parseMissingKeyHandler(d));
    }
    return i ? (f.res = d, f.usedParams = this.getUsedParamsDetails(t), f) : d;
  }
  extendTranslation(e, t, r, i, o) {
    var a = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || i.usedLng, i.usedNS, i.usedKey, {
        resolved: i
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const c = typeof e == "string" && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const d = e.match(this.interpolator.nestingRegexp);
        u = d && d.length;
      }
      let f = r.replace && typeof r.replace != "string" ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (f = {
        ...this.options.interpolation.defaultVariables,
        ...f
      }), e = this.interpolator.interpolate(e, f, r.lng || this.language, r), c) {
        const d = e.match(this.interpolator.nestingRegexp), g = d && d.length;
        u < g && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && i && i.res && (r.lng = i.usedLng), r.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var d = arguments.length, g = new Array(d), p = 0; p < d; p++)
          g[p] = arguments[p];
        return o && o[0] === g[0] && !r.context ? (a.logger.warn(`It seems you are nesting recursively key: ${g[0]} in key: ${t[0]}`), null) : a.translate(...g, t);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const s = r.postProcess || this.options.postProcess, l = typeof s == "string" ? [s] : s;
    return e != null && l && l.length && r.applyPostProcessor !== !1 && (e = Di.handle(l, e, t, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...i,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), e;
  }
  resolve(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, i, o, a, s;
    return typeof e == "string" && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(r))
        return;
      const c = this.extractFromKey(l, t), u = c.key;
      i = u;
      let f = c.namespaces;
      this.options.fallbackNS && (f = f.concat(this.options.fallbackNS));
      const d = t.count !== void 0 && typeof t.count != "string", g = d && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), p = t.context !== void 0 && (typeof t.context == "string" || typeof t.context == "number") && t.context !== "", y = t.lngs ? t.lngs : this.languageUtils.toResolveHierarchy(t.lng || this.language, t.fallbackLng);
      f.forEach((b) => {
        this.isValidLookup(r) || (s = b, !Rr[`${y[0]}-${b}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(s) && (Rr[`${y[0]}-${b}`] = !0, this.logger.warn(`key "${i}" for languages "${y.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), y.forEach((k) => {
          if (this.isValidLookup(r))
            return;
          a = k;
          const x = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(x, u, k, b, t);
          else {
            let F;
            d && (F = this.pluralResolver.getSuffix(k, t.count, t));
            const K = `${this.options.pluralSeparator}zero`, j = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (d && (x.push(u + F), t.ordinal && F.indexOf(j) === 0 && x.push(u + F.replace(j, this.options.pluralSeparator)), g && x.push(u + K)), p) {
              const V = `${u}${this.options.contextSeparator}${t.context}`;
              x.push(V), d && (x.push(V + F), t.ordinal && F.indexOf(j) === 0 && x.push(V + F.replace(j, this.options.pluralSeparator)), g && x.push(V + K));
            }
          }
          let Q;
          for (; Q = x.pop(); )
            this.isValidLookup(r) || (o = Q, r = this.getResource(k, b, Q, t));
        }));
      });
    }), {
      res: r,
      usedKey: i,
      exactUsedKey: o,
      usedLng: a,
      usedNS: s
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, t, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, r, i) : this.resourceStore.getResource(e, t, r, i);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = e.replace && typeof e.replace != "string";
    let i = r ? e.replace : e;
    if (r && typeof e.count < "u" && (i.count = e.count), this.options.interpolation.defaultVariables && (i = {
      ...this.options.interpolation.defaultVariables,
      ...i
    }), !r) {
      i = {
        ...i
      };
      for (const o of t)
        delete i[o];
    }
    return i;
  }
  static hasDefaultValue(e) {
    const t = "defaultValue";
    for (const r in e)
      if (Object.prototype.hasOwnProperty.call(e, r) && t === r.substring(0, t.length) && e[r] !== void 0)
        return !0;
    return !1;
  }
}
function Xt(n) {
  return n.charAt(0).toUpperCase() + n.slice(1);
}
class Ar {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Be.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = Mt(e), !e || e.indexOf("-") < 0)
      return null;
    const t = e.split("-");
    return t.length === 2 || (t.pop(), t[t.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(t.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = Mt(e), !e || e.indexOf("-") < 0)
      return e;
    const t = e.split("-");
    return this.formatLanguageCode(t[0]);
  }
  formatLanguageCode(e) {
    if (typeof e == "string" && e.indexOf("-") > -1) {
      const t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = e.split("-");
      return this.options.lowerCaseLng ? r = r.map((i) => i.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = Xt(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = Xt(r[1].toLowerCase())), t.indexOf(r[2].toLowerCase()) > -1 && (r[2] = Xt(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e)
      return null;
    let t;
    return e.forEach((r) => {
      if (t)
        return;
      const i = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(i)) && (t = i);
    }), !t && this.options.supportedLngs && e.forEach((r) => {
      if (t)
        return;
      const i = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(i))
        return t = i;
      t = this.options.supportedLngs.find((o) => {
        if (o === i)
          return o;
        if (!(o.indexOf("-") < 0 && i.indexOf("-") < 0) && (o.indexOf("-") > 0 && i.indexOf("-") < 0 && o.substring(0, o.indexOf("-")) === i || o.indexOf(i) === 0 && i.length > 1))
          return o;
      });
    }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t;
  }
  getFallbackCodes(e, t) {
    if (!e)
      return [];
    if (typeof e == "function" && (e = e(t)), typeof e == "string" && (e = [e]), Array.isArray(e))
      return e;
    if (!t)
      return e.default || [];
    let r = e[t];
    return r || (r = e[this.getScriptPartFromCode(t)]), r || (r = e[this.formatLanguageCode(t)]), r || (r = e[this.getLanguagePartFromCode(t)]), r || (r = e.default), r || [];
  }
  toResolveHierarchy(e, t) {
    const r = this.getFallbackCodes(t || this.options.fallbackLng || [], e), i = [], o = (a) => {
      a && (this.isSupportedCode(a) ? i.push(a) : this.logger.warn(`rejecting language code not found in supportedLngs: ${a}`));
    };
    return typeof e == "string" && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && o(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && o(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && o(this.getLanguagePartFromCode(e))) : typeof e == "string" && o(this.formatLanguageCode(e)), r.forEach((a) => {
      i.indexOf(a) < 0 && o(this.formatLanguageCode(a));
    }), i;
  }
}
let Kg = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], qg = {
  1: function(n) {
    return +(n > 1);
  },
  2: function(n) {
    return +(n != 1);
  },
  3: function(n) {
    return 0;
  },
  4: function(n) {
    return n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  5: function(n) {
    return n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
  },
  6: function(n) {
    return n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2;
  },
  7: function(n) {
    return n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  8: function(n) {
    return n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3;
  },
  9: function(n) {
    return +(n >= 2);
  },
  10: function(n) {
    return n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4;
  },
  11: function(n) {
    return n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3;
  },
  12: function(n) {
    return +(n % 10 != 1 || n % 100 == 11);
  },
  13: function(n) {
    return +(n !== 0);
  },
  14: function(n) {
    return n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3;
  },
  15: function(n) {
    return n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  16: function(n) {
    return n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2;
  },
  17: function(n) {
    return n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1;
  },
  18: function(n) {
    return n == 0 ? 0 : n == 1 ? 1 : 2;
  },
  19: function(n) {
    return n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3;
  },
  20: function(n) {
    return n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2;
  },
  21: function(n) {
    return n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0;
  },
  22: function(n) {
    return n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3;
  }
};
const Vg = ["v1", "v2", "v3"], Jg = ["v4"], Mr = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function Zg() {
  const n = {};
  return Kg.forEach((e) => {
    e.lngs.forEach((t) => {
      n[t] = {
        numbers: e.nr,
        plurals: qg[e.fc]
      };
    });
  }), n;
}
class Qg {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = t, this.logger = Be.create("pluralResolver"), (!this.options.compatibilityJSON || Jg.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Zg();
  }
  addRule(e, t) {
    this.rules[e] = t;
  }
  getRule(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        return new Intl.PluralRules(Mt(e === "dev" ? "en" : e), {
          type: t.ordinal ? "ordinal" : "cardinal"
        });
      } catch {
        return;
      }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(e, t);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, r).map((i) => `${t}${i}`);
  }
  getSuffixes(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(e, t);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((i, o) => Mr[i] - Mr[o]).map((i) => `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${i}`) : r.numbers.map((i) => this.getSuffix(e, i, t)) : [];
  }
  getSuffix(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const i = this.getRule(e, r);
    return i ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${i.select(t)}` : this.getSuffixRetroCompatible(i, t) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, t) {
    const r = e.noAbs ? e.plurals(t) : e.plurals(Math.abs(t));
    let i = e.numbers[r];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (i === 2 ? i = "plural" : i === 1 && (i = ""));
    const o = () => this.options.prepend && i.toString() ? this.options.prepend + i.toString() : i.toString();
    return this.options.compatibilityJSON === "v1" ? i === 1 ? "" : typeof i == "number" ? `_plural_${i.toString()}` : o() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? o() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !Vg.includes(this.options.compatibilityJSON);
  }
}
function Or(n, e, t) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, o = Ug(n, e, t);
  return !o && i && typeof t == "string" && (o = mn(n, t, r), o === void 0 && (o = mn(e, t, r))), o;
}
class Xg {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Be.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((t) => t), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: t,
      escapeValue: r,
      useRawValueToEscape: i,
      prefix: o,
      prefixEscaped: a,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: f,
      nestingPrefix: d,
      nestingPrefixEscaped: g,
      nestingSuffix: p,
      nestingSuffixEscaped: y,
      nestingOptionsSeparator: b,
      maxReplaces: k,
      alwaysFormat: x
    } = e.interpolation;
    this.escape = t !== void 0 ? t : Yg, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = i !== void 0 ? i : !1, this.prefix = o ? Je(o) : a || "{{", this.suffix = s ? Je(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : f || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = d ? Je(d) : g || Je("$t("), this.nestingSuffix = p ? Je(p) : y || Je(")"), this.nestingOptionsSeparator = b || ",", this.maxReplaces = k || 1e3, this.alwaysFormat = x !== void 0 ? x : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (t, r) => t && t.source === r ? (t.lastIndex = 0, t) : new RegExp(r, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, t, r, i) {
    let o, a, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    function c(p) {
      return p.replace(/\$/g, "$$$$");
    }
    const u = (p) => {
      if (p.indexOf(this.formatSeparator) < 0) {
        const x = Or(t, l, p, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(x, void 0, r, {
          ...i,
          ...t,
          interpolationkey: p
        }) : x;
      }
      const y = p.split(this.formatSeparator), b = y.shift().trim(), k = y.join(this.formatSeparator).trim();
      return this.format(Or(t, l, b, this.options.keySeparator, this.options.ignoreJSONStructure), k, r, {
        ...i,
        ...t,
        interpolationkey: b
      });
    };
    this.resetRegExp();
    const f = i && i.missingInterpolationHandler || this.options.missingInterpolationHandler, d = i && i.interpolation && i.interpolation.skipOnVariables !== void 0 ? i.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (p) => c(p)
    }, {
      regex: this.regexp,
      safeValue: (p) => this.escapeValue ? c(this.escape(p)) : c(p)
    }].forEach((p) => {
      for (s = 0; o = p.regex.exec(e); ) {
        const y = o[1].trim();
        if (a = u(y), a === void 0)
          if (typeof f == "function") {
            const k = f(e, o, i);
            a = typeof k == "string" ? k : "";
          } else if (i && Object.prototype.hasOwnProperty.call(i, y))
            a = "";
          else if (d) {
            a = o[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${y} for interpolating ${e}`), a = "";
        else
          typeof a != "string" && !this.useRawValueToEscape && (a = xr(a));
        const b = p.safeValue(a);
        if (e = e.replace(o[0], b), d ? (p.regex.lastIndex += a.length, p.regex.lastIndex -= o[0].length) : p.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i, o, a;
    function s(l, c) {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0)
        return l;
      const f = l.split(new RegExp(`${u}[ ]*{`));
      let d = `{${f[1]}`;
      l = f[0], d = this.interpolate(d, a);
      const g = d.match(/'/g), p = d.match(/"/g);
      (g && g.length % 2 === 0 && !p || p.length % 2 !== 0) && (d = d.replace(/'/g, '"'));
      try {
        a = JSON.parse(d), c && (a = {
          ...c,
          ...a
        });
      } catch (y) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, y), `${l}${u}${d}`;
      }
      return a.defaultValue && a.defaultValue.indexOf(this.prefix) > -1 && delete a.defaultValue, l;
    }
    for (; i = this.nestingRegexp.exec(e); ) {
      let l = [];
      a = {
        ...r
      }, a = a.replace && typeof a.replace != "string" ? a.replace : a, a.applyPostProcessor = !1, delete a.defaultValue;
      let c = !1;
      if (i[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(i[1])) {
        const u = i[1].split(this.formatSeparator).map((f) => f.trim());
        i[1] = u.shift(), l = u, c = !0;
      }
      if (o = t(s.call(this, i[1].trim(), a), a), o && i[0] === e && typeof o != "string")
        return o;
      typeof o != "string" && (o = xr(o)), o || (this.logger.warn(`missed to resolve ${i[1]} for nesting ${e}`), o = ""), c && (o = l.reduce((u, f) => this.format(u, f, r.lng, {
        ...r,
        interpolationkey: i[1].trim()
      }), o.trim())), e = e.replace(i[0], o), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
function ep(n) {
  let e = n.toLowerCase().trim();
  const t = {};
  if (n.indexOf("(") > -1) {
    const r = n.split("(");
    e = r[0].toLowerCase().trim();
    const i = r[1].substring(0, r[1].length - 1);
    e === "currency" && i.indexOf(":") < 0 ? t.currency || (t.currency = i.trim()) : e === "relativetime" && i.indexOf(":") < 0 ? t.range || (t.range = i.trim()) : i.split(";").forEach((a) => {
      if (a) {
        const [s, ...l] = a.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = s.trim();
        t[u] || (t[u] = c), c === "false" && (t[u] = !1), c === "true" && (t[u] = !0), isNaN(c) || (t[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: t
  };
}
function Ze(n) {
  const e = {};
  return function(r, i, o) {
    const a = i + JSON.stringify(o);
    let s = e[a];
    return s || (s = n(Mt(i), o), e[a] = s), s(r);
  };
}
class tp {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Be.create("formatter"), this.options = e, this.formats = {
      number: Ze((t, r) => {
        const i = new Intl.NumberFormat(t, {
          ...r
        });
        return (o) => i.format(o);
      }),
      currency: Ze((t, r) => {
        const i = new Intl.NumberFormat(t, {
          ...r,
          style: "currency"
        });
        return (o) => i.format(o);
      }),
      datetime: Ze((t, r) => {
        const i = new Intl.DateTimeFormat(t, {
          ...r
        });
        return (o) => i.format(o);
      }),
      relativetime: Ze((t, r) => {
        const i = new Intl.RelativeTimeFormat(t, {
          ...r
        });
        return (o) => i.format(o, r.range || "day");
      }),
      list: Ze((t, r) => {
        const i = new Intl.ListFormat(t, {
          ...r
        });
        return (o) => i.format(o);
      })
    }, this.init(e);
  }
  init(e) {
    const r = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    }).interpolation;
    this.formatSeparator = r.formatSeparator ? r.formatSeparator : r.formatSeparator || ",";
  }
  add(e, t) {
    this.formats[e.toLowerCase().trim()] = t;
  }
  addCached(e, t) {
    this.formats[e.toLowerCase().trim()] = Ze(t);
  }
  format(e, t, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return t.split(this.formatSeparator).reduce((s, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = ep(l);
      if (this.formats[c]) {
        let f = s;
        try {
          const d = i && i.formatParams && i.formatParams[i.interpolationkey] || {}, g = d.locale || d.lng || i.locale || i.lng || r;
          f = this.formats[c](s, g, {
            ...u,
            ...i,
            ...d
          });
        } catch (d) {
          this.logger.warn(d);
        }
        return f;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return s;
    }, e);
  }
}
function np(n, e) {
  n.pending[e] !== void 0 && (delete n.pending[e], n.pendingCount--);
}
class rp extends Ht {
  constructor(e, t, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = t, this.services = r, this.languageUtils = r.languageUtils, this.options = i, this.logger = Be.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = i.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = i.maxRetries >= 0 ? i.maxRetries : 5, this.retryTimeout = i.retryTimeout >= 1 ? i.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, i.backend, i);
  }
  queueLoad(e, t, r, i) {
    const o = {}, a = {}, s = {}, l = {};
    return e.forEach((c) => {
      let u = !0;
      t.forEach((f) => {
        const d = `${c}|${f}`;
        !r.reload && this.store.hasResourceBundle(c, f) ? this.state[d] = 2 : this.state[d] < 0 || (this.state[d] === 1 ? a[d] === void 0 && (a[d] = !0) : (this.state[d] = 1, u = !1, a[d] === void 0 && (a[d] = !0), o[d] === void 0 && (o[d] = !0), l[f] === void 0 && (l[f] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(o).length || Object.keys(a).length) && this.queue.push({
      pending: a,
      pendingCount: Object.keys(a).length,
      loaded: {},
      errors: [],
      callback: i
    }), {
      toLoad: Object.keys(o),
      pending: Object.keys(a),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, t, r) {
    const i = e.split("|"), o = i[0], a = i[1];
    t && this.emit("failedLoading", o, a, t), r && this.store.addResourceBundle(o, a, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = t ? -1 : 2;
    const s = {};
    this.queue.forEach((l) => {
      _g(l.loaded, [o], a), np(l, e), t && l.errors.push(t), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((f) => {
          s[c][f] === void 0 && (s[c][f] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, t, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, a = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length)
      return a(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: t,
        fcName: r,
        tried: i,
        wait: o,
        callback: a
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const f = this.waitingReads.shift();
        this.read(f.lng, f.ns, f.fcName, f.tried, f.wait, f.callback);
      }
      if (c && u && i < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, t, r, i + 1, o * 2, a);
        }, o);
        return;
      }
      a(c, u);
    }, l = this.backend[r].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(e, t);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(e, t, s);
  }
  prepareLoading(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), i && i();
    typeof e == "string" && (e = this.languageUtils.toResolveHierarchy(e)), typeof t == "string" && (t = [t]);
    const o = this.queueLoad(e, t, r, i);
    if (!o.toLoad.length)
      return o.pending.length || i(), null;
    o.toLoad.forEach((a) => {
      this.loadOne(a);
    });
  }
  load(e, t, r) {
    this.prepareLoading(e, t, {}, r);
  }
  reload(e, t, r) {
    this.prepareLoading(e, t, {
      reload: !0
    }, r);
  }
  loadOne(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = e.split("|"), i = r[0], o = r[1];
    this.read(i, o, "read", void 0, void 0, (a, s) => {
      a && this.logger.warn(`${t}loading namespace ${o} for language ${i} failed`, a), !a && s && this.logger.log(`${t}loaded namespace ${o} for language ${i}`, s), this.loaded(e, a, s);
    });
  }
  saveMissing(e, t, r, i, o) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${t}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...a,
          isUpdate: o
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(e, t, r, i, l) : u = c(e, t, r, i), u && typeof u.then == "function" ? u.then((f) => s(null, f)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          c(e, t, r, i, s, l);
      }
      !e || !e[0] || this.store.addResource(e[0], t, r, i);
    }
  }
}
function Dr() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !1,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(e) {
      let t = {};
      if (typeof e[1] == "object" && (t = e[1]), typeof e[1] == "string" && (t.defaultValue = e[1]), typeof e[2] == "string" && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
        const r = e[3] || e[2];
        Object.keys(r).forEach((i) => {
          t[i] = r[i];
        });
      }
      return t;
    },
    interpolation: {
      escapeValue: !0,
      format: (n) => n,
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function Nr(n) {
  return typeof n.ns == "string" && (n.ns = [n.ns]), typeof n.fallbackLng == "string" && (n.fallbackLng = [n.fallbackLng]), typeof n.fallbackNS == "string" && (n.fallbackNS = [n.fallbackNS]), n.supportedLngs && n.supportedLngs.indexOf("cimode") < 0 && (n.supportedLngs = n.supportedLngs.concat(["cimode"])), n;
}
function vt() {
}
function ip(n) {
  Object.getOwnPropertyNames(Object.getPrototypeOf(n)).forEach((t) => {
    typeof n[t] == "function" && (n[t] = n[t].bind(n));
  });
}
class ht extends Ht {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Nr(e), this.services = {}, this.logger = Be, this.modules = {
      external: []
    }, ip(this), t && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, t), this;
      setTimeout(() => {
        this.init(e, t);
      }, 0);
    }
  }
  init() {
    var e = this;
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof t == "function" && (r = t, t = {}), !t.defaultNS && t.defaultNS !== !1 && t.ns && (typeof t.ns == "string" ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const i = Dr();
    this.options = {
      ...i,
      ...this.options,
      ...Nr(t)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...i.interpolation,
      ...this.options.interpolation
    }), t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    function o(u) {
      return u ? typeof u == "function" ? new u() : u : null;
    }
    if (!this.options.isClone) {
      this.modules.logger ? Be.init(o(this.modules.logger), this.options) : Be.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : typeof Intl < "u" && (u = tp);
      const f = new Ar(this.options);
      this.store = new Ir(this.options.resources, this.options);
      const d = this.services;
      d.logger = Be, d.resourceStore = this.store, d.languageUtils = f, d.pluralResolver = new Qg(f, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === i.interpolation.format) && (d.formatter = o(u), d.formatter.init(d, this.options), this.options.interpolation.format = d.formatter.format.bind(d.formatter)), d.interpolator = new Xg(this.options), d.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, d.backendConnector = new rp(o(this.modules.backend), d.resourceStore, d, this.options), d.backendConnector.on("*", function(g) {
        for (var p = arguments.length, y = new Array(p > 1 ? p - 1 : 0), b = 1; b < p; b++)
          y[b - 1] = arguments[b];
        e.emit(g, ...y);
      }), this.modules.languageDetector && (d.languageDetector = o(this.modules.languageDetector), d.languageDetector.init && d.languageDetector.init(d, this.options.detection, this.options)), this.modules.i18nFormat && (d.i18nFormat = o(this.modules.i18nFormat), d.i18nFormat.init && d.i18nFormat.init(this)), this.translator = new Ot(this.services, this.options), this.translator.on("*", function(g) {
        for (var p = arguments.length, y = new Array(p > 1 ? p - 1 : 0), b = 1; b < p; b++)
          y[b - 1] = arguments[b];
        e.emit(g, ...y);
      }), this.modules.external.forEach((g) => {
        g.init && g.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = vt), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments), e;
      };
    });
    const l = ot(), c = () => {
      const u = (f, d) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(d), r(f, d);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initImmediate ? c() : setTimeout(c, 0), l;
  }
  loadResources(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : vt;
    const i = typeof e == "string" ? e : this.language;
    if (typeof e == "function" && (r = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (i && i.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return r();
      const o = [], a = (s) => {
        if (!s || s === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(s).forEach((c) => {
          c !== "cimode" && o.indexOf(c) < 0 && o.push(c);
        });
      };
      i ? a(i) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => a(l)), this.options.preload && this.options.preload.forEach((s) => a(s)), this.services.backendConnector.load(o, this.options.ns, (s) => {
        !s && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(s);
      });
    } else
      r(null);
  }
  reloadResources(e, t, r) {
    const i = ot();
    return e || (e = this.languages), t || (t = this.options.ns), r || (r = vt), this.services.backendConnector.reload(e, t, (o) => {
      i.resolve(), r(o);
    }), i;
  }
  use(e) {
    if (!e)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && Di.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let t = 0; t < this.languages.length; t++) {
        const r = this.languages[t];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(e, t) {
    var r = this;
    this.isLanguageChangingTo = e;
    const i = ot();
    this.emit("languageChanging", e);
    const o = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, a = (l, c) => {
      c ? (o(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, i.resolve(function() {
        return r.t(...arguments);
      }), t && t(l, function() {
        return r.t(...arguments);
      });
    }, s = (l) => {
      !e && !l && this.services.languageDetector && (l = []);
      const c = typeof l == "string" ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || o(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (u) => {
        a(u, c);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? s(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(s) : this.services.languageDetector.detect(s) : s(e), i;
  }
  getFixedT(e, t, r) {
    var i = this;
    const o = function(a, s) {
      let l;
      if (typeof s != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), f = 2; f < c; f++)
          u[f - 2] = arguments[f];
        l = i.options.overloadTranslationOptionHandler([a, s].concat(u));
      } else
        l = {
          ...s
        };
      l.lng = l.lng || o.lng, l.lngs = l.lngs || o.lngs, l.ns = l.ns || o.ns, l.keyPrefix = l.keyPrefix || r || o.keyPrefix;
      const d = i.options.keySeparator || ".";
      let g;
      return l.keyPrefix && Array.isArray(a) ? g = a.map((p) => `${l.keyPrefix}${d}${p}`) : g = l.keyPrefix ? `${l.keyPrefix}${d}${a}` : a, i.t(g, l);
    };
    return typeof e == "string" ? o.lng = e : o.lngs = e, o.ns = t, o.keyPrefix = r, o;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = t.lng || this.resolvedLanguage || this.languages[0], i = this.options ? this.options.fallbackLng : !1, o = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode")
      return !0;
    const a = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 2;
    };
    if (t.precheck) {
      const s = t.precheck(this, a);
      if (s !== void 0)
        return s;
    }
    return !!(this.hasResourceBundle(r, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || a(r, e) && (!i || a(o, e)));
  }
  loadNamespaces(e, t) {
    const r = ot();
    return this.options.ns ? (typeof e == "string" && (e = [e]), e.forEach((i) => {
      this.options.ns.indexOf(i) < 0 && this.options.ns.push(i);
    }), this.loadResources((i) => {
      r.resolve(), t && t(i);
    }), r) : (t && t(), Promise.resolve());
  }
  loadLanguages(e, t) {
    const r = ot();
    typeof e == "string" && (e = [e]);
    const i = this.options.preload || [], o = e.filter((a) => i.indexOf(a) < 0 && this.services.languageUtils.isSupportedCode(a));
    return o.length ? (this.options.preload = i.concat(o), this.loadResources((a) => {
      r.resolve(), t && t(a);
    }), r) : (t && t(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e)
      return "rtl";
    const t = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new Ar(Dr());
    return t.indexOf(r.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    return new ht(e, t);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : vt;
    const r = e.forkResourceStore;
    r && delete e.forkResourceStore;
    const i = {
      ...this.options,
      ...e,
      isClone: !0
    }, o = new ht(i);
    return (e.debug !== void 0 || e.prefix !== void 0) && (o.logger = o.logger.clone(e)), ["store", "services", "language"].forEach((s) => {
      o[s] = this[s];
    }), o.services = {
      ...this.services
    }, o.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, r && (o.store = new Ir(this.store.data, i), o.services.resourceStore = o.store), o.translator = new Ot(o.services, i), o.translator.on("*", function(s) {
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)
        c[u - 1] = arguments[u];
      o.emit(s, ...c);
    }), o.init(i, t), o.translator.options = i, o.translator.backendConnector.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, o;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const An = ht.createInstance();
An.createInstance = ht.createInstance;
const Ni = "No date selected", Fi = "Choose another time slot to reschedule your meeting", Li = {
  sunday: "SUN",
  monday: "MON",
  tuesday: "TUE",
  wednesday: "WED",
  thursday: "THU",
  friday: "FRI",
  saturday: "SAT"
}, Pi = {
  hour: "hour",
  hours: "hours",
  minute: "minute",
  minutes: "minutes"
}, _i = {
  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December"
}, Ui = "Next", Hi = "{{date}}", Yi = "{{time}}", ji = "Name", zi = "Enter your name", Wi = "Email", Gi = "Enter your email", Ki = "Guest email", qi = "Enter guest email", Vi = "Add guest", Ji = "Add another guest", Zi = "Back", Qi = "Book now", Xi = "Booking confirmed", eo = "Booking rescheduled", to = "Booking date and time", no = "Cancel booking", ro = "Reschedule", io = "Cancel booking?", oo = "Your current timeslot will become available to others.", ao = "Reason for cancellation", so = "Go back", lo = "Your booking has been cancelled successfully", co = "A cancellation email has been sent to", uo = "Close", fo = "Closing", ho = "{{field}} is required.", go = "{{field}} has invalid format.", po = "Create Booking", mo = "Get Availability", yo = "Cancel Booking", bo = "Reschedule Booking", vo = "Get UI Settings", Eo = "Something went wrong...", ko = "No sessionId!", $o = "Session ID is required", wo = "Invalid timeslot!", To = "The selected timeslot is invalid", So = "Cancellation Error", Co = "Please provide a reason for cancellation.", xo = "You cannot cancel the booking within {{minCancellationNotice}} minutes of the event", Bo = "Cancel booking form error", op = {
  noDateSelected: Ni,
  rescheduleTitle: Fi,
  days: Li,
  time: Pi,
  months: _i,
  nextButton: Ui,
  selectedDayAndYear: Hi,
  selectedTime: Yi,
  name: ji,
  namePlaceholder: zi,
  email: Wi,
  emailPlaceholder: Gi,
  guestEmail: Ki,
  guestEmailPlaceholder: qi,
  addGuest: Vi,
  addAnotherGuest: Ji,
  backButton: Zi,
  bookNowButton: Qi,
  bookingConfirmed: Xi,
  bookingRescheduled: eo,
  bookingDateAndTimeHeader: to,
  cancelBookingButton: no,
  rescheduleBookingButton: ro,
  cancelBookingTitle: io,
  cancelBookingMessage: oo,
  reasonForCancellation: ao,
  goBackButton: so,
  bookingCancelledTitle: lo,
  bookingCancelledMessage: co,
  closeButton: uo,
  closingButton: fo,
  fieldRequired: ho,
  invalidInputFormat: go,
  createBookingErrorTitle: po,
  getAvailabilityErrorTitle: mo,
  cancelBookingErrorTitle: yo,
  rescheduleBookingErrorTitle: bo,
  getUISettingErrorTitle: vo,
  genericErrorTitle: Eo,
  noSessionIdErrorTitle: ko,
  noSessionIdErrorMessage: $o,
  invalidTimeslotErrorTitle: wo,
  invalidTimeslotErrorMessage: To,
  cancellationErrorTitle: So,
  cancellationErrorMessage: Co,
  minimumCancellationErrorMessage: xo,
  cancelBokingFormError: Bo
}, ap = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  noDateSelected: Ni,
  rescheduleTitle: Fi,
  days: Li,
  time: Pi,
  months: _i,
  nextButton: Ui,
  selectedDayAndYear: Hi,
  selectedTime: Yi,
  name: ji,
  namePlaceholder: zi,
  email: Wi,
  emailPlaceholder: Gi,
  guestEmail: Ki,
  guestEmailPlaceholder: qi,
  addGuest: Vi,
  addAnotherGuest: Ji,
  backButton: Zi,
  bookNowButton: Qi,
  bookingConfirmed: Xi,
  bookingRescheduled: eo,
  bookingDateAndTimeHeader: to,
  cancelBookingButton: no,
  rescheduleBookingButton: ro,
  cancelBookingTitle: io,
  cancelBookingMessage: oo,
  reasonForCancellation: ao,
  goBackButton: so,
  bookingCancelledTitle: lo,
  bookingCancelledMessage: co,
  closeButton: uo,
  closingButton: fo,
  fieldRequired: ho,
  invalidInputFormat: go,
  createBookingErrorTitle: po,
  getAvailabilityErrorTitle: mo,
  cancelBookingErrorTitle: yo,
  rescheduleBookingErrorTitle: bo,
  getUISettingErrorTitle: vo,
  genericErrorTitle: Eo,
  noSessionIdErrorTitle: ko,
  noSessionIdErrorMessage: $o,
  invalidTimeslotErrorTitle: wo,
  invalidTimeslotErrorMessage: To,
  cancellationErrorTitle: So,
  cancellationErrorMessage: Co,
  minimumCancellationErrorMessage: xo,
  cancelBokingFormError: Bo,
  default: op
}), Io = "Aucune date sélectionnée", Ro = "Choisissez un autre créneau horaire pour reprogrammer votre réunion", Ao = {
  sunday: "DIM",
  monday: "LUN",
  tuesday: "MAR",
  wednesday: "MER",
  thursday: "JEU",
  friday: "VEN",
  saturday: "SAM"
}, Mo = {
  hour: "heure",
  hours: "heures",
  minute: "minute",
  minutes: "minutes"
}, Oo = {
  january: "Janvier",
  february: "Février",
  march: "Mars",
  april: "Avril",
  may: "Mai",
  june: "Juin",
  july: "Juillet",
  august: "Août",
  september: "Septembre",
  october: "Octobre",
  november: "Novembre",
  december: "Décembre"
}, Do = "Procéder", No = "{{date}}", Fo = "{{time}}", Lo = "Name", Po = "Entrez votre nom", _o = "E-mail", Uo = "Entrer votre E-mail", Ho = "E-mail invité", Yo = "Entrez l'adresse e-mail de l'invité", jo = "Ajouter un invité", zo = "Ajouter un autre invité", Wo = "Retour", Go = "Réservez maintenant", Ko = "Réservation confirmée", qo = "Réservation reprogrammée", Vo = "Date et heure de la réservation", Jo = "Annuler la réservation", Zo = "Replanifier", Qo = "Annuler la réservation?", Xo = "Votre créneau horaire actuel sera disponible pour les autres.", ea = "Raison de l'annulation", ta = "Retourner", na = "Votre réservation a été annulée avec succès", ra = "Un e-mail d'annulation a été envoyé à", ia = "Fermer", oa = "Fermeture", aa = "{{field}} est requis.", sa = "{{field}} a un format invalide.", la = "Créer une Réservation", ca = "Obtenir la Disponibilité", ua = "Annuler la Réservation", da = "Reprogrammer la Réservation", fa = "Obtenir les Paramètres UI", ha = "Quelque chose a mal tourné...", ga = "Pas de sessionId !", pa = "L'ID de session est requis", ma = "Créneau horaire invalide !", ya = "Le créneau horaire sélectionné est invalide", ba = "Erreur d'annulation", va = "Veuillez fournir une raison pour l'annulation.", Ea = "Vous ne pouvez pas annuler la réservation dans les {{minCancellationNotice}} minutes avant l'événement", ka = "Erreur de formulaire d'annulation de réservation", sp = {
  noDateSelected: Io,
  rescheduleTitle: Ro,
  days: Ao,
  time: Mo,
  months: Oo,
  nextButton: Do,
  selectedDayAndYear: No,
  selectedTime: Fo,
  name: Lo,
  namePlaceholder: Po,
  email: _o,
  emailPlaceholder: Uo,
  guestEmail: Ho,
  guestEmailPlaceholder: Yo,
  addGuest: jo,
  addAnotherGuest: zo,
  backButton: Wo,
  bookNowButton: Go,
  bookingConfirmed: Ko,
  bookingRescheduled: qo,
  bookingDateAndTimeHeader: Vo,
  cancelBookingButton: Jo,
  rescheduleBookingButton: Zo,
  cancelBookingTitle: Qo,
  cancelBookingMessage: Xo,
  reasonForCancellation: ea,
  goBackButton: ta,
  bookingCancelledTitle: na,
  bookingCancelledMessage: ra,
  closeButton: ia,
  closingButton: oa,
  fieldRequired: aa,
  invalidInputFormat: sa,
  createBookingErrorTitle: la,
  getAvailabilityErrorTitle: ca,
  cancelBookingErrorTitle: ua,
  rescheduleBookingErrorTitle: da,
  getUISettingErrorTitle: fa,
  genericErrorTitle: ha,
  noSessionIdErrorTitle: ga,
  noSessionIdErrorMessage: pa,
  invalidTimeslotErrorTitle: ma,
  invalidTimeslotErrorMessage: ya,
  cancellationErrorTitle: ba,
  cancellationErrorMessage: va,
  minimumCancellationErrorMessage: Ea,
  cancelBokingFormError: ka
}, lp = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  noDateSelected: Io,
  rescheduleTitle: Ro,
  days: Ao,
  time: Mo,
  months: Oo,
  nextButton: Do,
  selectedDayAndYear: No,
  selectedTime: Fo,
  name: Lo,
  namePlaceholder: Po,
  email: _o,
  emailPlaceholder: Uo,
  guestEmail: Ho,
  guestEmailPlaceholder: Yo,
  addGuest: jo,
  addAnotherGuest: zo,
  backButton: Wo,
  bookNowButton: Go,
  bookingConfirmed: Ko,
  bookingRescheduled: qo,
  bookingDateAndTimeHeader: Vo,
  cancelBookingButton: Jo,
  rescheduleBookingButton: Zo,
  cancelBookingTitle: Qo,
  cancelBookingMessage: Xo,
  reasonForCancellation: ea,
  goBackButton: ta,
  bookingCancelledTitle: na,
  bookingCancelledMessage: ra,
  closeButton: ia,
  closingButton: oa,
  fieldRequired: aa,
  invalidInputFormat: sa,
  createBookingErrorTitle: la,
  getAvailabilityErrorTitle: ca,
  cancelBookingErrorTitle: ua,
  rescheduleBookingErrorTitle: da,
  getUISettingErrorTitle: fa,
  genericErrorTitle: ha,
  noSessionIdErrorTitle: ga,
  noSessionIdErrorMessage: pa,
  invalidTimeslotErrorTitle: ma,
  invalidTimeslotErrorMessage: ya,
  cancellationErrorTitle: ba,
  cancellationErrorMessage: va,
  minimumCancellationErrorMessage: Ea,
  cancelBokingFormError: ka,
  default: sp
}), $a = "No has seleccionado ninguna fecha", wa = "Elige otro horario para reprogramar tu reunión", Ta = {
  sunday: "DOM",
  monday: "LUN",
  tuesday: "MAR",
  wednesday: "MIÉ",
  thursday: "JUE",
  friday: "VIE",
  saturday: "SÁB"
}, Sa = {
  hour: "hora",
  hours: "horas",
  minute: "minuto",
  minutes: "minutos"
}, Ca = {
  january: "Enero",
  february: "Febrero",
  march: "Marzo",
  april: "Abril",
  may: "Mayo",
  june: "Junio",
  july: "Julio",
  august: "Agosto",
  september: "Septiembre",
  october: "Octubre",
  november: "Noviembre",
  december: "Diciembre"
}, xa = "Siguiente", Ba = "{{date}}", Ia = "{{time}}", Ra = "Nombre", Aa = "Introduce tu nombre", Ma = "Correo electrónico", Oa = "Introduce tu correo electrónico", Da = "Correo electrónico del invitado", Na = "Introduce el correo electrónico del invitado", Fa = "Añadir invitado", La = "Añadir otro invitado", Pa = "Atrás", _a = "Reservar ahora", Ua = "Reserva confirmada", Ha = "Reserva reprogramada", Ya = "Fecha y hora de la reserva", ja = "Cancelar reserva", za = "Reprogramar", Wa = "¿Cancelar reserva?", Ga = "Su franja horaria actual estará disponible para otros.", Ka = "Motivo de la cancelación", qa = "Regresar", Va = "Su reserva ha sido cancelada con éxito", Ja = "Se ha enviado un correo electrónico de cancelación a", Za = "Cerrar", Qa = "Cerrando", Xa = "{{field}} es obligatorio.", es = "{{field}} tiene un formato no válido.", ts = "Crear Reserva", ns = "Obtener Disponibilidad", rs = "Cancelar Reserva", is = "Reprogramar Reserva", os = "Obtener Configuraciones de UI", as = "Algo salió mal...", ss = "¡No hay sessionId!", ls = "Se requiere ID de sesión", cs = "¡Intervalo de tiempo no válido!", us = "El intervalo de tiempo seleccionado no es válido", ds = "Error de Cancelación", fs = "Por favor, proporcione una razón para la cancelación.", hs = "No puede cancelar la reserva dentro de los {{minCancellationNotice}} minutos del evento", gs = "Error en el formulario de cancelación de la reserva", cp = {
  noDateSelected: $a,
  rescheduleTitle: wa,
  days: Ta,
  time: Sa,
  months: Ca,
  nextButton: xa,
  selectedDayAndYear: Ba,
  selectedTime: Ia,
  name: Ra,
  namePlaceholder: Aa,
  email: Ma,
  emailPlaceholder: Oa,
  guestEmail: Da,
  guestEmailPlaceholder: Na,
  addGuest: Fa,
  addAnotherGuest: La,
  backButton: Pa,
  bookNowButton: _a,
  bookingConfirmed: Ua,
  bookingRescheduled: Ha,
  bookingDateAndTimeHeader: Ya,
  cancelBookingButton: ja,
  rescheduleBookingButton: za,
  cancelBookingTitle: Wa,
  cancelBookingMessage: Ga,
  reasonForCancellation: Ka,
  goBackButton: qa,
  bookingCancelledTitle: Va,
  bookingCancelledMessage: Ja,
  closeButton: Za,
  closingButton: Qa,
  fieldRequired: Xa,
  invalidInputFormat: es,
  createBookingErrorTitle: ts,
  getAvailabilityErrorTitle: ns,
  cancelBookingErrorTitle: rs,
  rescheduleBookingErrorTitle: is,
  getUISettingErrorTitle: os,
  genericErrorTitle: as,
  noSessionIdErrorTitle: ss,
  noSessionIdErrorMessage: ls,
  invalidTimeslotErrorTitle: cs,
  invalidTimeslotErrorMessage: us,
  cancellationErrorTitle: ds,
  cancellationErrorMessage: fs,
  minimumCancellationErrorMessage: hs,
  cancelBokingFormError: gs
}, up = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  noDateSelected: $a,
  rescheduleTitle: wa,
  days: Ta,
  time: Sa,
  months: Ca,
  nextButton: xa,
  selectedDayAndYear: Ba,
  selectedTime: Ia,
  name: Ra,
  namePlaceholder: Aa,
  email: Ma,
  emailPlaceholder: Oa,
  guestEmail: Da,
  guestEmailPlaceholder: Na,
  addGuest: Fa,
  addAnotherGuest: La,
  backButton: Pa,
  bookNowButton: _a,
  bookingConfirmed: Ua,
  bookingRescheduled: Ha,
  bookingDateAndTimeHeader: Ya,
  cancelBookingButton: ja,
  rescheduleBookingButton: za,
  cancelBookingTitle: Wa,
  cancelBookingMessage: Ga,
  reasonForCancellation: Ka,
  goBackButton: qa,
  bookingCancelledTitle: Va,
  bookingCancelledMessage: Ja,
  closeButton: Za,
  closingButton: Qa,
  fieldRequired: Xa,
  invalidInputFormat: es,
  createBookingErrorTitle: ts,
  getAvailabilityErrorTitle: ns,
  cancelBookingErrorTitle: rs,
  rescheduleBookingErrorTitle: is,
  getUISettingErrorTitle: os,
  genericErrorTitle: as,
  noSessionIdErrorTitle: ss,
  noSessionIdErrorMessage: ls,
  invalidTimeslotErrorTitle: cs,
  invalidTimeslotErrorMessage: us,
  cancellationErrorTitle: ds,
  cancellationErrorMessage: fs,
  minimumCancellationErrorMessage: hs,
  cancelBokingFormError: gs,
  default: cp
}), ps = "日付が選択されていません", ms = "別の時間を選択してください", ys = {
  sunday: "日",
  monday: "月",
  tuesday: "火",
  wednesday: "水",
  thursday: "木",
  friday: "金",
  saturday: "土"
}, bs = {
  hour: "時間",
  hours: "時間",
  minute: "分",
  minutes: "分"
}, vs = {
  january: "1月",
  february: "2月",
  march: "3月",
  april: "4月",
  may: "5月",
  june: "6月",
  july: "7月",
  august: "8月",
  september: "9月",
  october: "10月",
  november: "11月",
  december: "12月"
}, Es = "次", ks = "{{date}}", $s = "{{time}}", ws = "名前", Ts = "名前を入力してください", Ss = "メールアドレス", Cs = "メールアドレスを入力してください", xs = "ゲストのメールアドレス", Bs = "ゲストのメールアドレスを入力してください", Is = "ゲストを追加", Rs = "他のゲストを追加", As = "戻る", Ms = "今すぐ予約", Os = "予約が確認されました", Ds = "予約が再予定されました", Ns = "予約の日付と時間", Fs = "予約をキャンセル", Ls = "再調整", Ps = "予約をキャンセルしますか？", _s = "現在の時間枠は他の人に利用可能になります。", Us = "キャンセルの理由", Hs = "戻る", Ys = "予約が正常にキャンセルされました", js = "キャンセルメールが送信されました", zs = "閉じる", Ws = "閉じる", Gs = "{{field}} は必須です.", Ks = "{{field}} の形式が無効です.", qs = "予約作成", Vs = "空き状況を取得", Js = "予約をキャンセル", Zs = "予約の再スケジュール", Qs = "UI設定を取得", Xs = "何かがうまくいかなかった...", el = "セッションIDがありません！", tl = "セッションIDが必要です", nl = "無効な時間帯！", rl = "選択された時間帯は無効です", il = "キャンセルエラー", ol = "キャンセルの理由を入力してください。", al = "イベントの{{minCancellationNotice}}分前には予約をキャンセルできません", sl = "予約キャンセルフォームエラー", dp = {
  noDateSelected: ps,
  rescheduleTitle: ms,
  days: ys,
  time: bs,
  months: vs,
  nextButton: Es,
  selectedDayAndYear: ks,
  selectedTime: $s,
  name: ws,
  namePlaceholder: Ts,
  email: Ss,
  emailPlaceholder: Cs,
  guestEmail: xs,
  guestEmailPlaceholder: Bs,
  addGuest: Is,
  addAnotherGuest: Rs,
  backButton: As,
  bookNowButton: Ms,
  bookingConfirmed: Os,
  bookingRescheduled: Ds,
  bookingDateAndTimeHeader: Ns,
  cancelBookingButton: Fs,
  rescheduleBookingButton: Ls,
  cancelBookingTitle: Ps,
  cancelBookingMessage: _s,
  reasonForCancellation: Us,
  goBackButton: Hs,
  bookingCancelledTitle: Ys,
  bookingCancelledMessage: js,
  closeButton: zs,
  closingButton: Ws,
  fieldRequired: Gs,
  invalidInputFormat: Ks,
  createBookingErrorTitle: qs,
  getAvailabilityErrorTitle: Vs,
  cancelBookingErrorTitle: Js,
  rescheduleBookingErrorTitle: Zs,
  getUISettingErrorTitle: Qs,
  genericErrorTitle: Xs,
  noSessionIdErrorTitle: el,
  noSessionIdErrorMessage: tl,
  invalidTimeslotErrorTitle: nl,
  invalidTimeslotErrorMessage: rl,
  cancellationErrorTitle: il,
  cancellationErrorMessage: ol,
  minimumCancellationErrorMessage: al,
  cancelBokingFormError: sl
}, fp = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  noDateSelected: ps,
  rescheduleTitle: ms,
  days: ys,
  time: bs,
  months: vs,
  nextButton: Es,
  selectedDayAndYear: ks,
  selectedTime: $s,
  name: ws,
  namePlaceholder: Ts,
  email: Ss,
  emailPlaceholder: Cs,
  guestEmail: xs,
  guestEmailPlaceholder: Bs,
  addGuest: Is,
  addAnotherGuest: Rs,
  backButton: As,
  bookNowButton: Ms,
  bookingConfirmed: Os,
  bookingRescheduled: Ds,
  bookingDateAndTimeHeader: Ns,
  cancelBookingButton: Fs,
  rescheduleBookingButton: Ls,
  cancelBookingTitle: Ps,
  cancelBookingMessage: _s,
  reasonForCancellation: Us,
  goBackButton: Hs,
  bookingCancelledTitle: Ys,
  bookingCancelledMessage: js,
  closeButton: zs,
  closingButton: Ws,
  fieldRequired: Gs,
  invalidInputFormat: Ks,
  createBookingErrorTitle: qs,
  getAvailabilityErrorTitle: Vs,
  cancelBookingErrorTitle: Js,
  rescheduleBookingErrorTitle: Zs,
  getUISettingErrorTitle: Qs,
  genericErrorTitle: Xs,
  noSessionIdErrorTitle: el,
  noSessionIdErrorMessage: tl,
  invalidTimeslotErrorTitle: nl,
  invalidTimeslotErrorMessage: rl,
  cancellationErrorTitle: il,
  cancellationErrorMessage: ol,
  minimumCancellationErrorMessage: al,
  cancelBokingFormError: sl,
  default: dp
}), ll = "Kein Datum ausgewählt", cl = "Wählen Sie einen anderen Zeitpunkt, um Ihr Meeting neu zu planen", ul = {
  sunday: "SO",
  monday: "MO",
  tuesday: "DI",
  wednesday: "MI",
  thursday: "DO",
  friday: "FR",
  saturday: "SA"
}, dl = {
  hour: "Stunde",
  hours: "Stunden",
  minute: "Minute",
  minutes: "Minuten"
}, fl = {
  january: "Januar",
  february: "Februar",
  march: "März",
  april: "April",
  may: "Mai",
  june: "Juni",
  july: "Juli",
  august: "August",
  september: "September",
  october: "Oktober",
  november: "November",
  december: "Dezember"
}, hl = "Weiter", gl = "{{date}}", pl = "{{time}}", ml = "Name", yl = "Geben Sie Ihren Namen ein", bl = "E-Mail", vl = "Geben Sie Ihre E-Mail-Adresse ein", El = "Gast E-Mail", kl = "Geben Sie die E-Mail-Adresse des Gastes ein", $l = "Gast hinzufügen", wl = "Weiteren Gast hinzufügen", Tl = "Zurück", Sl = "Jetzt buchen", Cl = "Buchung bestätigt", xl = "Buchung umgebucht", Bl = "Buchungsdatum und -zeit", Il = "Buchung stornieren", Rl = "Umplanen", Al = "Buchung stornieren?", Ml = "Ihr aktueller Zeitraum wird für andere verfügbar.", Ol = "Grund für die Stornierung", Dl = "Zurück", Nl = "Ihre Buchung wurde erfolgreich storniert", Fl = "Eine Stornierungs-E-Mail wurde gesendet an", Ll = "Schließen", Pl = "Schließen", _l = "{{field}} ist erforderlich.", Ul = "{{field}} hat ein ungültiges Format.", Hl = "Buchung Erstellen", Yl = "Verfügbarkeit Ermitteln", jl = "Buchung Stornieren", zl = "Buchung Verschieben", Wl = "UI-Einstellungen Abrufen", Gl = "Etwas ist schief gelaufen...", Kl = "Keine Sitzungs-ID!", ql = "Sitzungs-ID ist erforderlich", Vl = "Ungültiges Zeitfenster!", Jl = "Das ausgewählte Zeitfenster ist ungültig", Zl = "Stornierungsfehler", Ql = "Bitte geben Sie einen Grund für die Stornierung an.", Xl = "Sie können die Buchung nicht innerhalb von {{minCancellationNotice}} Minuten vor der Veranstaltung stornieren", ec = "Fehler im Stornierungsformular", hp = {
  noDateSelected: ll,
  rescheduleTitle: cl,
  days: ul,
  time: dl,
  months: fl,
  nextButton: hl,
  selectedDayAndYear: gl,
  selectedTime: pl,
  name: ml,
  namePlaceholder: yl,
  email: bl,
  emailPlaceholder: vl,
  guestEmail: El,
  guestEmailPlaceholder: kl,
  addGuest: $l,
  addAnotherGuest: wl,
  backButton: Tl,
  bookNowButton: Sl,
  bookingConfirmed: Cl,
  bookingRescheduled: xl,
  bookingDateAndTimeHeader: Bl,
  cancelBookingButton: Il,
  rescheduleBookingButton: Rl,
  cancelBookingTitle: Al,
  cancelBookingMessage: Ml,
  reasonForCancellation: Ol,
  goBackButton: Dl,
  bookingCancelledTitle: Nl,
  bookingCancelledMessage: Fl,
  closeButton: Ll,
  closingButton: Pl,
  fieldRequired: _l,
  invalidInputFormat: Ul,
  createBookingErrorTitle: Hl,
  getAvailabilityErrorTitle: Yl,
  cancelBookingErrorTitle: jl,
  rescheduleBookingErrorTitle: zl,
  getUISettingErrorTitle: Wl,
  genericErrorTitle: Gl,
  noSessionIdErrorTitle: Kl,
  noSessionIdErrorMessage: ql,
  invalidTimeslotErrorTitle: Vl,
  invalidTimeslotErrorMessage: Jl,
  cancellationErrorTitle: Zl,
  cancellationErrorMessage: Ql,
  minimumCancellationErrorMessage: Xl,
  cancelBokingFormError: ec
}, gp = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  noDateSelected: ll,
  rescheduleTitle: cl,
  days: ul,
  time: dl,
  months: fl,
  nextButton: hl,
  selectedDayAndYear: gl,
  selectedTime: pl,
  name: ml,
  namePlaceholder: yl,
  email: bl,
  emailPlaceholder: vl,
  guestEmail: El,
  guestEmailPlaceholder: kl,
  addGuest: $l,
  addAnotherGuest: wl,
  backButton: Tl,
  bookNowButton: Sl,
  bookingConfirmed: Cl,
  bookingRescheduled: xl,
  bookingDateAndTimeHeader: Bl,
  cancelBookingButton: Il,
  rescheduleBookingButton: Rl,
  cancelBookingTitle: Al,
  cancelBookingMessage: Ml,
  reasonForCancellation: Ol,
  goBackButton: Dl,
  bookingCancelledTitle: Nl,
  bookingCancelledMessage: Fl,
  closeButton: Ll,
  closingButton: Pl,
  fieldRequired: _l,
  invalidInputFormat: Ul,
  createBookingErrorTitle: Hl,
  getAvailabilityErrorTitle: Yl,
  cancelBookingErrorTitle: jl,
  rescheduleBookingErrorTitle: zl,
  getUISettingErrorTitle: Wl,
  genericErrorTitle: Gl,
  noSessionIdErrorTitle: Kl,
  noSessionIdErrorMessage: ql,
  invalidTimeslotErrorTitle: Vl,
  invalidTimeslotErrorMessage: Jl,
  cancellationErrorTitle: Zl,
  cancellationErrorMessage: Ql,
  minimumCancellationErrorMessage: Xl,
  cancelBokingFormError: ec,
  default: hp
}), tc = "Ingen dag vald", nc = "Välj en annan tid för att boka om din tid", rc = {
  sunday: "SÖN",
  monday: "MÅN",
  tuesday: "TIS",
  wednesday: "ONS",
  thursday: "TOR",
  friday: "FRE",
  saturday: "LÖR"
}, ic = {
  hour: "timme",
  hours: "timmar",
  minute: "minut",
  minutes: "minuter"
}, oc = {
  january: "Januari",
  february: "Februari",
  march: "Mars",
  april: "April",
  may: "Maj",
  june: "Juni",
  july: "Juli",
  august: "Augusti",
  september: "September",
  october: "Oktober",
  november: "November",
  december: "December"
}, ac = "Nästa", sc = "{{date}}", lc = "{{time}}", cc = "Namn", uc = "Ange ditt namn", dc = "E-post", fc = "Ange din e-postadress", hc = "Gästens e-post", gc = "Ange gästens e-postadress", pc = "Lägg till gäst", mc = "Lägg till en gäst till", yc = "Tillbaka", bc = "Boka nu", vc = "Bokning bekräftad", Ec = "Bokning ombokad", kc = "Bokningsdatum och tid", $c = "Avboka bokning", wc = "Omboka", Tc = "Avboka bokning?", Sc = "Din nuvarande tidslucka kommer att bli tillgänglig för andra.", Cc = "Anledning till avbokning", xc = "Gå tillbaka", Bc = "Din bokning har avbokats framgångsrikt", Ic = "Ett avbokningsmejl har skickats till", Rc = "Stäng", Ac = "Stänger", Mc = "{{field}} är obligatoriskt.", Oc = "{{field}} har ogiltigt format.", Dc = "Skapa Bokning", Nc = "Hämta Tillgänglighet", Fc = "Avboka Bokning", Lc = "Omboka Bokning", Pc = "Hämta UI-inställningar", _c = "Något gick fel...", Uc = "Ingen sessionId!", Hc = "Session ID krävs", Yc = "Ogiltig tidslucka!", jc = "Den valda tidsluckan är ogiltig", zc = "Avbokningsfel", Wc = "Vänligen ange en anledning till avbokningen.", Gc = "Du kan inte avboka bokningen inom {{minCancellationNotice}} minuter före evenemanget", Kc = "Fel i avbokningsformuläret", pp = {
  noDateSelected: tc,
  rescheduleTitle: nc,
  days: rc,
  time: ic,
  months: oc,
  nextButton: ac,
  selectedDayAndYear: sc,
  selectedTime: lc,
  name: cc,
  namePlaceholder: uc,
  email: dc,
  emailPlaceholder: fc,
  guestEmail: hc,
  guestEmailPlaceholder: gc,
  addGuest: pc,
  addAnotherGuest: mc,
  backButton: yc,
  bookNowButton: bc,
  bookingConfirmed: vc,
  bookingRescheduled: Ec,
  bookingDateAndTimeHeader: kc,
  cancelBookingButton: $c,
  rescheduleBookingButton: wc,
  cancelBookingTitle: Tc,
  cancelBookingMessage: Sc,
  reasonForCancellation: Cc,
  goBackButton: xc,
  bookingCancelledTitle: Bc,
  bookingCancelledMessage: Ic,
  closeButton: Rc,
  closingButton: Ac,
  fieldRequired: Mc,
  invalidInputFormat: Oc,
  createBookingErrorTitle: Dc,
  getAvailabilityErrorTitle: Nc,
  cancelBookingErrorTitle: Fc,
  rescheduleBookingErrorTitle: Lc,
  getUISettingErrorTitle: Pc,
  genericErrorTitle: _c,
  noSessionIdErrorTitle: Uc,
  noSessionIdErrorMessage: Hc,
  invalidTimeslotErrorTitle: Yc,
  invalidTimeslotErrorMessage: jc,
  cancellationErrorTitle: zc,
  cancellationErrorMessage: Wc,
  minimumCancellationErrorMessage: Gc,
  cancelBokingFormError: Kc
}, mp = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  noDateSelected: tc,
  rescheduleTitle: nc,
  days: rc,
  time: ic,
  months: oc,
  nextButton: ac,
  selectedDayAndYear: sc,
  selectedTime: lc,
  name: cc,
  namePlaceholder: uc,
  email: dc,
  emailPlaceholder: fc,
  guestEmail: hc,
  guestEmailPlaceholder: gc,
  addGuest: pc,
  addAnotherGuest: mc,
  backButton: yc,
  bookNowButton: bc,
  bookingConfirmed: vc,
  bookingRescheduled: Ec,
  bookingDateAndTimeHeader: kc,
  cancelBookingButton: $c,
  rescheduleBookingButton: wc,
  cancelBookingTitle: Tc,
  cancelBookingMessage: Sc,
  reasonForCancellation: Cc,
  goBackButton: xc,
  bookingCancelledTitle: Bc,
  bookingCancelledMessage: Ic,
  closeButton: Rc,
  closingButton: Ac,
  fieldRequired: Mc,
  invalidInputFormat: Oc,
  createBookingErrorTitle: Dc,
  getAvailabilityErrorTitle: Nc,
  cancelBookingErrorTitle: Fc,
  rescheduleBookingErrorTitle: Lc,
  getUISettingErrorTitle: Pc,
  genericErrorTitle: _c,
  noSessionIdErrorTitle: Uc,
  noSessionIdErrorMessage: Hc,
  invalidTimeslotErrorTitle: Yc,
  invalidTimeslotErrorMessage: jc,
  cancellationErrorTitle: zc,
  cancellationErrorMessage: Wc,
  minimumCancellationErrorMessage: Gc,
  cancelBokingFormError: Kc,
  default: pp
}), qc = "请选择日期", Vc = "选择另一个时间段重新安排您的会议", Jc = {
  sunday: "周日",
  monday: "周一",
  tuesday: "周二",
  wednesday: "周三",
  thursday: "周四",
  friday: "周五",
  saturday: "周六"
}, Zc = {
  hour: "小时",
  hours: "小时",
  minute: "分钟",
  minutes: "分钟"
}, Qc = {
  january: "一月",
  february: "二月",
  march: "三月",
  april: "四月",
  may: "五月",
  june: "六月",
  july: "七月",
  august: "八月",
  september: "九月",
  october: "十月",
  november: "十一月",
  december: "十二月"
}, Xc = "下一个", eu = "{{date}}", tu = "{{time}}", nu = "姓名", ru = "输入你的名字", iu = "电子邮件", ou = "输入你的电子邮件", au = "客人的电子邮件", su = "输入客人的电子邮件", lu = "添加客人", cu = "添加另一个客人", uu = "返回", du = "立即预订", fu = "预订已确认", hu = "预订已重新安排", gu = "预订日期和时间", pu = "取消预订", mu = "重新安排", yu = "取消预订？", bu = "您当前的时间段将对其他人开放。", vu = "取消原因", Eu = "返回", ku = "您的预订已成功取消", $u = "取消邮件已发送至", wu = "关闭", Tu = "关闭", Su = "{{field}} 是必需的.", Cu = "{{field}} 格式无效.", xu = "创建预订", Bu = "获取可用性", Iu = "取消预订", Ru = "重新安排预订", Au = "获取UI设置", Mu = "出了点问题...", Ou = "没有sessionId！", Du = "需要会话ID", Nu = "无效的时间段！", Fu = "所选时间段无效", Lu = "取消错误", Pu = "请提供取消的原因。", _u = "您不能在活动开始前的{{minCancellationNotice}}分钟内取消预订", Uu = "取消预订表单错误", yp = {
  noDateSelected: qc,
  rescheduleTitle: Vc,
  days: Jc,
  time: Zc,
  months: Qc,
  nextButton: Xc,
  selectedDayAndYear: eu,
  selectedTime: tu,
  name: nu,
  namePlaceholder: ru,
  email: iu,
  emailPlaceholder: ou,
  guestEmail: au,
  guestEmailPlaceholder: su,
  addGuest: lu,
  addAnotherGuest: cu,
  backButton: uu,
  bookNowButton: du,
  bookingConfirmed: fu,
  bookingRescheduled: hu,
  bookingDateAndTimeHeader: gu,
  cancelBookingButton: pu,
  rescheduleBookingButton: mu,
  cancelBookingTitle: yu,
  cancelBookingMessage: bu,
  reasonForCancellation: vu,
  goBackButton: Eu,
  bookingCancelledTitle: ku,
  bookingCancelledMessage: $u,
  closeButton: wu,
  closingButton: Tu,
  fieldRequired: Su,
  invalidInputFormat: Cu,
  createBookingErrorTitle: xu,
  getAvailabilityErrorTitle: Bu,
  cancelBookingErrorTitle: Iu,
  rescheduleBookingErrorTitle: Ru,
  getUISettingErrorTitle: Au,
  genericErrorTitle: Mu,
  noSessionIdErrorTitle: Ou,
  noSessionIdErrorMessage: Du,
  invalidTimeslotErrorTitle: Nu,
  invalidTimeslotErrorMessage: Fu,
  cancellationErrorTitle: Lu,
  cancellationErrorMessage: Pu,
  minimumCancellationErrorMessage: _u,
  cancelBokingFormError: Uu
}, bp = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  noDateSelected: qc,
  rescheduleTitle: Vc,
  days: Jc,
  time: Zc,
  months: Qc,
  nextButton: Xc,
  selectedDayAndYear: eu,
  selectedTime: tu,
  name: nu,
  namePlaceholder: ru,
  email: iu,
  emailPlaceholder: ou,
  guestEmail: au,
  guestEmailPlaceholder: su,
  addGuest: lu,
  addAnotherGuest: cu,
  backButton: uu,
  bookNowButton: du,
  bookingConfirmed: fu,
  bookingRescheduled: hu,
  bookingDateAndTimeHeader: gu,
  cancelBookingButton: pu,
  rescheduleBookingButton: mu,
  cancelBookingTitle: yu,
  cancelBookingMessage: bu,
  reasonForCancellation: vu,
  goBackButton: Eu,
  bookingCancelledTitle: ku,
  bookingCancelledMessage: $u,
  closeButton: wu,
  closingButton: Tu,
  fieldRequired: Su,
  invalidInputFormat: Cu,
  createBookingErrorTitle: xu,
  getAvailabilityErrorTitle: Bu,
  cancelBookingErrorTitle: Iu,
  rescheduleBookingErrorTitle: Ru,
  getUISettingErrorTitle: Au,
  genericErrorTitle: Mu,
  noSessionIdErrorTitle: Ou,
  noSessionIdErrorMessage: Du,
  invalidTimeslotErrorTitle: Nu,
  invalidTimeslotErrorMessage: Fu,
  cancellationErrorTitle: Lu,
  cancellationErrorMessage: Pu,
  minimumCancellationErrorMessage: _u,
  cancelBokingFormError: Uu,
  default: yp
}), Hu = "Geen datum geselecteerd", Yu = "Kies een ander tijdslot om je afspraak te verzetten", ju = {
  sunday: "ZO",
  monday: "MA",
  tuesday: "DI",
  wednesday: "WO",
  thursday: "DO",
  friday: "VR",
  saturday: "ZA"
}, zu = {
  hour: "uur",
  hours: "uren",
  minute: "minuut",
  minutes: "minuten"
}, Wu = {
  january: "Januari",
  february: "Februari",
  march: "Maart",
  april: "April",
  may: "Mei",
  june: "Juni",
  july: "Juli",
  august: "Augustus",
  september: "September",
  october: "Oktober",
  november: "November",
  december: "December"
}, Gu = "Volgende", Ku = "{{date}}", qu = "{{time}}", Vu = "Naam", Ju = "Voer je naam in", Zu = "E-mail", Qu = "Voer je e-mail in", Xu = "E-mail van gast", ed = "Voer het e-mailadres van de gast in", td = "Gast toevoegen", nd = "Nog een gast toevoegen", rd = "Terug", id = "Boek nu", od = "Boeking bevestigd", ad = "Boeking verplaatst", sd = "Boekingsdatum en -tijd", ld = "Boeking annuleren", cd = "Herplannen", ud = "Boeking annuleren?", dd = "Uw huidige tijdslot zal beschikbaar worden voor anderen.", fd = "Reden voor annulering", hd = "Ga terug", gd = "Uw boeking is succesvol geannuleerd", pd = "Er is een annuleringsmail verzonden naar", md = "Sluiten", yd = "Sluiten", bd = "{{field}} is vereist.", vd = "{{field}} heeft een ongeldig formaat.", Ed = "Boeking Maken", kd = "Beschikbaarheid Opvragen", $d = "Boeking Annuleren", wd = "Boeking Wijzigen", Td = "UI-instellingen Ophalen", Sd = "Er is iets misgegaan...", Cd = "Geen sessie-ID!", xd = "Sessie-ID is vereist", Bd = "Ongeldig tijdslot!", Id = "Het geselecteerde tijdslot is ongeldig", Rd = "Annuleringsfout", Ad = "Geef een reden op voor de annulering.", Md = "U kunt de boeking niet annuleren binnen {{minCancellationNotice}} minuten voor het evenement", Od = "Fout in het annuleringsformulier", vp = {
  noDateSelected: Hu,
  rescheduleTitle: Yu,
  days: ju,
  time: zu,
  months: Wu,
  nextButton: Gu,
  selectedDayAndYear: Ku,
  selectedTime: qu,
  name: Vu,
  namePlaceholder: Ju,
  email: Zu,
  emailPlaceholder: Qu,
  guestEmail: Xu,
  guestEmailPlaceholder: ed,
  addGuest: td,
  addAnotherGuest: nd,
  backButton: rd,
  bookNowButton: id,
  bookingConfirmed: od,
  bookingRescheduled: ad,
  bookingDateAndTimeHeader: sd,
  cancelBookingButton: ld,
  rescheduleBookingButton: cd,
  cancelBookingTitle: ud,
  cancelBookingMessage: dd,
  reasonForCancellation: fd,
  goBackButton: hd,
  bookingCancelledTitle: gd,
  bookingCancelledMessage: pd,
  closeButton: md,
  closingButton: yd,
  fieldRequired: bd,
  invalidInputFormat: vd,
  createBookingErrorTitle: Ed,
  getAvailabilityErrorTitle: kd,
  cancelBookingErrorTitle: $d,
  rescheduleBookingErrorTitle: wd,
  getUISettingErrorTitle: Td,
  genericErrorTitle: Sd,
  noSessionIdErrorTitle: Cd,
  noSessionIdErrorMessage: xd,
  invalidTimeslotErrorTitle: Bd,
  invalidTimeslotErrorMessage: Id,
  cancellationErrorTitle: Rd,
  cancellationErrorMessage: Ad,
  minimumCancellationErrorMessage: Md,
  cancelBokingFormError: Od
}, Ep = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  noDateSelected: Hu,
  rescheduleTitle: Yu,
  days: ju,
  time: zu,
  months: Wu,
  nextButton: Gu,
  selectedDayAndYear: Ku,
  selectedTime: qu,
  name: Vu,
  namePlaceholder: Ju,
  email: Zu,
  emailPlaceholder: Qu,
  guestEmail: Xu,
  guestEmailPlaceholder: ed,
  addGuest: td,
  addAnotherGuest: nd,
  backButton: rd,
  bookNowButton: id,
  bookingConfirmed: od,
  bookingRescheduled: ad,
  bookingDateAndTimeHeader: sd,
  cancelBookingButton: ld,
  rescheduleBookingButton: cd,
  cancelBookingTitle: ud,
  cancelBookingMessage: dd,
  reasonForCancellation: fd,
  goBackButton: hd,
  bookingCancelledTitle: gd,
  bookingCancelledMessage: pd,
  closeButton: md,
  closingButton: yd,
  fieldRequired: bd,
  invalidInputFormat: vd,
  createBookingErrorTitle: Ed,
  getAvailabilityErrorTitle: kd,
  cancelBookingErrorTitle: $d,
  rescheduleBookingErrorTitle: wd,
  getUISettingErrorTitle: Td,
  genericErrorTitle: Sd,
  noSessionIdErrorTitle: Cd,
  noSessionIdErrorMessage: xd,
  invalidTimeslotErrorTitle: Bd,
  invalidTimeslotErrorMessage: Id,
  cancellationErrorTitle: Rd,
  cancellationErrorMessage: Ad,
  minimumCancellationErrorMessage: Md,
  cancelBokingFormError: Od,
  default: vp
});
An.init({
  lng: "en",
  resources: {
    en: {
      translation: ap
    },
    fr: {
      translation: lp
    },
    es: {
      translation: up
    },
    ja: {
      translation: fp
    },
    de: {
      translation: gp
    },
    sv: {
      translation: mp
    },
    zhcn: {
      translation: bp
    },
    nl: {
      translation: Ep
    }
  },
  interpolation: {
    escapeValue: !1
  }
});
function zp(...n) {
  window && window.localStorage && window.localStorage.getItem("debug") && (console.group(...n), console.trace(), console.groupEnd());
}
function Wp(...n) {
  console.error(...n);
}
function Gp() {
  return Math.random().toString(36).substr(2, 9);
}
function Kp(n) {
  return n.toString().replace(/^on/, "");
}
function qp(n) {
  const e = new Date(n * 1e3), t = /* @__PURE__ */ new Date(), r = new Date(t.getFullYear(), t.getMonth(), t.getDate());
  return e >= r ? new Intl.DateTimeFormat("default", {
    hour: "numeric",
    minute: "numeric",
    hour12: !0
  }).format(e) : new Intl.DateTimeFormat("default", {
    month: "short",
    day: "numeric"
  }).format(e);
}
function Vp(n) {
  return n.name ? `${n.name} - ${n.email}` : n.email;
}
function Jp(n, e = "", t = 1, r = 3) {
  const i = n.find((l) => {
    var c;
    return ((c = l.email) == null ? void 0 : c.toLowerCase()) === e.toLowerCase();
  }), o = n.filter((l) => {
    var c;
    return ((c = l.email) == null ? void 0 : c.toLowerCase()) !== e.toLowerCase();
  }), a = o.length, s = o.slice(0, r).map((l) => l.name || l.email).join(", ");
  return a === 0 ? i ? "me" : "" : a === 1 ? i && t > 1 ? `me, ${s}` : s : a === 2 ? i ? `me, ${s}` : `${s}` : i ? `me, ${s}, +${a - r}` : `${s}, +${a - r}`;
}
const Fr = [
  { amount: 60, name: "seconds" },
  { amount: 60, name: "minutes" },
  { amount: 24, name: "hours" },
  { amount: 7, name: "days" },
  { amount: 4.34524, name: "weeks" },
  { amount: 12, name: "months" },
  { amount: Number.POSITIVE_INFINITY, name: "years" }
], Zp = (n) => {
  const e = new Intl.RelativeTimeFormat(void 0, {
    numeric: "auto"
  }), t = /* @__PURE__ */ new Date();
  let r = (n.getTime() - t.getTime()) / 1e3;
  for (let i = 0; i <= Fr.length; i++) {
    const o = Fr[i];
    if (Math.abs(r) < o.amount)
      return e.format(Math.round(r), o.name);
    r /= o.amount;
  }
};
function Qp(n) {
  return new Date(n.getFullYear(), n.getMonth() + 1, 0);
}
function Xp(n) {
  return new Date(n.getFullYear(), n.getMonth(), 1);
}
function em(n, e) {
  return n.getFullYear() === e.getFullYear() && n.getMonth() === e.getMonth() && n.getDate() === e.getDate();
}
function tm(n, e) {
  return n.getFullYear() === e.getFullYear() && n.getMonth() === e.getMonth();
}
function nm(n) {
  return n.replace(/\w\S*/g, (e) => e.charAt(0).toUpperCase() + e.substr(1).toLowerCase());
}
function rm(n) {
  return n.replace("CATEGORY_", "").replace(/_/g, " ");
}
function kp(n) {
  return /<[^>]*>/g.test(n) ? "html" : "plain";
}
function im(n) {
  var i, o;
  const e = n.headers, t = e && ((i = e.find((a) => a.name === "Content-Type")) == null ? void 0 : i.value) || "", r = e && ((o = e.find((a) => a.name === "Content-Disposition")) == null ? void 0 : o.value) || "";
  return !!(t.includes("text/html") || r.includes("inline") || n.body && kp(n.body) === "html");
}
function om(n) {
  let r = n.split(`
`).filter((o) => o.trim().length > 0).map((o) => `<p>${o}</p>`).join("");
  const i = /((?:https?|ftp):\/\/[^\s]+)/g;
  return r = r.replace(i, '<a href="$1">$1</a>'), r;
}
function am(n) {
  return new DOMParser().parseFromString(n, "text/html").body.textContent || "";
}
const sm = (n) => n === "" ? !0 : /^(0[0-9]|1[0-2]|^[0-9])(:[0-5][0-9][ap]m?|:[0-5][0-9]|:[0-5]|:)?$/i.test(n), lm = (n) => /^(0[1-9]|1[0-2]):([0-5][0-9])(am|pm)$/i.test(n);
function cm(n = null) {
  let e = wi();
  n && (e = n);
  const t = e.minute() % 15;
  let r;
  return t !== 0 ? r = e.add(15 - t, "minute") : r = e, r;
}
function um(n) {
  const e = wi();
  let t = "";
  const [r, i] = n.split(":");
  r.length === 1 ? t += "0" + r : r.length === 2 && (t += r), t += ":", i === void 0 || i == "" ? t += "00" : i.length === 1 ? t += i + "0" : t += i;
  const o = t.slice(-1);
  return o === "a" && (t += "m"), o === "p" && (t += "m"), t.slice(-1) !== "m" && (t.split(":")[0] == "00" ? t += "am" : t += e.format("a")), t;
}
function dm(n) {
  const [e, t] = n.split(":").map((s) => parseInt(s, 10));
  let r = e;
  const i = r >= 12 ? "pm" : "am";
  r = r % 12, r = r || 12;
  const o = r.toString().padStart(2, "0"), a = t.toString().padStart(2, "0");
  return `${o}:${a}${i}`;
}
function fm(n) {
  const [e, t] = n.split(/(am|pm)/i), [r, i] = e.split(":").map((a) => parseInt(a, 10));
  let o = r;
  return t.toLowerCase() === "pm" && o < 12 ? o += 12 : t.toLowerCase() === "am" && o === 12 && (o = 0), `${o.toString().padStart(2, "0")}:${i.toString().padStart(2, "0")}`;
}
function hm(n) {
  const [e, t] = n.match(/(\d+):(\d+)(am|pm)/).slice(1);
  let r = parseInt(e, 10) * 60 + parseInt(t, 10);
  return n.includes("pm") && parseInt(e, 10) < 12 && (r += 12 * 60), n.includes("am") && parseInt(e, 10) === 12 && (r -= 12 * 60), r;
}
function gm(n) {
  const e = Math.floor(n / 60), t = n % 60;
  return `${e}:${t < 10 ? "0" : ""}${t}`;
}
function pm() {
  const n = navigator.userAgent, e = /Chrome/.test(n) && /Google Inc/.test(navigator.vendor), t = /Safari/.test(n) && /Apple Computer/.test(navigator.vendor), r = /Firefox/.test(n), i = /Trident/.test(n), o = /Edge/.test(n);
  return e && /Edg/.test(n) ? "Edge (Chromium)" : e ? "Chrome" : t ? "Safari" : r ? "Firefox" : i ? "Internet Explorer" : o ? "Edge (Legacy)" : "Unknown";
}
function Lr(n, e = null) {
  return e ? [null, e] : [n, null];
}
function mm(n, e) {
  const t = {
    "config.id": e == null ? void 0 : e.id,
    id: e == null ? void 0 : e.id
  };
  return Object.keys(t).forEach((r) => {
    n = n.replace(`{${r}}`, t[r]);
  }), n;
}
function ym(n) {
  if (n.keyCode < 48 || n.keyCode > 90 && n.keyCode < 96 || n.keyCode > 111 && n.keyCode < 186 || n.keyCode > 222 || n.keyCode === 32 || n.keyCode === 91 || n.keyCode === 92 || n.keyCode === 93 || n.keyCode >= 112 && n.keyCode <= 123 || n.keyCode >= 37 && n.keyCode <= 40 || n.ctrlKey || n.altKey || n.metaKey)
    return !0;
  const e = [
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    219,
    220,
    221,
    222
  ];
  return n.shiftKey && e.includes(n.keyCode), !1;
}
function bm(n, e) {
  const t = new Date(n);
  return t.setDate(t.getDate() + e), t.setHours(23), t.setMinutes(59), t.setSeconds(0), t.setMilliseconds(0), t;
}
function en(n) {
  return n && typeof n == "object" && !Array.isArray(n);
}
function Pr(n, e) {
  if (Array.isArray(n) && Array.isArray(e) && n !== e) {
    if (n.some((t) => t.is_organizer) && e.some((t) => t.is_organizer))
      n = n.map((t) => ({ ...t, is_organizer: !1 }));
    else if (!e.some((t) => t.is_organizer)) {
      let t = !1;
      n = n.map((r) => t ? r : (t = !0, { ...r, is_organizer: !0 }));
    }
    return n.map((t, r) => e[r] ? Pr(t, e[r]) : t).concat(e.slice(n.length));
  } else if (en(n) && en(e)) {
    const t = Object.assign({}, n);
    return Object.keys(e).forEach((r) => {
      en(e[r]) && r in n ? t[r] = Pr(n[r], e[r]) : t[r] = e[r];
    }), t;
  }
  return e;
}
function vm(n) {
  if (n < 60)
    return `${n} ${Et("time.minutes")}`;
  const e = Math.floor(n / 60), t = n % 60, r = Et(`time.${e > 1 ? "hours" : "hour"}`), i = t ? `${t} ${Et(`time.${t > 1 ? "minutes" : "minute"}`)}` : "";
  return `${e} ${r} ${i}`;
}
function Em(n, e) {
  n.forEach((t) => {
    var o;
    const r = (o = e.shadowRoot) == null ? void 0 : o.querySelector(`slot[name="${t}"]`), i = r == null ? void 0 : r.assignedNodes();
    i && i.length === 0 && console.warn(`${e.nodeName} No content provided for slot="${t}".`);
  });
}
function km(n) {
  const e = v.from(n, "base64"), t = e.slice(0, 16), r = e.slice(16, 32);
  function i(s) {
    const l = s.toString("hex");
    return `${l.slice(0, 8)}-${l.slice(8, 12)}-${l.slice(12, 16)}-${l.slice(16, 20)}-${l.slice(20)}`;
  }
  const o = i(t), a = i(r);
  return [o, a];
}
const Et = (n) => An.t(n), $m = (n) => typeof n != "string" ? "" : n.charAt(0).toUpperCase() + n.slice(1), wm = (n) => Et(`months.${n}`);
class Tm {
  constructor(e) {
    this.defaultAuthArgs = [], this.session = e;
  }
  setActiveGrantId(e) {
    this.activeGrantId = e;
  }
  async request({ method: e, path: t, body: r, headers: i }) {
    try {
      const o = await this.session.fetch(`grants/me/${t}`, {
        method: e,
        headers: i ? new Headers(i) : void 0,
        body: r,
        ...this.session.isMultiAccount() && this.activeGrantId ? { grant_id: this.activeGrantId } : {}
      });
      if (typeof o > "u")
        throw new Error("Response is undefined");
      return Lr(o);
    } catch (o) {
      let a = String(o);
      return String(o).includes("Access token not found") && (a = "Session expired, please log in again. Redirecting...", setTimeout(() => {
        localStorage.removeItem("grant"), localStorage.removeItem("user"), window.location.reload();
      }, 1e3)), Lr(null, {
        message: a
      });
    }
  }
  async currentUser() {
    const e = this.session.isMultiAccount() ? this.activeGrantId : void 0, t = await this.session.getProfile(e);
    return t ? {
      id: t.sub,
      email: t.email,
      name: t.name,
      provider: t.provider
    } : null;
  }
  async authenticationUrl(e) {
    const t = (e == null ? void 0 : e.provider) || "google";
    let i = this.defaultAuthArgs.find((o) => o.provider === t) || {};
    return e && (i = { ...i, ...e }), this.session.auth(i);
  }
  setDefaultAuthArgs(e) {
    this.defaultAuthArgs = e;
  }
}
ih({});
function Sm() {
  var n = [];
  if (typeof window < "u") {
    var e = window;
    (!e.customElements || e.Element && (!e.Element.prototype.closest || !e.Element.prototype.matches || !e.Element.prototype.remove || !e.Element.prototype.getRootNode)) && n.push(import(
      /* webpackChunkName: "polyfills-dom" */
      "./dom-86e17616.js"
    ));
    var t = function() {
      try {
        var r = new URL("b", "http://a");
        return r.pathname = "c%20d", r.href === "http://a/c%20d" && r.searchParams;
      } catch {
        return !1;
      }
    };
    (typeof Object.assign != "function" || !Object.entries || !Array.prototype.find || !Array.prototype.includes || !String.prototype.startsWith || !String.prototype.endsWith || e.NodeList && !e.NodeList.prototype.forEach || !e.fetch || !t() || typeof WeakMap > "u") && n.push(import(
      /* webpackChunkName: "polyfills-core-js" */
      "./core-js-a9d3b6e1.js"
    ));
  }
  return Promise.all(n);
}
async function $p() {
  await import("./elements-dc5b338e-5e8a704b.js");
}
const wp = $p, Tp = (n, e) => {
  if (!(typeof window > "u"))
    return wp(), Hf(JSON.parse('[["nylas-scheduler-editor",[[1,"nylas-scheduler-editor",{"configurationId":[1025,"configuration-id"],"nylasApiRequest":[1040],"nylasSessionsConfig":[16],"defaultAuthArgs":[16],"eventOverrides":[16],"schedulerPreviewLink":[1,"scheduler-preview-link"],"defaultSchedulerConfigState":[16],"mode":[1],"additionalParticipants":[16],"hideEditorTabs":[16],"conferenceProviders":[16],"automaticComponentRegistration":[32],"store":[64],"schedulerConnector":[64]},[[0,"registerComponent","registerComponentHandler"],[0,"unregisterComponent","unregisterComponentHandler"]],{"configurationId":["configurationIdChanged"]}]]],["nylas-scheduling",[[1,"nylas-scheduling",{"mode":[1],"defaultSchedulerState":[16],"sessionId":[1,"session-id"],"schedulerApiUrl":[1,"scheduler-api-url"],"bookingInfo":[16],"rescheduleBookingRef":[1,"reschedule-booking-ref"],"cancelBookingRef":[1,"cancel-booking-ref"],"configurationId":[1,"configuration-id"],"nylasBranding":[4,"nylas-branding"],"eventOverrides":[16],"isLoading":[4,"is-loading"],"themeConfig":[16],"showNotification":[4,"show-notification"],"automaticComponentRegistration":[32],"selectedDateLabel":[32],"refConfigId":[32],"language":[32],"getNylasSchedulerStore":[64],"getNylasSchedulerConnector":[64],"getRef":[64]},[[0,"languageChanged","languageChanged"],[0,"registerComponent","registerComponentHandler"],[0,"unregisterComponent","unregisterComponentHandler"],[0,"monthChanged","monthChangedHandler"],[0,"detailsConfirmed","bookButtonClickedHandler"],[0,"dateSelected","dateSelectedHandler"],[0,"cancelBookedEventError","cancelBookedEventErrorHandler"],[0,"cancelBookedEventValidationError","cancelBookedEventValidationErrorHandler"],[0,"rescheduleBookedEventError","rescheduleBookedEventErrorHandler"]],{"bookingInfo":["bookingInfoChanged"],"rescheduleBookingRef":["rescheduleBookingRefChanged"],"cancelBookingRef":["cancelBookingRefChanged"]}]]],["nylas-view-thread",[[1,"nylas-view-thread",{"draft":[16],"thread":[16],"messages":[16],"attachments":[16],"state":[32],"internalMessages":[32],"showAllEmails":[32],"showComposer":[32]},null,{"thread":["threadChanged"],"messages":["updateInternalMessages"]}]]],["nylas-list-folders",[[1,"nylas-list-folders",{"folders":[16],"selectedFolder":[1,"selected-folder"],"defaultFolders":[32],"otherFolders":[32]},null,{"folders":["watchFolders"]}]]],["nylas-custom-booking-flow",[[65,"nylas-custom-booking-flow",{"selectedConfiguration":[16],"name":[1],"bookingType":[1,"booking-type"],"selectedBookingType":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"]}]]],["nylas-mailbox-pagination",[[1,"nylas-mailbox-pagination",{"state":[1],"hasNextPage":[4,"has-next-page"],"hasPreviousPage":[4,"has-previous-page"],"scrollTarget":[1,"scroll-target"],"mobileOnlyInfiniteScroll":[4,"mobile-only-infinite-scroll"],"mobileViewPortWidth":[2,"mobile-view-port-width"],"nextPage":[64],"previousPage":[64]},[[9,"scroll","handlePageScroll"]]]]],["nylas-threads-refresh",[[1,"nylas-threads-refresh",{"start":[32],"state":[32],"pulling":[32],"updateState":[64]}]]],["checkmark-icon",[[2,"checkmark-icon",{"width":[1],"height":[1]}]]],["document-refresh-icon",[[2,"document-refresh-icon",{"width":[1],"height":[1]}]]],["nylas-if-state",[[1,"nylas-if-state",{"state":[1],"isStateSet":[4,"is-state-set"],"isBoolean":[4,"is-boolean"],"getStore":[16],"transition":[1],"show":[32],"classes":[32]},null,{"getStore":["onGetStoreChange"]}]]],["nylas-list-threads",[[1,"nylas-list-threads",{"threads":[16],"isAuthenticated":[4,"is-authenticated"],"tokenInfo":[16],"state":[1],"showCheckbox":[4,"show-checkbox"]}]]],["nylas-login",[[1,"nylas-login",{"isAuthenticated":[4,"is-authenticated"],"nylasConnector":[16],"scopes":[16],"loginMethod":[1,"login-method"],"companyName":[1,"company-name"],"logoUrl":[1,"logo-url"],"logoWidth":[1,"logo-width"],"providers":[1],"buttonText":[1,"button-text"],"email":[32]}]]],["nylas-mailbox",[[1,"nylas-mailbox",{"automaticComponentRegistration":[4,"automatic-component-registration"],"eventOverrides":[16],"authConfig":[16],"defaultAuthStoreState":[16],"defaultMailboxStoreState":[16],"getMailboxStore":[64],"getAuthStore":[64],"getNylasAuth":[64],"getNylasMailboxConnector":[64]},[[0,"registerComponent","registerComponentHandler"],[0,"unregisterComponent","unregisterComponentHandler"]]]]],["nylas-mailbox-toolbar-button",[[1,"nylas-mailbox-toolbar-button",{"method":[1],"dataState":[1,"data-state"],"iconOnly":[4,"icon-only"],"mailboxConnector":[16]}]]],["nylas-provider",[[1,"nylas-provider",{"authConfig":[16],"eventOverrides":[16],"automaticComponentRegistration":[4,"automatic-component-registration"],"getNylasAuth":[64],"getNylasConnector":[64],"getMailboxStore":[64],"getAuthStore":[64],"getNylasSchedulerStore":[64],"getNylasSchedulerConfigStore":[64]},[[0,"registerComponent","registerComponentHandler"],[0,"unregisterComponent","unregisterComponentHandler"]]]]],["nylas-threads-search",[[1,"nylas-threads-search",{"query":[1],"internalQuery":[32]},null,{"query":["onQueryChange"]}]]],["arrow-icon",[[2,"arrow-icon",{"width":[1],"height":[1]}]]],["person-icon",[[2,"person-icon",{"width":[1],"height":[1]}]]],["refresh-icon",[[2,"refresh-icon",{"width":[1],"height":[1]}]]],["textarea-component",[[1,"textarea-component",{"name":[1],"defaultValue":[1,"default-value"],"label":[1],"placeholder":[1],"required":[4],"readOnly":[4,"read-only"],"autoFocus":[4,"auto-focus"],"maxLength":[2,"max-length"],"type":[1],"value":[32],"error":[32]},[[4,"bookingFormSubmitted","handleBookingFormSubmitted"]]]]],["translate-icon",[[2,"translate-icon",{"width":[1],"height":[1]}]]],["warning-icon",[[2,"warning-icon",{"width":[1],"height":[1]}]]],["calendar-cancel-icon",[[2,"calendar-cancel-icon",{"width":[1],"height":[1]}]]],["chevron-icon_3",[[1,"select-dropdown",{"name":[1],"options":[16],"defaultSelectedOption":[16],"withSearch":[4,"with-search"],"label":[1],"required":[4],"pluralizedLabel":[1,"pluralized-label"],"dropdownButtonText":[1,"dropdown-button-text"],"withChevron":[4,"with-chevron"],"selectedOption":[32],"isOpen":[32],"searchValue":[32],"filteredOptions":[32],"ariaActivedescendant":[32],"errorMessage":[32]},[[4,"bookingFormSubmitted","handleBookingFormSubmitted"],[6,"click","handleOutsideClick"]],{"options":["optionsChangedHandler"],"defaultSelectedOption":["defaultSelectedOptionChangedHandler"]}],[2,"search-icon",{"width":[1],"height":[1]}],[2,"chevron-icon",{"width":[1],"height":[1]}]]],["multi-select-dropdown",[[1,"multi-select-dropdown",{"name":[1],"label":[1],"options":[16],"error":[1],"availableOptions":[32],"isOpen":[32],"ariaActivedescendant":[32],"shouldFocusFirstOption":[32]},[[6,"click","handleOutsideClick"]]]]],["calendar-check-icon_2",[[2,"calendar-check-icon",{"width":[1],"height":[1]}],[2,"checkmark-circle-icon",{"width":[1],"height":[1]}]]],["play-icon_2",[[2,"play-icon",{"width":[1],"height":[1]}],[2,"stop-icon",{"width":[1],"height":[1]}]]],["calendar-icon",[[2,"calendar-icon",{"width":[1],"height":[1]}]]],["nylas-time-window-picker",[[1,"nylas-time-window-picker",{"time":[1],"minimumStartTime":[1,"minimum-start-time"],"placeholder":[1],"name":[1],"hasError":[4,"has-error"],"err":[32],"showTimes":[32],"ariaActivedescendant":[32],"times":[32],"shouldAutoScroll":[32]},[[6,"click","handleOutsideClick"]],{"minimumStartTime":["minimumStartTimeChangedHandler"]}]]],["time-period-selector",[[2,"time-period-selector",{"timePeriods":[16],"defaultSelectedPeriod":[1,"default-selected-period"],"defaultSelectedNumber":[2,"default-selected-number"],"selectedPeriod":[32],"selectedNumber":[32],"numberOptions":[32],"timePeriodOptions":[32]},[[0,"inputOptionChanged","inputOptionChangedHandler"],[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"]],{"defaultSelectedPeriod":["defaultSelectedPeriodChangedHandler"],"defaultSelectedNumber":["defaultSelectedNumberChangedHandler"],"timePeriods":["timePeriodsChangedHandler"]}]]],["nylas-form-card",[[65,"nylas-form-card"]]],["copy-icon_3",[[2,"copy-icon",{"width":[1],"height":[1]}],[2,"delete-icon",{"width":[1],"height":[1]}],[2,"eye-icon",{"width":[1],"height":[1]}]]],["loading-icon",[[1,"loading-icon",{"width":[1],"height":[1]}]]],["globe-icon",[[2,"globe-icon",{"width":[1],"height":[1]}]]],["close-icon",[[2,"close-icon",{"width":[1],"height":[1]}]]],["info-icon_2",[[1,"tooltip-component",{"position":[1]}],[2,"info-icon",{"width":[1],"height":[1]}]]],["calendar-agenda-fill-icon_40",[[65,"nylas-reminder-emails",{"eventReminders":[16],"participants":[16],"name":[1],"reminders":[32],"reminderErrors":[32],"editingReminderIndex":[32]},[[0,"valueChanged","handleValueChanged"]],{"name":["elementNameChangedHandler"]}],[65,"nylas-participants-custom-availability",{"selectedConfiguration":[16],"name":[1],"participants":[16],"selectedParticipants":[32]},[[0,"nylasFormSwitchToggled","nylasFormSwitchToggledHandler"],[0,"valueChanged","handleValueChanged"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"participants":["participantsChangedHandler"]}],[65,"nylas-event-location",{"name":[1],"userProvider":[1,"user-provider"],"eventConferencing":[16],"conferenceProviders":[16],"selectedConfiguration":[16],"eventLocation":[1,"event-location"],"location":[32],"grantId":[32],"selectedLocationOption":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"eventLocation":["eventLocationChangedHandler"]}],[65,"nylas-booking-form-config",{"selectedConfiguration":[16],"name":[1],"additonalFields":[16],"formFields":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"],[0,"nylasFormInputChanged","nylasFormInputChangedHandler"]],{"name":["elementNameChangedHandler"],"formFields":["watchHandler"]}],[65,"nylas-confirmation-email",{"confirmationEmailTemplate":[16],"isOpen":[4,"is-open"],"participants":[16],"companyLogoErrorMessage":[1,"company-logo-error-message"],"name":[1],"confirmationEmail":[32]},[[0,"nylasFormInputChanged","nylasFormInputChangeHandler"],[0,"nylasFormInputBlurred","nylasFormInputBlurHandler"]],{"name":["elementNameChangedHandler"]}],[65,"nylas-additional-participants",{"selectedConfiguration":[16],"currentUser":[16],"name":[1],"eventParticipants":[16],"participantOptions":[16],"participants":[32],"participantErrors":[32],"includeOrganizerAsParticipant":[32],"isRoundRobinConfig":[32],"error":[32]},[[0,"inputOptionChanged","onInputOptionChanged"]],{"name":["elementNameChangedHandler"]}],[65,"nylas-limit-future-bookings",{"selectedConfiguration":[16],"availableDaysInFuture":[2,"available-days-in-future"],"name":[1],"selectedNumber":[32],"selectedPeriod":[32]},[[0,"timePeriodChanged","timePeriodChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"availableDaysInFuture":["availableDaysInFutureChanged"]}],[65,"nylas-min-booking-notice",{"selectedConfiguration":[16],"minBookingNotice":[2,"min-booking-notice"],"name":[1],"selectedNumber":[32],"selectedPeriod":[32]},[[0,"timePeriodChanged","timePeriodChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"availableDaysInFuture":["availableDaysInFutureChanged"]}],[65,"nylas-min-cancellation-notice",{"selectedConfiguration":[16],"minCancellationNotice":[2,"min-cancellation-notice"],"name":[1],"selectedNumber":[32],"selectedPeriod":[32]},[[0,"timePeriodChanged","timePeriodChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"availableDaysInFuture":["availableDaysInFutureChanged"]}],[65,"nylas-connected-calendars",{"name":[1],"participants":[16],"calendars":[16],"participantOptions":[16],"selectedCalendars":[32],"participantCalendars":[32],"participantDefaultSelectedCalendars":[32]},[[0,"valueChanged","handleValueChanged"]],{"name":["elementNameChangedHandler"],"calendars":["calendarsChangedHandler"],"participants":["participantsChangedHandler"],"participantOptions":["participantOptionsChangedHandler"]}],[65,"nylas-event-duration",{"selectedConfiguration":[16],"name":[1],"eventDurationMinutes":[2,"event-duration-minutes"],"duration":[32],"durationMinutes":[32],"durationIncrement":[32],"durationMinutesOptions":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"],[0,"inputOptionChanged","inputOptionChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"durationMinutes":["durationMinutesChangedHandler"]}],[65,"nylas-participant-booking-calendars",{"selectedConfiguration":[16],"name":[1],"participants":[16],"calendars":[16],"participantOptions":[16],"selectedCalendars":[32],"participantCalendars":[32],"participantDefaultSelectedCalendar":[32]},[[0,"valueChanged","handleValueChanged"]],{"name":["elementNameChangedHandler"],"calendars":["calendarsChangedHandler"],"participants":["participantsChangedHandler"],"participantOptions":["participantOptionsChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"]}],[65,"nylas-timeslot-interval",{"selectedConfiguration":[16],"name":[1],"eventDurationMinutes":[2,"event-duration-minutes"],"defaultIntervalMinutes":[2,"default-interval-minutes"],"defaultRoundTo":[2,"default-round-to"],"selectedInterval":[32],"selectedRoundTo":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"],[0,"nylasFormRadioChanged","nylasFormRadioChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"]}],[65,"nylas-buffer-time",{"name":[1],"buffer":[16],"selectedBeforeBufferTime":[32],"selectedAfterBufferTime":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"]],{"name":["elementNameChangedHandler"]}],[65,"nylas-customize-booking-settings",{"selectedConfiguration":[16],"defaultHideAdditionalGuests":[4,"default-hide-additional-guests"],"defaultHideCancellationOptions":[4,"default-hide-cancellation-options"],"defaultHideReschedulingOptions":[4,"default-hide-rescheduling-options"],"name":[1],"allowGuestsToInvite":[32],"hideCancellationOptions":[32],"hideReschedulingOptions":[32]},[[0,"nylasFormCheckboxToggled","checkboxToggledHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"]}],[65,"nylas-cancellation-policy",{"selectedConfiguration":[16],"cancellationPolicy":[1,"cancellation-policy"],"name":[1],"message":[32]},null,{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"]}],[65,"nylas-event-description",{"selectedConfiguration":[16],"eventDescription":[1,"event-description"],"name":[1],"description":[32]},null,{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"]}],[65,"nylas-event-title",{"selectedConfiguration":[16],"eventTitle":[1,"event-title"],"name":[1],"showTokens":[32],"availableTokens":[32],"filteredTokens":[32],"ariaActivedescendant":[32],"currentWord":[32],"validationError":[32],"configEventTitle":[32]},[[8,"formSubmitted","formSubmittedHandler"]],{"name":["elementNameChangedHandler"],"ariaActivedescendant":["ariaActivedescendantChangedHandler"],"selectedConfiguration":["configChangedHandler"]}],[65,"nylas-event-info"],[65,"nylas-event-limits"],[2,"calendar-agenda-fill-icon",{"width":[1],"height":[1]}],[2,"calendar-agenda-icon",{"width":[1],"height":[1]}],[2,"calendar-info-icon",{"width":[1],"height":[1]}],[2,"calendar-patterns-icon",{"width":[1],"height":[1]}],[2,"envelope-fill-icon",{"width":[1],"height":[1]}],[2,"envelope-icon",{"width":[1],"height":[1]}],[2,"flow-icon",{"width":[1],"height":[1]}],[2,"people-icon",{"width":[1],"height":[1]}],[65,"nylas-availability-picker",{"selectedConfiguration":[16],"openHours":[16],"name":[1],"defaultTimezone":[1,"default-timezone"],"hideHeader":[4,"hide-header"],"schedule":[32],"timezone":[32],"overlapDays":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"],[0,"timeChange","setTime"],[0,"formError","setFormError"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["configChangedHandler"],"schedule":["scheduleChanged"]}],[65,"nylas-booking-calendar-picker",{"calendars":[16],"currentUser":[16],"currentUserCalendars":[16],"name":[1],"defaultBookingCalendar":[1,"default-booking-calendar"],"hideHeader":[4,"hide-header"],"selectedCalendar":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"]],{"name":["elementNameChangedHandler"],"currentUserCalendars":["currentUserCalendarsChangedHandler"]}],[65,"nylas-calendar-picker",{"calendars":[16],"currentUser":[16],"name":[1],"defaultSelectedCalendars":[16],"selectedCalendars":[32],"error":[32]},[[0,"selectedOptionsChanged","selectedOptionsChangedHandler"]],{"name":["elementNameChangedHandler"]}],[65,"nylas-reminder-time",{"selectedConfiguration":[16],"name":[1],"eventReminderTimeMinutes":[2,"event-reminder-time-minutes"],"reminderTime":[32],"reminderTimeMinutes":[32],"reminderTimeincrement":[32],"reminderTimeMinutesOptions":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"],[0,"inputOptionChanged","inputOptionChangedHandler"]],{"name":["elementNameChangedHandler"],"reminderTimeMinutes":["reminderTimeMinutesChangedHandler"]}],[2,"dragable-icon",{"width":[1],"height":[1]}],[2,"google-meet-icon",{"width":[1],"height":[1]}],[2,"location-icon",{"width":[1],"height":[1]}],[2,"location-off-icon",{"width":[1],"height":[1]}],[2,"microsoft-teams-icon",{"width":[1],"height":[1]}],[1,"toggle-switch",{"name":[1],"checked":[4],"label":[1],"isChecked":[32]}],[2,"trash-icon",{"width":[1],"height":[1]}],[2,"zoom-icon",{"width":[1],"height":[1]}]]],["google-logo-icon_4",[[6,"nylas-editor-tabs",{"calendars":[16],"selectedConfiguration":[16],"currentUser":[16],"schedulerPreviewLink":[1,"scheduler-preview-link"],"mode":[1],"hideEditorTabs":[16],"action":[32],"activeTab":[32],"isLoading":[32],"hasUnsavedChanges":[32],"changesSaved":[32],"formState":[32],"error":[32]},[[0,"valueChanged","handleValueChanged"]],{"selectedConfiguration":["configChangedHandler"],"currentUser":["userChangedHandler"]}],[1,"nylas-list-configurations",{"configurations":[16],"schedulerPreviewLink":[1,"scheduler-preview-link"],"listConfigurationsNextCursor":[1,"list-configurations-next-cursor"],"state":[32],"error":[32],"currentCursor":[32],"previousCursors":[32],"disableNextPageButton":[32],"getState":[64],"setState":[64],"setError":[64]},[[0,"nylasFormDropdownChanged","handleNylasFormDropdownChanged"]],{"listConfigurationsNextCursor":["listConfigurationsNextCursorChangedHandler"]}],[2,"google-logo-icon",{"width":[1],"height":[1]}],[2,"microsoft-logo-icon",{"width":[1],"height":[1]}]]],["bold-icon_3",[[2,"bold-icon",{"width":[1],"height":[1]}],[2,"italic-icon",{"width":[1],"height":[1]}],[2,"underline-icon",{"width":[1],"height":[1]}]]],["forward-icon_6",[[1,"nylas-composer",{"message":[16],"viewEmailElement":[16]},null,{"message":["watchBody"]}],[1,"nylas-summarize-message-button",{"message":[16],"state":[32],"updateState":[64],"playAudio":[64]}],[2,"forward-icon",{"width":[1],"height":[1]}],[1,"nylas-view-email",{"message":[16],"parent":[16],"attachments":[16],"detectDarkMode":[4,"detect-dark-mode"],"state":[32],"sanitizedBody":[32],"styles":[32],"viewEmailElement":[32],"hoistedFontURLs":[32]},[[9,"resize","handleScroll"]],{"message":["messageChanged"],"viewEmailElement":["viewEmailElementChanged"]}],[2,"reply-all-icon",{"width":[1],"height":[1]}],[2,"reply-icon",{"width":[1],"height":[1]}]]],["archive-icon_7",[[2,"archive-icon",{"width":[1],"height":[1]}],[2,"folder-icon",{"width":[1],"height":[1]}],[2,"inbox-icon",{"width":[1],"height":[1]}],[2,"sent-icon",{"width":[1],"height":[1]}],[2,"spam-icon",{"width":[1],"height":[1]}],[2,"star-icon",{"width":[1],"height":[1]}],[2,"trash-fill-icon",{"width":[1],"height":[1]}]]],["button-component",[[6,"button-component",{"variant":[1],"disabled":[4],"type":[1],"clickHandler":[16],"mouseOverHandler":[16],"mouseOutHandler":[16],"focusHandler":[16],"blurHandler":[16]}]]],["checkbox-component_2",[[1,"checkbox-component",{"name":[1],"checked":[4],"label":[1],"required":[4],"isChecked":[32],"error":[32]},[[4,"bookingFormSubmitted","handleBookingFormSubmitted"]]],[1,"radio-button-group",{"name":[1],"options":[16],"defaultSelectedValue":[1,"default-selected-value"],"label":[1],"required":[4],"selectedValue":[32],"error":[32]},[[4,"bookingFormSubmitted","handleBookingFormSubmitted"]]]]],["input-dropdown",[[1,"input-dropdown",{"name":[1],"options":[16],"defaultInputOption":[16],"inputValue":[1,"input-value"],"pluralizedLabel":[1,"pluralized-label"],"filterable":[4],"selectedOption":[32],"isOpen":[32],"filteredOptions":[32],"ariaActivedescendant":[32],"shouldAutoScroll":[32]},[[6,"click","handleOutsideClick"]],{"options":["optionsChangedHandler"],"defaultInputOption":["defaultSelectedOptionChangedHandler"],"inputValue":["inputValueChangedHandler"]}]]],["add-circle-icon_2",[[1,"input-component",{"name":[1],"defaultValue":[1,"default-value"],"label":[1],"type":[1],"placeholder":[1],"required":[4],"readOnly":[4,"read-only"],"autoFocus":[4,"auto-focus"],"pattern":[16],"maxLength":[2,"max-length"],"patternError":[1,"pattern-error"],"requiredError":[1,"required-error"],"value":[32],"error":[32]},[[4,"bookingFormSubmitted","handleBookingFormSubmitted"]],{"defaultValue":["handleDefaultValueChange"]}],[2,"add-circle-icon",{"width":[1],"height":[1]}]]],["clock-icon_4",[[2,"person-clipboard-icon",{"width":[1],"height":[1]}],[2,"plus-icon",{"width":[1],"height":[1]}],[2,"edit-icon",{"width":[1],"height":[1]}],[2,"clock-icon",{"width":[1],"height":[1]}]]],["nylas-booked-event-card_10",[[1,"nylas-booking-form",{"isLoading":[4,"is-loading"],"bookingInfo":[8,"booking-info"],"eventInfo":[16],"configSettings":[8,"config-settings"],"name":[32],"email":[32],"guestEmails":[32],"guestEmailErrors":[32],"isNameValid":[32],"isEmailValid":[32],"additionalFields":[32],"validationError":[32]},[[0,"nylasFormInputChanged","nylasFormInputChangedHandler"],[0,"nylasFormDropdownChanged","selectOptionChangedHandler"],[0,"nylasFormSwitchToggled","switchToggledHandler"],[0,"nylasFormCheckboxToggled","checkboxToggledHandler"],[0,"nylasFormRadioChanged","radioChangedHandler"]],{"bookingInfo":["bookingInfoChangedHandler"]}],[1,"nylas-locale-switch",{"selectedTimezone":[1025,"selected-timezone"],"selectedLanguage":[1025,"selected-language"]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"]]],[1,"nylas-booked-event-card",{"eventInfo":[16],"rescheduleBookingId":[1,"reschedule-booking-id"],"bookingInfo":[8,"booking-info"],"selectedTimezone":[1,"selected-timezone"],"selectedTimeslot":[16],"configSettings":[8,"config-settings"],"isLoading":[4,"is-loading"],"selectedLanguage":[1,"selected-language"]}],[1,"nylas-date-picker",{"selectableDates":[16],"selectedDate":[16],"configSettings":[16],"selectedLanguage":[1,"selected-language"],"isLoading":[4,"is-loading"],"eventDuration":[2,"event-duration"],"month":[32],"dates":[32],"disableNextMonthButton":[32]},null,{"configSettings":["configSettingsChanged"],"selectedLanguage":["selectedLanguageChanged"]}],[1,"nylas-notification",{"ttl":[8],"allowedCategories":[16],"notifications":[32]},[[16,"nylasSchedulerError","onError"],[16,"nylasSchedulerWarning","onWarning"],[16,"nylasSchedulerInfo","onInfo"],[16,"nylasSchedulerSuccess","onSuccess"]]],[1,"nylas-selected-event-card",{"selectedDate":[16],"selectedTimeslot":[16],"selectedTimezone":[1,"selected-timezone"],"selectedLanguage":[1,"selected-language"],"startTime":[32],"endTime":[32]},null,{"selectedTimeslot":["handleSelectedTimeslotChange"]}],[1,"nylas-cancel-booking-form",{"cancelBookingId":[1,"cancel-booking-id"],"configSettings":[16],"selectedTimeslot":[16],"cancellationReason":[32],"cancellationError":[32],"cancellationPolicy":[32]},null,{"configSettings":["configSettingsChangedHandler"]}],[1,"nylas-cancelled-event-card",{"cancelledEventInfo":[16],"configSettings":[16],"isClosing":[32]}],[2,"nylas-logo",{"width":[1],"height":[1]}],[1,"nylas-timeslot-picker",{"selectedDate":[16],"availability":[16],"selectedTimeslot":[16],"isLoading":[4,"loading-state"],"selectedTimezone":[1,"selected-timezone"],"selectedLanguage":[1,"selected-language"],"times":[32],"hoveredTimeslotIndex":[32],"selectedTimeslotIndex":[32]},null,{"selectedLanguage":["selectedLanguageChanged"],"selectedDate":["selectedDateChanged"],"availability":["availabilityChanged"]}]]]]'), e);
};
(function() {
  if (typeof window < "u" && window.Reflect !== void 0 && window.customElements !== void 0) {
    var n = HTMLElement;
    window.HTMLElement = function() {
      return Reflect.construct(n, [], this.constructor);
    }, HTMLElement.prototype = n.prototype, HTMLElement.prototype.constructor = HTMLElement, Object.setPrototypeOf(HTMLElement, n);
  }
})();
var yn = { exports: {} }, at = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _r;
function Sp() {
  if (_r)
    return at;
  _r = 1;
  var n = Dt, e = Symbol.for("react.element"), t = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, c) {
    var u, f = {}, d = null, g = null;
    c !== void 0 && (d = "" + c), l.key !== void 0 && (d = "" + l.key), l.ref !== void 0 && (g = l.ref);
    for (u in l)
      r.call(l, u) && !o.hasOwnProperty(u) && (f[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        f[u] === void 0 && (f[u] = l[u]);
    return { $$typeof: e, type: s, key: d, ref: g, props: f, _owner: i.current };
  }
  return at.Fragment = t, at.jsx = a, at.jsxs = a, at;
}
var st = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ur;
function Cp() {
  return Ur || (Ur = 1, process.env.NODE_ENV !== "production" && function() {
    var n = Dt, e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), p = Symbol.iterator, y = "@@iterator";
    function b(h) {
      if (h === null || typeof h != "object")
        return null;
      var E = p && h[p] || h[y];
      return typeof E == "function" ? E : null;
    }
    var k = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(h) {
      {
        for (var E = arguments.length, S = new Array(E > 1 ? E - 1 : 0), D = 1; D < E; D++)
          S[D - 1] = arguments[D];
        Q("error", h, S);
      }
    }
    function Q(h, E, S) {
      {
        var D = k.ReactDebugCurrentFrame, Y = D.getStackAddendum();
        Y !== "" && (E += "%s", S = S.concat([Y]));
        var z = S.map(function(P) {
          return String(P);
        });
        z.unshift("Warning: " + E), Function.prototype.apply.call(console[h], console, z);
      }
    }
    var F = !1, K = !1, j = !1, V = !1, Ee = !1, J;
    J = Symbol.for("react.module.reference");
    function _(h) {
      return !!(typeof h == "string" || typeof h == "function" || h === r || h === o || Ee || h === i || h === c || h === u || V || h === g || F || K || j || typeof h == "object" && h !== null && (h.$$typeof === d || h.$$typeof === f || h.$$typeof === a || h.$$typeof === s || h.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      h.$$typeof === J || h.getModuleId !== void 0));
    }
    function me(h, E, S) {
      var D = h.displayName;
      if (D)
        return D;
      var Y = E.displayName || E.name || "";
      return Y !== "" ? S + "(" + Y + ")" : S;
    }
    function Ge(h) {
      return h.displayName || "Context";
    }
    function I(h) {
      if (h == null)
        return null;
      if (typeof h.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof h == "function")
        return h.displayName || h.name || null;
      if (typeof h == "string")
        return h;
      switch (h) {
        case r:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case s:
            var E = h;
            return Ge(E) + ".Consumer";
          case a:
            var S = h;
            return Ge(S._context) + ".Provider";
          case l:
            return me(h, h.render, "ForwardRef");
          case f:
            var D = h.displayName || null;
            return D !== null ? D : I(h.type) || "Memo";
          case d: {
            var Y = h, z = Y._payload, P = Y._init;
            try {
              return I(P(z));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var w = Object.assign, $ = 0, M, C, B, A, N, G, q;
    function ne() {
    }
    ne.__reactDisabledLog = !0;
    function Te() {
      {
        if ($ === 0) {
          M = console.log, C = console.info, B = console.warn, A = console.error, N = console.group, G = console.groupCollapsed, q = console.groupEnd;
          var h = {
            configurable: !0,
            enumerable: !0,
            value: ne,
            writable: !0
          };
          Object.defineProperties(console, {
            info: h,
            log: h,
            warn: h,
            error: h,
            group: h,
            groupCollapsed: h,
            groupEnd: h
          });
        }
        $++;
      }
    }
    function ke() {
      {
        if ($--, $ === 0) {
          var h = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: w({}, h, {
              value: M
            }),
            info: w({}, h, {
              value: C
            }),
            warn: w({}, h, {
              value: B
            }),
            error: w({}, h, {
              value: A
            }),
            group: w({}, h, {
              value: N
            }),
            groupCollapsed: w({}, h, {
              value: G
            }),
            groupEnd: w({}, h, {
              value: q
            })
          });
        }
        $ < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Me = k.ReactCurrentDispatcher, Oe;
    function $e(h, E, S) {
      {
        if (Oe === void 0)
          try {
            throw Error();
          } catch (Y) {
            var D = Y.stack.trim().match(/\n( *(at )?)/);
            Oe = D && D[1] || "";
          }
        return `
` + Oe + h;
      }
    }
    var re = !1, fe;
    {
      var rt = typeof WeakMap == "function" ? WeakMap : Map;
      fe = new rt();
    }
    function je(h, E) {
      if (!h || re)
        return "";
      {
        var S = fe.get(h);
        if (S !== void 0)
          return S;
      }
      var D;
      re = !0;
      var Y = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var z;
      z = Me.current, Me.current = null, Te();
      try {
        if (E) {
          var P = function() {
            throw Error();
          };
          if (Object.defineProperty(P.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(P, []);
            } catch (De) {
              D = De;
            }
            Reflect.construct(h, [], P);
          } else {
            try {
              P.call();
            } catch (De) {
              D = De;
            }
            h.call(P.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (De) {
            D = De;
          }
          h();
        }
      } catch (De) {
        if (De && D && typeof De.stack == "string") {
          for (var L = De.stack.split(`
`), ce = D.stack.split(`
`), X = L.length - 1, ee = ce.length - 1; X >= 1 && ee >= 0 && L[X] !== ce[ee]; )
            ee--;
          for (; X >= 1 && ee >= 0; X--, ee--)
            if (L[X] !== ce[ee]) {
              if (X !== 1 || ee !== 1)
                do
                  if (X--, ee--, ee < 0 || L[X] !== ce[ee]) {
                    var ye = `
` + L[X].replace(" at new ", " at ");
                    return h.displayName && ye.includes("<anonymous>") && (ye = ye.replace("<anonymous>", h.displayName)), typeof h == "function" && fe.set(h, ye), ye;
                  }
                while (X >= 1 && ee >= 0);
              break;
            }
        }
      } finally {
        re = !1, Me.current = z, ke(), Error.prepareStackTrace = Y;
      }
      var qe = h ? h.displayName || h.name : "", zn = qe ? $e(qe) : "";
      return typeof h == "function" && fe.set(h, zn), zn;
    }
    function Fd(h, E, S) {
      return je(h, !1);
    }
    function Ld(h) {
      var E = h.prototype;
      return !!(E && E.isReactComponent);
    }
    function pt(h, E, S) {
      if (h == null)
        return "";
      if (typeof h == "function")
        return je(h, Ld(h));
      if (typeof h == "string")
        return $e(h);
      switch (h) {
        case c:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case l:
            return Fd(h.render);
          case f:
            return pt(h.type, E, S);
          case d: {
            var D = h, Y = D._payload, z = D._init;
            try {
              return pt(z(Y), E, S);
            } catch {
            }
          }
        }
      return "";
    }
    var mt = Object.prototype.hasOwnProperty, Mn = {}, On = k.ReactDebugCurrentFrame;
    function yt(h) {
      if (h) {
        var E = h._owner, S = pt(h.type, h._source, E ? E.type : null);
        On.setExtraStackFrame(S);
      } else
        On.setExtraStackFrame(null);
    }
    function Pd(h, E, S, D, Y) {
      {
        var z = Function.call.bind(mt);
        for (var P in h)
          if (z(h, P)) {
            var L = void 0;
            try {
              if (typeof h[P] != "function") {
                var ce = Error((D || "React class") + ": " + S + " type `" + P + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof h[P] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ce.name = "Invariant Violation", ce;
              }
              L = h[P](E, P, D, S, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (X) {
              L = X;
            }
            L && !(L instanceof Error) && (yt(Y), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", D || "React class", S, P, typeof L), yt(null)), L instanceof Error && !(L.message in Mn) && (Mn[L.message] = !0, yt(Y), x("Failed %s type: %s", S, L.message), yt(null));
          }
      }
    }
    var _d = Array.isArray;
    function Yt(h) {
      return _d(h);
    }
    function Ud(h) {
      {
        var E = typeof Symbol == "function" && Symbol.toStringTag, S = E && h[Symbol.toStringTag] || h.constructor.name || "Object";
        return S;
      }
    }
    function Hd(h) {
      try {
        return Dn(h), !1;
      } catch {
        return !0;
      }
    }
    function Dn(h) {
      return "" + h;
    }
    function Nn(h) {
      if (Hd(h))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ud(h)), Dn(h);
    }
    var it = k.ReactCurrentOwner, Yd = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Fn, Ln, jt;
    jt = {};
    function jd(h) {
      if (mt.call(h, "ref")) {
        var E = Object.getOwnPropertyDescriptor(h, "ref").get;
        if (E && E.isReactWarning)
          return !1;
      }
      return h.ref !== void 0;
    }
    function zd(h) {
      if (mt.call(h, "key")) {
        var E = Object.getOwnPropertyDescriptor(h, "key").get;
        if (E && E.isReactWarning)
          return !1;
      }
      return h.key !== void 0;
    }
    function Wd(h, E) {
      if (typeof h.ref == "string" && it.current && E && it.current.stateNode !== E) {
        var S = I(it.current.type);
        jt[S] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', I(it.current.type), h.ref), jt[S] = !0);
      }
    }
    function Gd(h, E) {
      {
        var S = function() {
          Fn || (Fn = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", E));
        };
        S.isReactWarning = !0, Object.defineProperty(h, "key", {
          get: S,
          configurable: !0
        });
      }
    }
    function Kd(h, E) {
      {
        var S = function() {
          Ln || (Ln = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", E));
        };
        S.isReactWarning = !0, Object.defineProperty(h, "ref", {
          get: S,
          configurable: !0
        });
      }
    }
    var qd = function(h, E, S, D, Y, z, P) {
      var L = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: h,
        key: E,
        ref: S,
        props: P,
        // Record the component responsible for creating this element.
        _owner: z
      };
      return L._store = {}, Object.defineProperty(L._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(L, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: D
      }), Object.defineProperty(L, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Y
      }), Object.freeze && (Object.freeze(L.props), Object.freeze(L)), L;
    };
    function Vd(h, E, S, D, Y) {
      {
        var z, P = {}, L = null, ce = null;
        S !== void 0 && (Nn(S), L = "" + S), zd(E) && (Nn(E.key), L = "" + E.key), jd(E) && (ce = E.ref, Wd(E, Y));
        for (z in E)
          mt.call(E, z) && !Yd.hasOwnProperty(z) && (P[z] = E[z]);
        if (h && h.defaultProps) {
          var X = h.defaultProps;
          for (z in X)
            P[z] === void 0 && (P[z] = X[z]);
        }
        if (L || ce) {
          var ee = typeof h == "function" ? h.displayName || h.name || "Unknown" : h;
          L && Gd(P, ee), ce && Kd(P, ee);
        }
        return qd(h, L, ce, Y, D, it.current, P);
      }
    }
    var zt = k.ReactCurrentOwner, Pn = k.ReactDebugCurrentFrame;
    function Ke(h) {
      if (h) {
        var E = h._owner, S = pt(h.type, h._source, E ? E.type : null);
        Pn.setExtraStackFrame(S);
      } else
        Pn.setExtraStackFrame(null);
    }
    var Wt;
    Wt = !1;
    function Gt(h) {
      return typeof h == "object" && h !== null && h.$$typeof === e;
    }
    function _n() {
      {
        if (zt.current) {
          var h = I(zt.current.type);
          if (h)
            return `

Check the render method of \`` + h + "`.";
        }
        return "";
      }
    }
    function Jd(h) {
      {
        if (h !== void 0) {
          var E = h.fileName.replace(/^.*[\\\/]/, ""), S = h.lineNumber;
          return `

Check your code at ` + E + ":" + S + ".";
        }
        return "";
      }
    }
    var Un = {};
    function Zd(h) {
      {
        var E = _n();
        if (!E) {
          var S = typeof h == "string" ? h : h.displayName || h.name;
          S && (E = `

Check the top-level render call using <` + S + ">.");
        }
        return E;
      }
    }
    function Hn(h, E) {
      {
        if (!h._store || h._store.validated || h.key != null)
          return;
        h._store.validated = !0;
        var S = Zd(E);
        if (Un[S])
          return;
        Un[S] = !0;
        var D = "";
        h && h._owner && h._owner !== zt.current && (D = " It was passed a child from " + I(h._owner.type) + "."), Ke(h), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', S, D), Ke(null);
      }
    }
    function Yn(h, E) {
      {
        if (typeof h != "object")
          return;
        if (Yt(h))
          for (var S = 0; S < h.length; S++) {
            var D = h[S];
            Gt(D) && Hn(D, E);
          }
        else if (Gt(h))
          h._store && (h._store.validated = !0);
        else if (h) {
          var Y = b(h);
          if (typeof Y == "function" && Y !== h.entries)
            for (var z = Y.call(h), P; !(P = z.next()).done; )
              Gt(P.value) && Hn(P.value, E);
        }
      }
    }
    function Qd(h) {
      {
        var E = h.type;
        if (E == null || typeof E == "string")
          return;
        var S;
        if (typeof E == "function")
          S = E.propTypes;
        else if (typeof E == "object" && (E.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        E.$$typeof === f))
          S = E.propTypes;
        else
          return;
        if (S) {
          var D = I(E);
          Pd(S, h.props, "prop", D, h);
        } else if (E.PropTypes !== void 0 && !Wt) {
          Wt = !0;
          var Y = I(E);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Y || "Unknown");
        }
        typeof E.getDefaultProps == "function" && !E.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Xd(h) {
      {
        for (var E = Object.keys(h.props), S = 0; S < E.length; S++) {
          var D = E[S];
          if (D !== "children" && D !== "key") {
            Ke(h), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", D), Ke(null);
            break;
          }
        }
        h.ref !== null && (Ke(h), x("Invalid attribute `ref` supplied to `React.Fragment`."), Ke(null));
      }
    }
    function jn(h, E, S, D, Y, z) {
      {
        var P = _(h);
        if (!P) {
          var L = "";
          (h === void 0 || typeof h == "object" && h !== null && Object.keys(h).length === 0) && (L += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ce = Jd(Y);
          ce ? L += ce : L += _n();
          var X;
          h === null ? X = "null" : Yt(h) ? X = "array" : h !== void 0 && h.$$typeof === e ? (X = "<" + (I(h.type) || "Unknown") + " />", L = " Did you accidentally export a JSX literal instead of a component?") : X = typeof h, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", X, L);
        }
        var ee = Vd(h, E, S, Y, z);
        if (ee == null)
          return ee;
        if (P) {
          var ye = E.children;
          if (ye !== void 0)
            if (D)
              if (Yt(ye)) {
                for (var qe = 0; qe < ye.length; qe++)
                  Yn(ye[qe], h);
                Object.freeze && Object.freeze(ye);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Yn(ye, h);
        }
        return h === r ? Xd(ee) : Qd(ee), ee;
      }
    }
    function ef(h, E, S) {
      return jn(h, E, S, !0);
    }
    function tf(h, E, S) {
      return jn(h, E, S, !1);
    }
    var nf = tf, rf = ef;
    st.Fragment = r, st.jsx = nf, st.jsxs = rf;
  }()), st;
}
process.env.NODE_ENV === "production" ? yn.exports = Sp() : yn.exports = Cp();
var xp = yn.exports;
const Bp = (n) => n.toLowerCase().split("-").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(""), Dd = (n) => n.replace(/([A-Z])/g, (e) => `-${e[0].toLowerCase()}`), Ip = (n, e, t = {}) => {
  if (n instanceof Element) {
    const r = Rp(n.classList, e, t);
    r !== "" && (n.className = r), Object.keys(e).forEach((i) => {
      if (!(i === "children" || i === "style" || i === "ref" || i === "class" || i === "className" || i === "forwardedRef"))
        if (i.indexOf("on") === 0 && i[2] === i[2].toUpperCase()) {
          const o = i.substring(2), a = o[0].toLowerCase() + o.substring(1);
          Nd(a) || Mp(n, a, e[i]);
        } else
          n[i] = e[i], typeof e[i] === "string" && n.setAttribute(Dd(i), e[i]);
    });
  }
}, Rp = (n, e, t) => {
  const r = e.className || e.class, i = t.className || t.class, o = tn(n), a = tn(r ? r.split(" ") : []), s = tn(i ? i.split(" ") : []), l = [];
  return o.forEach((c) => {
    a.has(c) ? (l.push(c), a.delete(c)) : s.has(c) || l.push(c);
  }), a.forEach((c) => l.push(c)), l.join(" ");
}, Ap = (n) => {
  switch (n) {
    case "doubleclick":
      return "dblclick";
  }
  return n;
};
/**
 * Checks if an event is supported in the current execution environment.
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
const Nd = (n) => {
  if (typeof document > "u")
    return !0;
  {
    const e = "on" + Ap(n);
    let t = e in document;
    if (!t) {
      const r = document.createElement("div");
      r.setAttribute(e, "return;"), t = typeof r[e] == "function";
    }
    return t;
  }
}, Mp = (n, e, t) => {
  const r = n.__events || (n.__events = {}), i = r[e];
  i && n.removeEventListener(e, i), n.addEventListener(
    e,
    r[e] = function(a) {
      t && t.call(this, a);
    }
  );
}, tn = (n) => {
  const e = /* @__PURE__ */ new Map();
  return n.forEach((t) => e.set(t, t)), e;
}, Op = (n, e) => {
  typeof n == "function" ? n(e) : n != null && (n.current = e);
}, Dp = (...n) => (e) => {
  n.forEach((t) => {
    Op(t, e);
  });
}, Np = (n, e) => {
  const t = (r, i) => /* @__PURE__ */ xp.jsx(n, { ...r, forwardedRef: i });
  return t.displayName = e, Dt.forwardRef(t);
}, m = (n, e, t, r) => {
  r !== void 0 && r();
  const i = Bp(n), o = class extends Dt.Component {
    constructor(s) {
      super(s);
      Kt(this, "componentEl");
      Kt(this, "setComponentElRef", (s) => {
        this.componentEl = s;
      });
    }
    componentDidMount() {
      this.componentDidUpdate(this.props);
    }
    componentDidUpdate(s) {
      Ip(this.componentEl, this.props, s);
    }
    render() {
      const { children: s, forwardedRef: l, style: c, className: u, ref: f, ...d } = this.props;
      let g = Object.keys(d).reduce((y, b) => {
        const k = d[b];
        if (b.indexOf("on") === 0 && b[2] === b[2].toUpperCase()) {
          const x = b.substring(2).toLowerCase();
          typeof document < "u" && Nd(x) && (y[b] = k);
        } else {
          const x = typeof k;
          (x === "string" || x === "boolean" || x === "number") && (y[Dd(b)] = k);
        }
        return y;
      }, {});
      t && (g = t(this.props, g));
      const p = {
        ...g,
        ref: Dp(l, this.setComponentElRef),
        style: c
      };
      return sf(n, p, s);
    }
    static get displayName() {
      return i;
    }
  };
  return e && (o.contextType = e), Np(o, i);
};
Tp();
const Cm = /* @__PURE__ */ m("add-circle-icon"), xm = /* @__PURE__ */ m("archive-icon"), Bm = /* @__PURE__ */ m("arrow-icon"), Im = /* @__PURE__ */ m("bold-icon"), Rm = /* @__PURE__ */ m("button-component"), Am = /* @__PURE__ */ m("calendar-agenda-fill-icon"), Mm = /* @__PURE__ */ m("calendar-agenda-icon"), Om = /* @__PURE__ */ m("calendar-cancel-icon"), Dm = /* @__PURE__ */ m("calendar-check-icon"), Nm = /* @__PURE__ */ m("calendar-icon"), Fm = /* @__PURE__ */ m("calendar-info-icon"), Lm = /* @__PURE__ */ m("calendar-patterns-icon"), Pm = /* @__PURE__ */ m("checkbox-component"), _m = /* @__PURE__ */ m("checkmark-circle-icon"), Um = /* @__PURE__ */ m("checkmark-icon"), Hm = /* @__PURE__ */ m("chevron-icon"), Ym = /* @__PURE__ */ m("clock-icon"), jm = /* @__PURE__ */ m("close-icon"), zm = /* @__PURE__ */ m("copy-icon"), Wm = /* @__PURE__ */ m("delete-icon"), Gm = /* @__PURE__ */ m("document-refresh-icon"), Km = /* @__PURE__ */ m("dragable-icon"), qm = /* @__PURE__ */ m("edit-icon"), Vm = /* @__PURE__ */ m("envelope-fill-icon"), Jm = /* @__PURE__ */ m("envelope-icon"), Zm = /* @__PURE__ */ m("eye-icon"), Qm = /* @__PURE__ */ m("flow-icon"), Xm = /* @__PURE__ */ m("folder-icon"), ey = /* @__PURE__ */ m("forward-icon"), ty = /* @__PURE__ */ m("globe-icon"), ny = /* @__PURE__ */ m("google-logo-icon"), ry = /* @__PURE__ */ m("google-meet-icon"), iy = /* @__PURE__ */ m("inbox-icon"), oy = /* @__PURE__ */ m("info-icon"), ay = /* @__PURE__ */ m("input-component"), sy = /* @__PURE__ */ m("input-dropdown"), ly = /* @__PURE__ */ m("italic-icon"), cy = /* @__PURE__ */ m("loading-icon"), uy = /* @__PURE__ */ m("location-icon"), dy = /* @__PURE__ */ m("location-off-icon"), fy = /* @__PURE__ */ m("microsoft-logo-icon"), hy = /* @__PURE__ */ m("microsoft-teams-icon"), gy = /* @__PURE__ */ m("multi-select-dropdown"), py = /* @__PURE__ */ m("nylas-additional-participants"), my = /* @__PURE__ */ m("nylas-availability-picker"), yy = /* @__PURE__ */ m("nylas-booked-event-card"), by = /* @__PURE__ */ m("nylas-booking-calendar-picker"), vy = /* @__PURE__ */ m("nylas-booking-form"), Ey = /* @__PURE__ */ m("nylas-booking-form-config"), ky = /* @__PURE__ */ m("nylas-buffer-time"), $y = /* @__PURE__ */ m("nylas-calendar-picker"), wy = /* @__PURE__ */ m("nylas-cancel-booking-form"), Ty = /* @__PURE__ */ m("nylas-cancellation-policy"), Sy = /* @__PURE__ */ m("nylas-cancelled-event-card"), Cy = /* @__PURE__ */ m("nylas-composer"), xy = /* @__PURE__ */ m("nylas-confirmation-email"), By = /* @__PURE__ */ m("nylas-connected-calendars"), Iy = /* @__PURE__ */ m("nylas-custom-booking-flow"), Ry = /* @__PURE__ */ m("nylas-customize-booking-settings"), Ay = /* @__PURE__ */ m("nylas-date-picker"), My = /* @__PURE__ */ m("nylas-editor-tabs"), Oy = /* @__PURE__ */ m("nylas-event-description"), Dy = /* @__PURE__ */ m("nylas-event-duration"), Ny = /* @__PURE__ */ m("nylas-event-info"), Fy = /* @__PURE__ */ m("nylas-event-limits"), Ly = /* @__PURE__ */ m("nylas-event-location"), Py = /* @__PURE__ */ m("nylas-event-title"), _y = /* @__PURE__ */ m("nylas-form-card"), Uy = /* @__PURE__ */ m("nylas-if-state"), Hy = /* @__PURE__ */ m("nylas-limit-future-bookings"), Yy = /* @__PURE__ */ m("nylas-list-configurations"), jy = /* @__PURE__ */ m("nylas-list-folders"), zy = /* @__PURE__ */ m("nylas-list-threads"), Wy = /* @__PURE__ */ m("nylas-locale-switch"), Gy = /* @__PURE__ */ m("nylas-login"), Ky = /* @__PURE__ */ m("nylas-logo"), qy = /* @__PURE__ */ m("nylas-mailbox"), Vy = /* @__PURE__ */ m("nylas-mailbox-pagination"), Jy = /* @__PURE__ */ m("nylas-mailbox-toolbar-button"), Zy = /* @__PURE__ */ m("nylas-min-booking-notice"), Qy = /* @__PURE__ */ m("nylas-min-cancellation-notice"), Xy = /* @__PURE__ */ m("nylas-notification"), eb = /* @__PURE__ */ m("nylas-participant-booking-calendars"), tb = /* @__PURE__ */ m("nylas-participants-custom-availability"), nb = /* @__PURE__ */ m("nylas-provider"), rb = /* @__PURE__ */ m("nylas-reminder-emails"), ib = /* @__PURE__ */ m("nylas-reminder-time"), ob = /* @__PURE__ */ m("nylas-scheduler-editor"), ab = /* @__PURE__ */ m("nylas-scheduling"), sb = /* @__PURE__ */ m("nylas-selected-event-card"), lb = /* @__PURE__ */ m("nylas-summarize-message-button"), cb = /* @__PURE__ */ m("nylas-threads-refresh"), ub = /* @__PURE__ */ m("nylas-threads-search"), db = /* @__PURE__ */ m("nylas-time-window-picker"), fb = /* @__PURE__ */ m("nylas-timeslot-interval"), hb = /* @__PURE__ */ m("nylas-timeslot-picker"), gb = /* @__PURE__ */ m("nylas-view-email"), pb = /* @__PURE__ */ m("nylas-view-thread"), mb = /* @__PURE__ */ m("people-icon"), yb = /* @__PURE__ */ m("person-clipboard-icon"), bb = /* @__PURE__ */ m("person-icon"), vb = /* @__PURE__ */ m("play-icon"), Eb = /* @__PURE__ */ m("plus-icon"), kb = /* @__PURE__ */ m("radio-button-group"), $b = /* @__PURE__ */ m("refresh-icon"), wb = /* @__PURE__ */ m("reply-all-icon"), Tb = /* @__PURE__ */ m("reply-icon"), Sb = /* @__PURE__ */ m("search-icon"), Cb = /* @__PURE__ */ m("select-dropdown"), xb = /* @__PURE__ */ m("sent-icon"), Bb = /* @__PURE__ */ m("spam-icon"), Ib = /* @__PURE__ */ m("star-icon"), Rb = /* @__PURE__ */ m("stop-icon"), Ab = /* @__PURE__ */ m("textarea-component"), Mb = /* @__PURE__ */ m("time-period-selector"), Ob = /* @__PURE__ */ m("toggle-switch"), Db = /* @__PURE__ */ m("tooltip-component"), Nb = /* @__PURE__ */ m("translate-icon"), Fb = /* @__PURE__ */ m("trash-fill-icon"), Lb = /* @__PURE__ */ m("trash-icon"), Pb = /* @__PURE__ */ m("underline-icon"), _b = /* @__PURE__ */ m("warning-icon"), Ub = /* @__PURE__ */ m("zoom-icon");
function Hb() {
  const [, n] = lf((i) => i + 1, 0), e = qt(), t = qt(null), r = qt(null);
  return cf(() => {
    e.current && (t.current || e.current.getNylasMailboxConnector().then((i) => {
      i && (t.current = i, r.current = t.current.nylasAuthStore, i.nylasAuthStore.on("set", n), n());
    }));
  }, []), [e, r.current];
}
export {
  Tp as $,
  mm as A,
  v as B,
  Qp as C,
  Xp as D,
  em as E,
  Up as F,
  vm as G,
  yf as H,
  wm as I,
  tm as J,
  hm as K,
  dm as L,
  fm as M,
  Tm as N,
  Em as O,
  ym as P,
  gm as Q,
  pm as R,
  jp as S,
  Wp as T,
  wi as U,
  um as V,
  sm as W,
  cm as X,
  lm as Y,
  Hb as Z,
  Sm as _,
  Jp as a,
  Dy as a$,
  Hp as a0,
  Cm as a1,
  xm as a2,
  Bm as a3,
  Im as a4,
  Rm as a5,
  Am as a6,
  Mm as a7,
  Om as a8,
  Dm as a9,
  sy as aA,
  ly as aB,
  cy as aC,
  uy as aD,
  dy as aE,
  fy as aF,
  hy as aG,
  gy as aH,
  py as aI,
  my as aJ,
  yy as aK,
  by as aL,
  vy as aM,
  Ey as aN,
  ky as aO,
  $y as aP,
  wy as aQ,
  Ty as aR,
  Sy as aS,
  Cy as aT,
  xy as aU,
  By as aV,
  Iy as aW,
  Ry as aX,
  Ay as aY,
  My as aZ,
  Oy as a_,
  Nm as aa,
  Fm as ab,
  Lm as ac,
  Pm as ad,
  _m as ae,
  Um as af,
  Hm as ag,
  Ym as ah,
  jm as ai,
  zm as aj,
  Wm as ak,
  Gm as al,
  Km as am,
  qm as an,
  Vm as ao,
  Jm as ap,
  Zm as aq,
  Qm as ar,
  Xm as as,
  ey as at,
  ty as au,
  ny as av,
  ry as aw,
  iy as ax,
  oy as ay,
  ay as az,
  qp as b,
  Ny as b0,
  Fy as b1,
  Ly as b2,
  Py as b3,
  _y as b4,
  Uy as b5,
  Hy as b6,
  Yy as b7,
  jy as b8,
  zy as b9,
  yb as bA,
  bb as bB,
  vb as bC,
  Eb as bD,
  kb as bE,
  $b as bF,
  wb as bG,
  Tb as bH,
  Sb as bI,
  Cb as bJ,
  xb as bK,
  Bb as bL,
  Ib as bM,
  Rb as bN,
  Ab as bO,
  Mb as bP,
  Ob as bQ,
  Db as bR,
  Nb as bS,
  Fb as bT,
  Lb as bU,
  Pb as bV,
  _b as bW,
  Ub as bX,
  Wy as ba,
  Gy as bb,
  Ky as bc,
  qy as bd,
  Vy as be,
  Jy as bf,
  Zy as bg,
  Qy as bh,
  Xy as bi,
  eb as bj,
  tb as bk,
  nb as bl,
  rb as bm,
  ib as bn,
  ob as bo,
  ab as bp,
  sb as bq,
  lb as br,
  cb as bs,
  ub as bt,
  db as bu,
  fb as bv,
  hb as bw,
  gb as bx,
  pb as by,
  mb as bz,
  _p as c,
  zp as d,
  ih as e,
  rm as f,
  $f as g,
  Wr as h,
  Fh as i,
  Lr as j,
  An as k,
  km as l,
  bm as m,
  $m as n,
  or as o,
  Kp as p,
  Zp as q,
  Yp as r,
  Vp as s,
  nm as t,
  Gp as u,
  im as v,
  kp as w,
  om as x,
  am as y,
  Pr as z
};
